//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import {environment} from "../../../environments/environment";

export const medMijApiUrl = new InjectionToken<string>('medMijApiUrl');

@Injectable({
    providedIn: 'root'
})
export class BasisgegevenssetZorgClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(medMijApiUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : environment.apiMedMijUrl;
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getAdministrationAgreements(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<AdministrationAgreementModel[]> {
        let url_ = this.baseUrl + "/api/basisgegevensset-zorg/administration-agreements";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdministrationAgreements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdministrationAgreements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrationAgreementModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrationAgreementModel[]>;
        }));
    }

    protected processGetAdministrationAgreements(response: HttpResponseBase): Observable<AdministrationAgreementModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdministrationAgreementModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AdministrationAgreementModel[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getAdvanceDirectives(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<AdvanceDirectiveModel[]> {
        let url_ = this.baseUrl + "/api/basisgegevensset-zorg/advance-directives";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdvanceDirectives(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvanceDirectives(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdvanceDirectiveModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdvanceDirectiveModel[]>;
        }));
    }

    protected processGetAdvanceDirectives(response: HttpResponseBase): Observable<AdvanceDirectiveModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdvanceDirectiveModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AdvanceDirectiveModel[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getAlcoholUses(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<AlcoholUseModel[]> {
        let url_ = this.baseUrl + "/api/basisgegevensset-zorg/alcohol-uses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlcoholUses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlcoholUses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlcoholUseModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlcoholUseModel[]>;
        }));
    }

    protected processGetAlcoholUses(response: HttpResponseBase): Observable<AlcoholUseModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AlcoholUseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AlcoholUseModel[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getAlerts(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<AlertModel[]> {
        let url_ = this.baseUrl + "/api/basisgegevensset-zorg/alerts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlerts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlerts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlertModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlertModel[]>;
        }));
    }

    protected processGetAlerts(response: HttpResponseBase): Observable<AlertModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AlertModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AlertModel[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getAllergies(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<AllergyIntoleranceModel[]> {
        let url_ = this.baseUrl + "/api/basisgegevensset-zorg/allergies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllergies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllergies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllergyIntoleranceModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllergyIntoleranceModel[]>;
        }));
    }

    protected processGetAllergies(response: HttpResponseBase): Observable<AllergyIntoleranceModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AllergyIntoleranceModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AllergyIntoleranceModel[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getDrugUses(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<DrugUseModel[]> {
        let url_ = this.baseUrl + "/api/basisgegevensset-zorg/drug-uses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDrugUses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDrugUses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DrugUseModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DrugUseModel[]>;
        }));
    }

    protected processGetDrugUses(response: HttpResponseBase): Observable<DrugUseModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DrugUseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DrugUseModel[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getEncounters(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<EncounterModel[]> {
        let url_ = this.baseUrl + "/api/basisgegevensset-zorg/encounters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEncounters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEncounters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EncounterModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EncounterModel[]>;
        }));
    }

    protected processGetEncounters(response: HttpResponseBase): Observable<EncounterModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EncounterModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EncounterModel[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getLastBloodPressure(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<BloodPressureModel> {
        let url_ = this.baseUrl + "/api/basisgegevensset-zorg/last-blood-pressure";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastBloodPressure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastBloodPressure(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BloodPressureModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BloodPressureModel>;
        }));
    }

    protected processGetLastBloodPressure(response: HttpResponseBase): Observable<BloodPressureModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BloodPressureModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BloodPressureModel>(null as any);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getLastBodyHeight(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<BodyHeightModel> {
        let url_ = this.baseUrl + "/api/basisgegevensset-zorg/last-body-height";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastBodyHeight(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastBodyHeight(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BodyHeightModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BodyHeightModel>;
        }));
    }

    protected processGetLastBodyHeight(response: HttpResponseBase): Observable<BodyHeightModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BodyHeightModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BodyHeightModel>(null as any);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getLastBodyWeight(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<BodyWeightModel> {
        let url_ = this.baseUrl + "/api/basisgegevensset-zorg/last-body-weight";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastBodyWeight(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastBodyWeight(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BodyWeightModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BodyWeightModel>;
        }));
    }

    protected processGetLastBodyWeight(response: HttpResponseBase): Observable<BodyWeightModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BodyWeightModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BodyWeightModel>(null as any);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getLastFunctionalAndMentalStatus(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<LastFunctionalAndMentalStatusModel> {
        let url_ = this.baseUrl + "/api/basisgegevensset-zorg/last-functional-and-mental-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastFunctionalAndMentalStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastFunctionalAndMentalStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LastFunctionalAndMentalStatusModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LastFunctionalAndMentalStatusModel>;
        }));
    }

    protected processGetLastFunctionalAndMentalStatus(response: HttpResponseBase): Observable<LastFunctionalAndMentalStatusModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LastFunctionalAndMentalStatusModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LastFunctionalAndMentalStatusModel>(null as any);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getLastLaboratoryTestResult(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<ZibLaboratoryTestResult> {
        let url_ = this.baseUrl + "/api/basisgegevensset-zorg/last-laboratory-test-result";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastLaboratoryTestResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastLaboratoryTestResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZibLaboratoryTestResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZibLaboratoryTestResult>;
        }));
    }

    protected processGetLastLaboratoryTestResult(response: HttpResponseBase): Observable<ZibLaboratoryTestResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZibLaboratoryTestResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ZibLaboratoryTestResult>(null as any);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getLastLivingSituation(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<LivingSituationModel> {
        let url_ = this.baseUrl + "/api/basisgegevensset-zorg/last-living-situation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastLivingSituation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastLivingSituation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LivingSituationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LivingSituationModel>;
        }));
    }

    protected processGetLastLivingSituation(response: HttpResponseBase): Observable<LivingSituationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LivingSituationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LivingSituationModel>(null as any);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getMedicalDeviceRequests(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<MedicalDeviceRequestModel[]> {
        let url_ = this.baseUrl + "/api/basisgegevensset-zorg/medical-device-requests";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicalDeviceRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicalDeviceRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MedicalDeviceRequestModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MedicalDeviceRequestModel[]>;
        }));
    }

    protected processGetMedicalDeviceRequests(response: HttpResponseBase): Observable<MedicalDeviceRequestModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MedicalDeviceRequestModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalDeviceRequestModel[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getMedicalDeviceUses(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<MedicalDeviceUseModel[]> {
        let url_ = this.baseUrl + "/api/basisgegevensset-zorg/medical-device-uses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicalDeviceUses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicalDeviceUses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MedicalDeviceUseModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MedicalDeviceUseModel[]>;
        }));
    }

    protected processGetMedicalDeviceUses(response: HttpResponseBase): Observable<MedicalDeviceUseModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MedicalDeviceUseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalDeviceUseModel[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getMedicationAgreements(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<MedicationAgreementModel[]> {
        let url_ = this.baseUrl + "/api/basisgegevensset-zorg/medication-agreements";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicationAgreements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicationAgreements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MedicationAgreementModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MedicationAgreementModel[]>;
        }));
    }

    protected processGetMedicationAgreements(response: HttpResponseBase): Observable<MedicationAgreementModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MedicationAgreementModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicationAgreementModel[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getMedicationUses(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<MedicationUseModel[]> {
        let url_ = this.baseUrl + "/api/basisgegevensset-zorg/medication-uses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicationUses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicationUses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MedicationUseModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MedicationUseModel[]>;
        }));
    }

    protected processGetMedicationUses(response: HttpResponseBase): Observable<MedicationUseModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MedicationUseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicationUseModel[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getNutritionAdvices(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<NutritionAdviceModel[]> {
        let url_ = this.baseUrl + "/api/basisgegevensset-zorg/nutrition-advices";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNutritionAdvices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNutritionAdvices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NutritionAdviceModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NutritionAdviceModel[]>;
        }));
    }

    protected processGetNutritionAdvices(response: HttpResponseBase): Observable<NutritionAdviceModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NutritionAdviceModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NutritionAdviceModel[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getPatient(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<PatientModel> {
        let url_ = this.baseUrl + "/api/basisgegevensset-zorg/patient";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientModel>;
        }));
    }

    protected processGetPatient(response: HttpResponseBase): Observable<PatientModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PatientModel>(null as any);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getPayers(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<PayerModel[]> {
        let url_ = this.baseUrl + "/api/basisgegevensset-zorg/payers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayerModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayerModel[]>;
        }));
    }

    protected processGetPayers(response: HttpResponseBase): Observable<PayerModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PayerModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PayerModel[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getProblems(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<ProblemModel[]> {
        let url_ = this.baseUrl + "/api/basisgegevensset-zorg/problems";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProblems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProblems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProblemModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProblemModel[]>;
        }));
    }

    protected processGetProblems(response: HttpResponseBase): Observable<ProblemModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProblemModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProblemModel[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getProcedureRequests(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<ProcedureRequestModel[]> {
        let url_ = this.baseUrl + "/api/basisgegevensset-zorg/procedure-requests";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProcedureRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProcedureRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcedureRequestModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcedureRequestModel[]>;
        }));
    }

    protected processGetProcedureRequests(response: HttpResponseBase): Observable<ProcedureRequestModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProcedureRequestModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProcedureRequestModel[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getProcedures(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<ProcedureModel[]> {
        let url_ = this.baseUrl + "/api/basisgegevensset-zorg/procedures";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProcedures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProcedures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcedureModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcedureModel[]>;
        }));
    }

    protected processGetProcedures(response: HttpResponseBase): Observable<ProcedureModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProcedureModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProcedureModel[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getTobaccoUses(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<TobaccoUseModel[]> {
        let url_ = this.baseUrl + "/api/basisgegevensset-zorg/tobacco-uses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTobaccoUses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTobaccoUses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TobaccoUseModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TobaccoUseModel[]>;
        }));
    }

    protected processGetTobaccoUses(response: HttpResponseBase): Observable<TobaccoUseModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TobaccoUseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TobaccoUseModel[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getTreatmentDirectives(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<TreatmentDirectiveModel[]> {
        let url_ = this.baseUrl + "/api/basisgegevensset-zorg/treatment-directives";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreatmentDirectives(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreatmentDirectives(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TreatmentDirectiveModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TreatmentDirectiveModel[]>;
        }));
    }

    protected processGetTreatmentDirectives(response: HttpResponseBase): Observable<TreatmentDirectiveModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreatmentDirectiveModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreatmentDirectiveModel[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getUpcomingAppointments(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<AppointmentModel[]> {
        let url_ = this.baseUrl + "/api/basisgegevensset-zorg/upcoming-appointments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUpcomingAppointments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUpcomingAppointments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppointmentModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppointmentModel[]>;
        }));
    }

    protected processGetUpcomingAppointments(response: HttpResponseBase): Observable<AppointmentModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppointmentModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppointmentModel[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getVaccinationRecommendations(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<VaccinationRecommendationModel[]> {
        let url_ = this.baseUrl + "/api/basisgegevensset-zorg/vaccination-recommendations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVaccinationRecommendations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVaccinationRecommendations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VaccinationRecommendationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VaccinationRecommendationModel[]>;
        }));
    }

    protected processGetVaccinationRecommendations(response: HttpResponseBase): Observable<VaccinationRecommendationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VaccinationRecommendationModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VaccinationRecommendationModel[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getVaccinations(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<VaccinationModel[]> {
        let url_ = this.baseUrl + "/api/basisgegevensset-zorg/vaccinations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVaccinations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVaccinations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VaccinationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VaccinationModel[]>;
        }));
    }

    protected processGetVaccinations(response: HttpResponseBase): Observable<VaccinationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VaccinationModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VaccinationModel[]>([]);
    }
}

@Injectable({
    providedIn: 'root'
})
export class GeboortezorgGegevensClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(medMijApiUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : environment.apiMedMijUrl;
    }

    /**
     * @param maternalRecordId (optional)
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getMaternalRecordDetails(maternalRecordId: string | null | undefined, medmij_care_provider_name: string, medmij_data_service_id: string): Observable<MaternalRecordDetailsViewModel> {
        let url_ = this.baseUrl + "/api/geboortezorg-gegevens/maternal-record-details?";
        if (maternalRecordId !== undefined && maternalRecordId !== null)
            url_ += "maternalRecordId=" + encodeURIComponent("" + maternalRecordId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMaternalRecordDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaternalRecordDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaternalRecordDetailsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaternalRecordDetailsViewModel>;
        }));
    }

    protected processGetMaternalRecordDetails(response: HttpResponseBase): Observable<MaternalRecordDetailsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MaternalRecordDetailsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaternalRecordDetailsViewModel>(null as any);
    }

    /**
     * @param patientId (optional)
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getMaternalRecords(patientId: string | null | undefined, medmij_care_provider_name: string, medmij_data_service_id: string): Observable<BcMaternalRecord[]> {
        let url_ = this.baseUrl + "/api/geboortezorg-gegevens/maternal-records?";
        if (patientId !== undefined && patientId !== null)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMaternalRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaternalRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BcMaternalRecord[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BcMaternalRecord[]>;
        }));
    }

    protected processGetMaternalRecords(response: HttpResponseBase): Observable<BcMaternalRecord[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BcMaternalRecord.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BcMaternalRecord[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getWoman(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<BcWoman> {
        let url_ = this.baseUrl + "/api/geboortezorg-gegevens/woman";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoman(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoman(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BcWoman>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BcWoman>;
        }));
    }

    protected processGetWoman(response: HttpResponseBase): Observable<BcWoman> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BcWoman.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BcWoman>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class GeestelijkeGezondheidszorgClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(medMijApiUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : environment.apiMedMijUrl;
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getAdvanceDirectives(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<AdvanceDirectiveModel[]> {
        let url_ = this.baseUrl + "/api/geestelijke-gezondheidszorg/advance-directives";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdvanceDirectives(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvanceDirectives(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdvanceDirectiveModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdvanceDirectiveModel[]>;
        }));
    }

    protected processGetAdvanceDirectives(response: HttpResponseBase): Observable<AdvanceDirectiveModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdvanceDirectiveModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AdvanceDirectiveModel[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getAlcoholUses(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<AlcoholUseModel[]> {
        let url_ = this.baseUrl + "/api/geestelijke-gezondheidszorg/alcohol-uses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlcoholUses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlcoholUses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlcoholUseModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlcoholUseModel[]>;
        }));
    }

    protected processGetAlcoholUses(response: HttpResponseBase): Observable<AlcoholUseModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AlcoholUseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AlcoholUseModel[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getCareTeam(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<CareTeamModel> {
        let url_ = this.baseUrl + "/api/geestelijke-gezondheidszorg/care-team";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCareTeam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCareTeam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CareTeamModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CareTeamModel>;
        }));
    }

    protected processGetCareTeam(response: HttpResponseBase): Observable<CareTeamModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CareTeamModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CareTeamModel>(null as any);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getDrugUses(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<DrugUseModel[]> {
        let url_ = this.baseUrl + "/api/geestelijke-gezondheidszorg/drug-uses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDrugUses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDrugUses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DrugUseModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DrugUseModel[]>;
        }));
    }

    protected processGetDrugUses(response: HttpResponseBase): Observable<DrugUseModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DrugUseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DrugUseModel[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getFamilySituations(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<FamilySituationModel[]> {
        let url_ = this.baseUrl + "/api/geestelijke-gezondheidszorg/family-situations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFamilySituations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFamilySituations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FamilySituationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FamilySituationModel[]>;
        }));
    }

    protected processGetFamilySituations(response: HttpResponseBase): Observable<FamilySituationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FamilySituationModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FamilySituationModel[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getFamilySituationsChild(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<FamilySituationChildModel[]> {
        let url_ = this.baseUrl + "/api/geestelijke-gezondheidszorg/family-situations-child";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFamilySituationsChild(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFamilySituationsChild(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FamilySituationChildModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FamilySituationChildModel[]>;
        }));
    }

    protected processGetFamilySituationsChild(response: HttpResponseBase): Observable<FamilySituationChildModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FamilySituationChildModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FamilySituationChildModel[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getFunctionalAndMentalStatuses(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<FunctionalAndMentalStatusesModel> {
        let url_ = this.baseUrl + "/api/geestelijke-gezondheidszorg/functional-and-mental-statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFunctionalAndMentalStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFunctionalAndMentalStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FunctionalAndMentalStatusesModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FunctionalAndMentalStatusesModel>;
        }));
    }

    protected processGetFunctionalAndMentalStatuses(response: HttpResponseBase): Observable<FunctionalAndMentalStatusesModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FunctionalAndMentalStatusesModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FunctionalAndMentalStatusesModel>(null as any);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getGeneralMeasurements(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<GeneralMeasurementModel[]> {
        let url_ = this.baseUrl + "/api/geestelijke-gezondheidszorg/general-measurements";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeneralMeasurements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralMeasurements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralMeasurementModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralMeasurementModel[]>;
        }));
    }

    protected processGetGeneralMeasurements(response: HttpResponseBase): Observable<GeneralMeasurementModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralMeasurementModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralMeasurementModel[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getHelpFromOthers(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<HelpFromOthersModel[]> {
        let url_ = this.baseUrl + "/api/geestelijke-gezondheidszorg/help-from-others";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHelpFromOthers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHelpFromOthers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HelpFromOthersModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HelpFromOthersModel[]>;
        }));
    }

    protected processGetHelpFromOthers(response: HttpResponseBase): Observable<HelpFromOthersModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HelpFromOthersModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HelpFromOthersModel[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getLastLaboratoryTestResult(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<ZibLaboratoryTestResult> {
        let url_ = this.baseUrl + "/api/geestelijke-gezondheidszorg/last-laboratory-test-result";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastLaboratoryTestResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastLaboratoryTestResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZibLaboratoryTestResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZibLaboratoryTestResult>;
        }));
    }

    protected processGetLastLaboratoryTestResult(response: HttpResponseBase): Observable<ZibLaboratoryTestResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZibLaboratoryTestResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ZibLaboratoryTestResult>(null as any);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getLivingSituations(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<LivingSituationModel[]> {
        let url_ = this.baseUrl + "/api/geestelijke-gezondheidszorg/living-situations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLivingSituations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLivingSituations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LivingSituationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LivingSituationModel[]>;
        }));
    }

    protected processGetLivingSituations(response: HttpResponseBase): Observable<LivingSituationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LivingSituationModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LivingSituationModel[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getParticipationInSociety(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<ParticipationInSocietyModel[]> {
        let url_ = this.baseUrl + "/api/geestelijke-gezondheidszorg/participation-in-society";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticipationInSociety(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticipationInSociety(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParticipationInSocietyModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParticipationInSocietyModel[]>;
        }));
    }

    protected processGetParticipationInSociety(response: HttpResponseBase): Observable<ParticipationInSocietyModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParticipationInSocietyModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ParticipationInSocietyModel[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getPatient(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<PatientModel> {
        let url_ = this.baseUrl + "/api/geestelijke-gezondheidszorg/patient";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientModel>;
        }));
    }

    protected processGetPatient(response: HttpResponseBase): Observable<PatientModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PatientModel>(null as any);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getPayers(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<PayerModel[]> {
        let url_ = this.baseUrl + "/api/geestelijke-gezondheidszorg/payers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayerModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayerModel[]>;
        }));
    }

    protected processGetPayers(response: HttpResponseBase): Observable<PayerModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PayerModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PayerModel[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getProblems(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<ProblemModel[]> {
        let url_ = this.baseUrl + "/api/geestelijke-gezondheidszorg/problems";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProblems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProblems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProblemModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProblemModel[]>;
        }));
    }

    protected processGetProblems(response: HttpResponseBase): Observable<ProblemModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProblemModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProblemModel[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getProcedures(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<GroupedProceduresModel> {
        let url_ = this.baseUrl + "/api/geestelijke-gezondheidszorg/procedures";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProcedures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProcedures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GroupedProceduresModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GroupedProceduresModel>;
        }));
    }

    protected processGetProcedures(response: HttpResponseBase): Observable<GroupedProceduresModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupedProceduresModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GroupedProceduresModel>(null as any);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getTextResults(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<TextResultModel[]> {
        let url_ = this.baseUrl + "/api/geestelijke-gezondheidszorg/text-results";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTextResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTextResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TextResultModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TextResultModel[]>;
        }));
    }

    protected processGetTextResults(response: HttpResponseBase): Observable<TextResultModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TextResultModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TextResultModel[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getTobaccoUses(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<TobaccoUseModel[]> {
        let url_ = this.baseUrl + "/api/geestelijke-gezondheidszorg/tobacco-uses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTobaccoUses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTobaccoUses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TobaccoUseModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TobaccoUseModel[]>;
        }));
    }

    protected processGetTobaccoUses(response: HttpResponseBase): Observable<TobaccoUseModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TobaccoUseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TobaccoUseModel[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getTreatmentDirectives(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<TreatmentDirectiveModel[]> {
        let url_ = this.baseUrl + "/api/geestelijke-gezondheidszorg/treatment-directives";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreatmentDirectives(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreatmentDirectives(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TreatmentDirectiveModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TreatmentDirectiveModel[]>;
        }));
    }

    protected processGetTreatmentDirectives(response: HttpResponseBase): Observable<TreatmentDirectiveModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreatmentDirectiveModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreatmentDirectiveModel[]>([]);
    }
}

@Injectable({
    providedIn: 'root'
})
export class HuisartsgegevensClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(medMijApiUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : environment.apiMedMijUrl;
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getAlerts(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<AlertModel[]> {
        let url_ = this.baseUrl + "/api/huisartsgegevens/alerts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlerts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlerts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlertModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlertModel[]>;
        }));
    }

    protected processGetAlerts(response: HttpResponseBase): Observable<AlertModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AlertModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AlertModel[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getAllergies(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<AllergyIntoleranceModel[]> {
        let url_ = this.baseUrl + "/api/huisartsgegevens/allergies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllergies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllergies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllergyIntoleranceModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllergyIntoleranceModel[]>;
        }));
    }

    protected processGetAllergies(response: HttpResponseBase): Observable<AllergyIntoleranceModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AllergyIntoleranceModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AllergyIntoleranceModel[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getEncounterReports(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<EncounterReportModel[]> {
        let url_ = this.baseUrl + "/api/huisartsgegevens/encounter-reports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEncounterReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEncounterReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EncounterReportModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EncounterReportModel[]>;
        }));
    }

    protected processGetEncounterReports(response: HttpResponseBase): Observable<EncounterReportModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EncounterReportModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EncounterReportModel[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getEncounters(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<EncounterModel[]> {
        let url_ = this.baseUrl + "/api/huisartsgegevens/encounters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEncounters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEncounters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EncounterModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EncounterModel[]>;
        }));
    }

    protected processGetEncounters(response: HttpResponseBase): Observable<EncounterModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EncounterModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EncounterModel[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getEpisodesOfCare(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<NlCoreEpisodeOfCare[]> {
        let url_ = this.baseUrl + "/api/huisartsgegevens/episodes-of-care";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEpisodesOfCare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEpisodesOfCare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NlCoreEpisodeOfCare[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NlCoreEpisodeOfCare[]>;
        }));
    }

    protected processGetEpisodesOfCare(response: HttpResponseBase): Observable<NlCoreEpisodeOfCare[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NlCoreEpisodeOfCare.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NlCoreEpisodeOfCare[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getLabResults(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<ObservationBaseModel[]> {
        let url_ = this.baseUrl + "/api/huisartsgegevens/lab-results";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLabResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLabResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationBaseModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationBaseModel[]>;
        }));
    }

    protected processGetLabResults(response: HttpResponseBase): Observable<ObservationBaseModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationBaseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ObservationBaseModel[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getMedicationAgreements(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<MedicationAgreementModel[]> {
        let url_ = this.baseUrl + "/api/huisartsgegevens/medication-agreements";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicationAgreements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicationAgreements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MedicationAgreementModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MedicationAgreementModel[]>;
        }));
    }

    protected processGetMedicationAgreements(response: HttpResponseBase): Observable<MedicationAgreementModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MedicationAgreementModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicationAgreementModel[]>([]);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getPatient(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<PatientModel> {
        let url_ = this.baseUrl + "/api/huisartsgegevens/patient";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientModel>;
        }));
    }

    protected processGetPatient(response: HttpResponseBase): Observable<PatientModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PatientModel>(null as any);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    touchstoneGetEncounterReports(medmij_care_provider_name: string, medmij_data_service_id: string): Observable<EncounterReportModel[]> {
        let url_ = this.baseUrl + "/api/huisartsgegevens/touchstone/encounter-reports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTouchstoneGetEncounterReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTouchstoneGetEncounterReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EncounterReportModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EncounterReportModel[]>;
        }));
    }

    protected processTouchstoneGetEncounterReports(response: HttpResponseBase): Observable<EncounterReportModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EncounterReportModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EncounterReportModel[]>([]);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LabuitwisselingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(medMijApiUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : environment.apiMedMijUrl;
    }

    /**
     * @param startDate (optional)
     * @param endDate (optional)
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getDiagnosticReports(startDate: Date | null | undefined, endDate: Date | null | undefined, medmij_care_provider_name: string, medmij_data_service_id: string): Observable<LaboratoryTestResultDiagnosticReportModel[]> {
        let url_ = this.baseUrl + "/api/labuitwisseling/diagnostic-reports?";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiagnosticReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiagnosticReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LaboratoryTestResultDiagnosticReportModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LaboratoryTestResultDiagnosticReportModel[]>;
        }));
    }

    protected processGetDiagnosticReports(response: HttpResponseBase): Observable<LaboratoryTestResultDiagnosticReportModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LaboratoryTestResultDiagnosticReportModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LaboratoryTestResultDiagnosticReportModel[]>([]);
    }

    /**
     * @param startDate (optional)
     * @param endDate (optional)
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getLaboratoryTestResults(startDate: Date | null | undefined, endDate: Date | null | undefined, medmij_care_provider_name: string, medmij_data_service_id: string): Observable<ZibLaboratoryTestResult[]> {
        let url_ = this.baseUrl + "/api/labuitwisseling/laboratory-test-results?";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLaboratoryTestResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLaboratoryTestResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZibLaboratoryTestResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZibLaboratoryTestResult[]>;
        }));
    }

    protected processGetLaboratoryTestResults(response: HttpResponseBase): Observable<ZibLaboratoryTestResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ZibLaboratoryTestResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ZibLaboratoryTestResult[]>([]);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PdfaClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(medMijApiUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : environment.apiMedMijUrl;
    }

    /**
     * @param creationDateStart (optional)
     * @param creationDateEnd (optional)
     * @param status (optional)
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    searchDocumentManifests(creationDateStart: Date | null | undefined, creationDateEnd: Date | null | undefined, status: DocumentReferenceStatus | null | undefined, medmij_care_provider_name: string, medmij_data_service_id: string): Observable<DocumentManifestSearchResultModel> {
        let url_ = this.baseUrl + "/api/pdfa/search-document-manifests?";
        if (creationDateStart !== undefined && creationDateStart !== null)
            url_ += "CreationDateStart=" + encodeURIComponent(creationDateStart ? "" + creationDateStart.toISOString() : "") + "&";
        if (creationDateEnd !== undefined && creationDateEnd !== null)
            url_ += "CreationDateEnd=" + encodeURIComponent(creationDateEnd ? "" + creationDateEnd.toISOString() : "") + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchDocumentManifests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchDocumentManifests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentManifestSearchResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentManifestSearchResultModel>;
        }));
    }

    protected processSearchDocumentManifests(response: HttpResponseBase): Observable<DocumentManifestSearchResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentManifestSearchResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentManifestSearchResultModel>(null as any);
    }

    /**
     * @param creationDateStart (optional)
     * @param creationDateEnd (optional)
     * @param status (optional)
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    searchDocumentReferences(creationDateStart: Date | null | undefined, creationDateEnd: Date | null | undefined, status: DocumentReferenceStatus | null | undefined, medmij_care_provider_name: string, medmij_data_service_id: string): Observable<DocumentReferenceSearchResultModel> {
        let url_ = this.baseUrl + "/api/pdfa/search-document-references?";
        if (creationDateStart !== undefined && creationDateStart !== null)
            url_ += "CreationDateStart=" + encodeURIComponent(creationDateStart ? "" + creationDateStart.toISOString() : "") + "&";
        if (creationDateEnd !== undefined && creationDateEnd !== null)
            url_ += "CreationDateEnd=" + encodeURIComponent(creationDateEnd ? "" + creationDateEnd.toISOString() : "") + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchDocumentReferences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchDocumentReferences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentReferenceSearchResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentReferenceSearchResultModel>;
        }));
    }

    protected processSearchDocumentReferences(response: HttpResponseBase): Observable<DocumentReferenceSearchResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentReferenceSearchResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentReferenceSearchResultModel>(null as any);
    }

    /**
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    sendDocument(medmij_care_provider_name: string, medmij_data_service_id: string, sendModel: SendPdfaDocumentSetModel): Observable<void> {
        let url_ = this.baseUrl + "/api/pdfa/send-document";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sendModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ResourceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(medMijApiUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : environment.apiMedMijUrl;
    }

    /**
     * @param resourceUri (optional)
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    download(resourceUri: string | null | undefined, medmij_care_provider_name: string, medmij_data_service_id: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/resource/download?";
        if (resourceUri !== undefined && resourceUri !== null)
            url_ += "resourceUri=" + encodeURIComponent("" + resourceUri) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownload(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    /**
     * @param resourceUri (optional)
     * @param types (optional)
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    get(resourceUri: string | null | undefined, types: ResourceModelType[] | null | undefined, medmij_care_provider_name: string, medmij_data_service_id: string): Observable<ResourceModel> {
        let url_ = this.baseUrl + "/api/resource?";
        if (resourceUri !== undefined && resourceUri !== null)
            url_ += "resourceUri=" + encodeURIComponent("" + resourceUri) + "&";
        if (types !== undefined && types !== null)
            types && types.forEach(item => { url_ += "types=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResourceModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResourceModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ResourceModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResourceModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResourceModel>(null as any);
    }

    /**
     * @param resourceUri (optional)
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getFromDossier(resourceUri: string | null | undefined, medmij_care_provider_name: string, medmij_data_service_id: string): Observable<ResourceModel> {
        let url_ = this.baseUrl + "/api/resource/dossier?";
        if (resourceUri !== undefined && resourceUri !== null)
            url_ += "resourceUri=" + encodeURIComponent("" + resourceUri) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFromDossier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFromDossier(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResourceModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResourceModel>;
        }));
    }

    protected processGetFromDossier(response: HttpResponseBase): Observable<ResourceModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResourceModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResourceModel>(null as any);
    }

    /**
     * @param hcim (optional)
     * @param resourceId (optional)
     * @param medmij_care_provider_name The selected care provider name
     * @param medmij_data_service_id The selected data service id
     */
    getPatientDossierResource(providerName: string, dataServiceId: string, resourceType: string, hcim: string | null | undefined, resourceId: string | null | undefined, medmij_care_provider_name: string, medmij_data_service_id: string): Observable<ResourceModel[]> {
        let url_ = this.baseUrl + "/api/resource/dossier/{providerName}/{dataServiceId}/{resourceType}?";
        if (providerName === undefined || providerName === null)
            throw new Error("The parameter 'providerName' must be defined.");
        url_ = url_.replace("{providerName}", encodeURIComponent("" + providerName));
        if (dataServiceId === undefined || dataServiceId === null)
            throw new Error("The parameter 'dataServiceId' must be defined.");
        url_ = url_.replace("{dataServiceId}", encodeURIComponent("" + dataServiceId));
        if (resourceType === undefined || resourceType === null)
            throw new Error("The parameter 'resourceType' must be defined.");
        url_ = url_.replace("{resourceType}", encodeURIComponent("" + resourceType));
        if (hcim !== undefined && hcim !== null)
            url_ += "hcim=" + encodeURIComponent("" + hcim) + "&";
        if (resourceId !== undefined && resourceId !== null)
            url_ += "resourceId=" + encodeURIComponent("" + resourceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "medmij-care-provider-name": medmij_care_provider_name !== undefined && medmij_care_provider_name !== null ? "" + medmij_care_provider_name : "",
                "medmij-data-service-id": medmij_data_service_id !== undefined && medmij_data_service_id !== null ? "" + medmij_data_service_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientDossierResource(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientDossierResource(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResourceModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResourceModel[]>;
        }));
    }

    protected processGetPatientDossierResource(response: HttpResponseBase): Observable<ResourceModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResourceModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResourceModel[]>([]);
    }
}

export class ResourceModel implements IResourceModel {
    id?: string | undefined;
    resourceType?: ResourceModelType;
    retrievalDateTime?: Date;
    resourceSource?: string | undefined;

    protected _discriminator: string;

    constructor(data?: IResourceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "ResourceModel";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.resourceType = _data["resourceType"];
            this.retrievalDateTime = _data["retrievalDateTime"] ? new Date(_data["retrievalDateTime"].toString()) : <any>undefined;
            this.resourceSource = _data["resourceSource"];
        }
    }

    static fromJS(data: any): ResourceModel {
        data = typeof data === 'object' ? data : {};
        if (data["resourceTypeDiscriminator"] === "AdministrationAgreementModel") {
            let result = new AdministrationAgreementModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "AllergyIntoleranceModel") {
            let result = new AllergyIntoleranceModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "AppointmentModel") {
            let result = new AppointmentModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "NlCorePractitioner") {
            let result = new NlCorePractitioner();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "CareTeamModel") {
            let result = new CareTeamModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "TextResultModel") {
            let result = new TextResultModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "EncounterModel") {
            let result = new EncounterModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "NlCoreEpisodeOfCare") {
            let result = new NlCoreEpisodeOfCare();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "CarePlanModel") {
            let result = new CarePlanModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "HelpFromOthersModel") {
            let result = new HelpFromOthersModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "LocationModel") {
            let result = new LocationModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "MedicationAdministrationModel") {
            let result = new MedicationAdministrationModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "MedicalDeviceProductModel") {
            let result = new MedicalDeviceProductModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "MedicalDeviceUseModel") {
            let result = new MedicalDeviceUseModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "ObservationBaseModel") {
            let result = new ObservationBaseModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BloodGlucoseModel") {
            let result = new BloodGlucoseModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BloodPressureModel") {
            let result = new BloodPressureModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BodyHeightModel") {
            let result = new BodyHeightModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BodyTemperatureModel") {
            let result = new BodyTemperatureModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BodyWeightModel") {
            let result = new BodyWeightModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "FamilySituationChildModel") {
            let result = new FamilySituationChildModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "FamilySituationModel") {
            let result = new FamilySituationModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "GeneralMeasurementModel") {
            let result = new GeneralMeasurementModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "HeartRateModel") {
            let result = new HeartRateModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "ZibLaboratoryTestResult") {
            let result = new ZibLaboratoryTestResult();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "OxygenSaturationModel") {
            let result = new OxygenSaturationModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "PulseRateModel") {
            let result = new PulseRateModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "OrganizationModel") {
            let result = new OrganizationModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "PharmaceuticalProductModel") {
            let result = new PharmaceuticalProductModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "PatientModel") {
            let result = new PatientModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "PractitionerRoleModel") {
            let result = new PractitionerRoleModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "ProblemModel") {
            let result = new ProblemModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "RelatedPersonModel") {
            let result = new RelatedPersonModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "SpecimenModel") {
            let result = new SpecimenModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "VaccinationModel") {
            let result = new VaccinationModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "NlCoreObservation") {
            let result = new NlCoreObservation();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BcBirth") {
            let result = new BcBirth();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BcBirthObservation") {
            let result = new BcBirthObservation();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BcBirthObservationOnsetOfPushing") {
            let result = new BcBirthObservationOnsetOfPushing();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BcBirthObservationPartus") {
            let result = new BcBirthObservationPartus();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BcBirthWeight") {
            let result = new BcBirthWeight();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BcChild") {
            let result = new BcChild();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BcChildBirthAssistance") {
            let result = new BcChildBirthAssistance();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BcDeliveryObservation") {
            let result = new BcDeliveryObservation();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BcDeliveryObservationBloodloss") {
            let result = new BcDeliveryObservationBloodloss();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BcDeliveryObservationOnsetLaborFirstStage") {
            let result = new BcDeliveryObservationOnsetLaborFirstStage();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BcDeliveryObservationPerineumCondition") {
            let result = new BcDeliveryObservationPerineumCondition();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BcDeliveryProcedure") {
            let result = new BcDeliveryProcedure();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BcMaternalRecord") {
            let result = new BcMaternalRecord();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BcMotherOf") {
            let result = new BcMotherOf();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BcObstetricProcedure") {
            let result = new BcObstetricProcedure();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BcPregnancyObservation") {
            let result = new BcPregnancyObservation();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BcPregnancyObservationTerminationDate") {
            let result = new BcPregnancyObservationTerminationDate();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BcPregnancyObservationTerminationType") {
            let result = new BcPregnancyObservationTerminationType();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BcWoman") {
            let result = new BcWoman();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "ZibApgarScore") {
            let result = new ZibApgarScore();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "ZibPregnancy") {
            let result = new ZibPregnancy();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "ZibPregnancyGravidity") {
            let result = new ZibPregnancyGravidity();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "ZibPregnancyParity") {
            let result = new ZibPregnancyParity();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "ZibPregnancyTermDate") {
            let result = new ZibPregnancyTermDate();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "GoalModel") {
            let result = new GoalModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "NutritionAdviceModel") {
            let result = new NutritionAdviceModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "AdvanceDirectiveModel") {
            let result = new AdvanceDirectiveModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "AlcoholUseModel") {
            let result = new AlcoholUseModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "AlertModel") {
            let result = new AlertModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "DrugUseModel") {
            let result = new DrugUseModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "FunctionalOrMentalStatusModel") {
            let result = new FunctionalOrMentalStatusModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "LivingSituationModel") {
            let result = new LivingSituationModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "MedicalDeviceRequestModel") {
            let result = new MedicalDeviceRequestModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "MedicationAgreementModel") {
            let result = new MedicationAgreementModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "MedicationUseModel") {
            let result = new MedicationUseModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "PayerModel") {
            let result = new PayerModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "ProcedureRequestModel") {
            let result = new ProcedureRequestModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "ProcedureBaseModel") {
            let result = new ProcedureBaseModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "FreedomRestrictingMeasureModel") {
            let result = new FreedomRestrictingMeasureModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "ProcedureModel") {
            let result = new ProcedureModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "TobaccoUseModel") {
            let result = new TobaccoUseModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "TreatmentDirectiveModel") {
            let result = new TreatmentDirectiveModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "VaccinationRecommendationModel") {
            let result = new VaccinationRecommendationModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "ParticipationInSocietyModel") {
            let result = new ParticipationInSocietyModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "EncounterReportModel") {
            let result = new EncounterReportModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "LaboratoryTestResultDiagnosticReportModel") {
            let result = new LaboratoryTestResultDiagnosticReportModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "DocumentManifestModel") {
            let result = new DocumentManifestModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "DocumentReferenceModel") {
            let result = new DocumentReferenceModel();
            result.init(data);
            return result;
        }
        let result = new ResourceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resourceTypeDiscriminator"] = this._discriminator;
        data["id"] = this.id;
        data["resourceType"] = this.resourceType;
        data["retrievalDateTime"] = this.retrievalDateTime ? this.retrievalDateTime.toISOString() : <any>undefined;
        data["resourceSource"] = this.resourceSource;
        return data;
    }
}

export interface IResourceModel {
    id?: string | undefined;
    resourceType?: ResourceModelType;
    retrievalDateTime?: Date;
    resourceSource?: string | undefined;
}

export class AdministrationAgreementModel extends ResourceModel implements IAdministrationAgreementModel {
    additionalInformation?: AdministrationAgreementAdditionalInformation | undefined;
    agreementReason?: string | undefined;
    authoredOn?: string | undefined;
    authorizingPrescriptions?: ReferenceModel[] | undefined;
    category?: CategoryModel | undefined;
    comments?: CommentModel[] | undefined;
    context?: ReferenceModel | undefined;
    copyIndicator?: boolean | undefined;
    identifiers?: IdentifierModel[] | undefined;
    medication?: ReferenceModel | undefined;
    periodOfUse?: PeriodModel | undefined;
    repeatPeriodCyclicalSchedule?: DurationModel | undefined;
    status?: MedicationDispenseStatus;
    subject?: ReferenceModel | undefined;
    suppliers?: PerformerModel[] | undefined;
    treatment?: IdentifierModel | undefined;
    treatmentStopType?: TreatmentStopType | undefined;
    usageDuration?: DurationModel | undefined;
    instructions?: InstructionsModel | undefined;

    constructor(data?: IAdministrationAgreementModel) {
        super(data);
        this._discriminator = "AdministrationAgreementModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.additionalInformation = _data["additionalInformation"];
            this.agreementReason = _data["agreementReason"];
            this.authoredOn = _data["authoredOn"];
            if (Array.isArray(_data["authorizingPrescriptions"])) {
                this.authorizingPrescriptions = [] as any;
                for (let item of _data["authorizingPrescriptions"])
                    this.authorizingPrescriptions!.push(ReferenceModel.fromJS(item));
            }
            this.category = _data["category"] ? CategoryModel.fromJS(_data["category"]) : <any>undefined;
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(CommentModel.fromJS(item));
            }
            this.context = _data["context"] ? ReferenceModel.fromJS(_data["context"]) : <any>undefined;
            this.copyIndicator = _data["copyIndicator"];
            if (Array.isArray(_data["identifiers"])) {
                this.identifiers = [] as any;
                for (let item of _data["identifiers"])
                    this.identifiers!.push(IdentifierModel.fromJS(item));
            }
            this.medication = _data["medication"] ? ReferenceModel.fromJS(_data["medication"]) : <any>undefined;
            this.periodOfUse = _data["periodOfUse"] ? PeriodModel.fromJS(_data["periodOfUse"]) : <any>undefined;
            this.repeatPeriodCyclicalSchedule = _data["repeatPeriodCyclicalSchedule"] ? DurationModel.fromJS(_data["repeatPeriodCyclicalSchedule"]) : <any>undefined;
            this.status = _data["status"];
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            if (Array.isArray(_data["suppliers"])) {
                this.suppliers = [] as any;
                for (let item of _data["suppliers"])
                    this.suppliers!.push(PerformerModel.fromJS(item));
            }
            this.treatment = _data["treatment"] ? IdentifierModel.fromJS(_data["treatment"]) : <any>undefined;
            this.treatmentStopType = _data["treatmentStopType"];
            this.usageDuration = _data["usageDuration"] ? DurationModel.fromJS(_data["usageDuration"]) : <any>undefined;
            this.instructions = _data["instructions"] ? InstructionsModel.fromJS(_data["instructions"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): AdministrationAgreementModel {
        data = typeof data === 'object' ? data : {};
        let result = new AdministrationAgreementModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additionalInformation"] = this.additionalInformation;
        data["agreementReason"] = this.agreementReason;
        data["authoredOn"] = this.authoredOn;
        if (Array.isArray(this.authorizingPrescriptions)) {
            data["authorizingPrescriptions"] = [];
            for (let item of this.authorizingPrescriptions)
                data["authorizingPrescriptions"].push(item.toJSON());
        }
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        data["context"] = this.context ? this.context.toJSON() : <any>undefined;
        data["copyIndicator"] = this.copyIndicator;
        if (Array.isArray(this.identifiers)) {
            data["identifiers"] = [];
            for (let item of this.identifiers)
                data["identifiers"].push(item.toJSON());
        }
        data["medication"] = this.medication ? this.medication.toJSON() : <any>undefined;
        data["periodOfUse"] = this.periodOfUse ? this.periodOfUse.toJSON() : <any>undefined;
        data["repeatPeriodCyclicalSchedule"] = this.repeatPeriodCyclicalSchedule ? this.repeatPeriodCyclicalSchedule.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        if (Array.isArray(this.suppliers)) {
            data["suppliers"] = [];
            for (let item of this.suppliers)
                data["suppliers"].push(item.toJSON());
        }
        data["treatment"] = this.treatment ? this.treatment.toJSON() : <any>undefined;
        data["treatmentStopType"] = this.treatmentStopType;
        data["usageDuration"] = this.usageDuration ? this.usageDuration.toJSON() : <any>undefined;
        data["instructions"] = this.instructions ? this.instructions.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAdministrationAgreementModel extends IResourceModel {
    additionalInformation?: AdministrationAgreementAdditionalInformation | undefined;
    agreementReason?: string | undefined;
    authoredOn?: string | undefined;
    authorizingPrescriptions?: ReferenceModel[] | undefined;
    category?: CategoryModel | undefined;
    comments?: CommentModel[] | undefined;
    context?: ReferenceModel | undefined;
    copyIndicator?: boolean | undefined;
    identifiers?: IdentifierModel[] | undefined;
    medication?: ReferenceModel | undefined;
    periodOfUse?: PeriodModel | undefined;
    repeatPeriodCyclicalSchedule?: DurationModel | undefined;
    status?: MedicationDispenseStatus;
    subject?: ReferenceModel | undefined;
    suppliers?: PerformerModel[] | undefined;
    treatment?: IdentifierModel | undefined;
    treatmentStopType?: TreatmentStopType | undefined;
    usageDuration?: DurationModel | undefined;
    instructions?: InstructionsModel | undefined;
}

export enum AdministrationAgreementAdditionalInformation {
    Unknown = 0,
    MedicationNotProvided = 1,
    OutOfStock = 2,
    MedicationAgreementChangedSubstance = 3,
    MedicationAgreementChangedDosage = 4,
    MedicationAgreementChangedPharmaceuticalForm = 5,
    MedicationAgreementChangedChangeOfPerson = 6,
    PermissionRequested = 7,
    PermissionRejected = 8,
    PermissionIntoUse = 9,
    InstructionForUseGiven = 10,
    CheckInhalationTechnique = 11,
    MeterPeriodicCheck = 12,
    PenCheckExchange = 13,
    SideEffectDiscussed = 14,
    HandlingSideEffectNonLareb = 15,
    NotificationLareb = 16,
    MedicationMonitoringOt = 17,
}

export class ReferenceModel implements IReferenceModel {
    id?: string | undefined;
    display?: string | undefined;
    resource?: ResourceModel | undefined;
    uri?: string | undefined;
    expectedResourceModelTypes?: ResourceModelType[] | undefined;
    extension?: ReferenceModel | undefined;

    constructor(data?: IReferenceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.display = _data["display"];
            this.resource = _data["resource"] ? ResourceModel.fromJS(_data["resource"]) : <any>undefined;
            this.uri = _data["uri"];
            if (Array.isArray(_data["expectedResourceModelTypes"])) {
                this.expectedResourceModelTypes = [] as any;
                for (let item of _data["expectedResourceModelTypes"])
                    this.expectedResourceModelTypes!.push(item);
            }
            this.extension = _data["extension"] ? ReferenceModel.fromJS(_data["extension"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReferenceModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReferenceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["display"] = this.display;
        data["resource"] = this.resource ? this.resource.toJSON() : <any>undefined;
        data["uri"] = this.uri;
        if (Array.isArray(this.expectedResourceModelTypes)) {
            data["expectedResourceModelTypes"] = [];
            for (let item of this.expectedResourceModelTypes)
                data["expectedResourceModelTypes"].push(item);
        }
        data["extension"] = this.extension ? this.extension.toJSON() : <any>undefined;
        return data;
    }
}

export interface IReferenceModel {
    id?: string | undefined;
    display?: string | undefined;
    resource?: ResourceModel | undefined;
    uri?: string | undefined;
    expectedResourceModelTypes?: ResourceModelType[] | undefined;
    extension?: ReferenceModel | undefined;
}

export enum ResourceModelType {
    Unknown = 0,
    Patient = 1,
    Organization = 2,
    RelatedPerson = 3,
    AllergyIntolerance = 4,
    Practitioner = 5,
    Encounter = 6,
    EpisodeOfCare = 7,
    Problem = 8,
    AdvanceDirective = 9,
    MedicalDeviceUse = 10,
    Location = 11,
    TextResult = 12,
    PharmaceuticalProduct = 13,
    Appointment = 14,
    Vaccination = 15,
    Observation = 16,
    BodyWeight = 17,
    BodyHeight = 18,
    PractitionerRole = 19,
    MedicalDeviceProduct = 20,
    VaccinationRecommendation = 21,
    BloodPressure = 22,
    BodyTemperature = 23,
    OxygenSaturation = 24,
    HeartRate = 25,
    PulseRate = 26,
    BloodGlucose = 27,
    LaboratoryTestResult = 28,
    Specimen = 29,
    EncounterReport = 30,
    Procedure = 31,
    FreedomRestrictingMeasure = 32,
    FamilySituationModel = 33,
    FamilySituationModelChild = 34,
    ParticipationInSociety = 35,
    CareTeam = 36,
    GeneralMeasurement = 37,
    HelpFromOthers = 38,
    MedicationAdministration = 39,
    MedicationUse = 40,
    AdministrationAgreement = 41,
    MedicationAgreement = 42,
    DispenseRequest = 43,
    Dispense = 44,
    LspAdministrationAgreement = 45,
    LspDispense = 46,
    MedicationOverviewPatient = 47,
    MedicationOverviewOrganization = 48,
    TreatmentOverviewEntry = 49,
    TreatmentOverviewDispenseRequestEntry = 50,
    TreatmentOverviewDispenseEntry = 51,
    TreatmentOverviewEntryMedicationUse = 52,
    TreatmentOverviewEntryAdministrationAgreement = 53,
    TreatmentOverviewEntryMedicationAgreement = 54,
    AlcoholUse = 55,
    Alert = 56,
    DrugUse = 57,
    LivingSituation = 58,
    FunctionalOrMentalStatus = 59,
    TobaccoUse = 60,
    MedicalDeviceRequest = 61,
    Payer = 62,
    ProcedureRequest = 63,
    TreatmentDirective = 64,
    DocumentReference = 65,
    DocumentManifest = 66,
    Binary = 67,
    BcWoman = 68,
    BcMotherOf = 69,
    BcChild = 70,
    BcMaternalRecord = 71,
    BcBirthWeight = 72,
    ZibApgarScore = 73,
    NlCoreObservation = 74,
    BcBirthObservation = 75,
    BcBirth = 76,
    BcDeliveryObservation = 77,
    BcObstetricProcedure = 78,
    BcDeliveryProcedure = 79,
    BcPregnancyObservation = 80,
    ZibPregnancy = 81,
    BcChildBirthAssistance = 82,
    ZibPregnancyDueDate = 83,
    ZibPregnancyGravidity = 84,
    ZibPregnancyParity = 85,
    BcMembraneCompleteness = 86,
    JourneyEntry = 87,
    CarePlan = 88,
    Goal = 89,
    LaboratoryTestResultDiagnosticReport = 90,
}

export class AllergyIntoleranceModel extends ResourceModel implements IAllergyIntoleranceModel {
    asserter?: ReferenceModel | undefined;
    categories?: AllergyCategory[] | undefined;
    comments?: CommentModel[] | undefined;
    criticality?: AllergyCriticality | undefined;
    lastOccurrenceDateTime?: string | undefined;
    name?: string | undefined;
    patient?: ReferenceModel | undefined;
    reactions?: ReactionModel[] | undefined;
    recorder?: ReferenceModel | undefined;
    startDateTime?: string | undefined;
    status?: AllergyStatus | undefined;
    verificationStatus?: VerificationStatus | undefined;

    constructor(data?: IAllergyIntoleranceModel) {
        super(data);
        this._discriminator = "AllergyIntoleranceModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.asserter = _data["asserter"] ? ReferenceModel.fromJS(_data["asserter"]) : <any>undefined;
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(item);
            }
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(CommentModel.fromJS(item));
            }
            this.criticality = _data["criticality"];
            this.lastOccurrenceDateTime = _data["lastOccurrenceDateTime"];
            this.name = _data["name"];
            this.patient = _data["patient"] ? ReferenceModel.fromJS(_data["patient"]) : <any>undefined;
            if (Array.isArray(_data["reactions"])) {
                this.reactions = [] as any;
                for (let item of _data["reactions"])
                    this.reactions!.push(ReactionModel.fromJS(item));
            }
            this.recorder = _data["recorder"] ? ReferenceModel.fromJS(_data["recorder"]) : <any>undefined;
            this.startDateTime = _data["startDateTime"];
            this.status = _data["status"];
            this.verificationStatus = _data["verificationStatus"];
        }
    }

    static override fromJS(data: any): AllergyIntoleranceModel {
        data = typeof data === 'object' ? data : {};
        let result = new AllergyIntoleranceModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["asserter"] = this.asserter ? this.asserter.toJSON() : <any>undefined;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item);
        }
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        data["criticality"] = this.criticality;
        data["lastOccurrenceDateTime"] = this.lastOccurrenceDateTime;
        data["name"] = this.name;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        if (Array.isArray(this.reactions)) {
            data["reactions"] = [];
            for (let item of this.reactions)
                data["reactions"].push(item.toJSON());
        }
        data["recorder"] = this.recorder ? this.recorder.toJSON() : <any>undefined;
        data["startDateTime"] = this.startDateTime;
        data["status"] = this.status;
        data["verificationStatus"] = this.verificationStatus;
        super.toJSON(data);
        return data;
    }
}

export interface IAllergyIntoleranceModel extends IResourceModel {
    asserter?: ReferenceModel | undefined;
    categories?: AllergyCategory[] | undefined;
    comments?: CommentModel[] | undefined;
    criticality?: AllergyCriticality | undefined;
    lastOccurrenceDateTime?: string | undefined;
    name?: string | undefined;
    patient?: ReferenceModel | undefined;
    reactions?: ReactionModel[] | undefined;
    recorder?: ReferenceModel | undefined;
    startDateTime?: string | undefined;
    status?: AllergyStatus | undefined;
    verificationStatus?: VerificationStatus | undefined;
}

export enum AllergyCategory {
    Other = 0,
    Food = 1,
    Medication = 2,
    Environment = 3,
    Biologic = 4,
}

export class CommentModel implements ICommentModel {
    author?: AuthorModel | undefined;
    dateTime?: string | undefined;
    text?: string | undefined;

    constructor(data?: ICommentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.author = _data["author"] ? AuthorModel.fromJS(_data["author"]) : <any>undefined;
            this.dateTime = _data["dateTime"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): CommentModel {
        data = typeof data === 'object' ? data : {};
        let result = new CommentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["author"] = this.author ? this.author.toJSON() : <any>undefined;
        data["dateTime"] = this.dateTime;
        data["text"] = this.text;
        return data;
    }
}

export interface ICommentModel {
    author?: AuthorModel | undefined;
    dateTime?: string | undefined;
    text?: string | undefined;
}

export class AuthorModel implements IAuthorModel {
    stringValue?: string | undefined;
    referenceValue?: ReferenceModel | undefined;

    constructor(data?: IAuthorModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stringValue = _data["stringValue"];
            this.referenceValue = _data["referenceValue"] ? ReferenceModel.fromJS(_data["referenceValue"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AuthorModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stringValue"] = this.stringValue;
        data["referenceValue"] = this.referenceValue ? this.referenceValue.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAuthorModel {
    stringValue?: string | undefined;
    referenceValue?: ReferenceModel | undefined;
}

export enum AllergyCriticality {
    Unknown = 0,
    Low = 1,
    High = 2,
    UnableToAssess = 3,
    Mild = 21,
    Moderate = 22,
    Severe = 23,
    Fatal = 24,
}

export class ReactionModel implements IReactionModel {
    dateTime?: string | undefined;
    description?: string | undefined;
    exposureRoute?: string | undefined;
    severity?: ReactionSeverity | undefined;
    substance?: string | undefined;
    symptoms?: SymptomCode[] | undefined;

    constructor(data?: IReactionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateTime = _data["dateTime"];
            this.description = _data["description"];
            this.exposureRoute = _data["exposureRoute"];
            this.severity = _data["severity"];
            this.substance = _data["substance"];
            if (Array.isArray(_data["symptoms"])) {
                this.symptoms = [] as any;
                for (let item of _data["symptoms"])
                    this.symptoms!.push(item);
            }
        }
    }

    static fromJS(data: any): ReactionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReactionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateTime"] = this.dateTime;
        data["description"] = this.description;
        data["exposureRoute"] = this.exposureRoute;
        data["severity"] = this.severity;
        data["substance"] = this.substance;
        if (Array.isArray(this.symptoms)) {
            data["symptoms"] = [];
            for (let item of this.symptoms)
                data["symptoms"].push(item);
        }
        return data;
    }
}

export interface IReactionModel {
    dateTime?: string | undefined;
    description?: string | undefined;
    exposureRoute?: string | undefined;
    severity?: ReactionSeverity | undefined;
    substance?: string | undefined;
    symptoms?: SymptomCode[] | undefined;
}

export enum ReactionSeverity {
    Unknown = 0,
    Mild = 1,
    Moderate = 2,
    Severe = 3,
}

export enum SymptomCode {
    Other = 0,
    Anaphylaxis = 1,
    Angioedema = 2,
    UpperRespiratoryHypersensitivity = 3,
    Dyspnea = 4,
    Bronchospasm = 5,
    Urticaria = 6,
    ContactDermatitis = 7,
    ItchingOfSkin = 8,
    EruptionOfSkin = 9,
    AllergicConjunctivitis = 10,
    ToxicEpidermalNecrolysis = 11,
    NauseaAndVomiting = 12,
    Diarrhoea = 13,
    DrugInducedErythemaMultiforme = 14,
    Fever = 15,
}

export enum AllergyStatus {
    Unknown = 0,
    Active = 1,
    Inactive = 2,
    Resolved = 3,
    Completed = 20,
    Obsolete = 21,
    Nullified = 22,
}

export enum VerificationStatus {
    Unknown = 0,
    Provisional = 1,
    Differential = 2,
    Confirmed = 3,
    Refuted = 4,
    Unconfirmed = 5,
    EnteredInError = 6,
}

export class AppointmentModel extends ResourceModel implements IAppointmentModel {
    comment?: string | undefined;
    creationDate?: string | undefined;
    description?: string | undefined;
    durationInMinutes?: number | undefined;
    endDateTime?: Date | undefined;
    indications?: ReferenceModel[] | undefined;
    onlineEditable?: boolean;
    onlineEditableUntil?: string | undefined;
    participants?: ParticipantModel[] | undefined;
    patientInstructions?: string[] | undefined;
    reason?: string | undefined;
    referrals?: ReferenceModel[] | undefined;
    serviceCategory?: string | undefined;
    serviceType?: string | undefined;
    specialty?: string | undefined;
    startDateTime?: Date | undefined;
    status?: OrderStatus | undefined;
    type?: ContactType | undefined;

    constructor(data?: IAppointmentModel) {
        super(data);
        this._discriminator = "AppointmentModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.comment = _data["comment"];
            this.creationDate = _data["creationDate"];
            this.description = _data["description"];
            this.durationInMinutes = _data["durationInMinutes"];
            this.endDateTime = _data["endDateTime"] ? new Date(_data["endDateTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["indications"])) {
                this.indications = [] as any;
                for (let item of _data["indications"])
                    this.indications!.push(ReferenceModel.fromJS(item));
            }
            this.onlineEditable = _data["onlineEditable"];
            this.onlineEditableUntil = _data["onlineEditableUntil"];
            if (Array.isArray(_data["participants"])) {
                this.participants = [] as any;
                for (let item of _data["participants"])
                    this.participants!.push(ParticipantModel.fromJS(item));
            }
            if (Array.isArray(_data["patientInstructions"])) {
                this.patientInstructions = [] as any;
                for (let item of _data["patientInstructions"])
                    this.patientInstructions!.push(item);
            }
            this.reason = _data["reason"];
            if (Array.isArray(_data["referrals"])) {
                this.referrals = [] as any;
                for (let item of _data["referrals"])
                    this.referrals!.push(ReferenceModel.fromJS(item));
            }
            this.serviceCategory = _data["serviceCategory"];
            this.serviceType = _data["serviceType"];
            this.specialty = _data["specialty"];
            this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.type = _data["type"];
        }
    }

    static override fromJS(data: any): AppointmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment;
        data["creationDate"] = this.creationDate;
        data["description"] = this.description;
        data["durationInMinutes"] = this.durationInMinutes;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : <any>undefined;
        if (Array.isArray(this.indications)) {
            data["indications"] = [];
            for (let item of this.indications)
                data["indications"].push(item.toJSON());
        }
        data["onlineEditable"] = this.onlineEditable;
        data["onlineEditableUntil"] = this.onlineEditableUntil;
        if (Array.isArray(this.participants)) {
            data["participants"] = [];
            for (let item of this.participants)
                data["participants"].push(item.toJSON());
        }
        if (Array.isArray(this.patientInstructions)) {
            data["patientInstructions"] = [];
            for (let item of this.patientInstructions)
                data["patientInstructions"].push(item);
        }
        data["reason"] = this.reason;
        if (Array.isArray(this.referrals)) {
            data["referrals"] = [];
            for (let item of this.referrals)
                data["referrals"].push(item.toJSON());
        }
        data["serviceCategory"] = this.serviceCategory;
        data["serviceType"] = this.serviceType;
        data["specialty"] = this.specialty;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["type"] = this.type;
        super.toJSON(data);
        return data;
    }
}

export interface IAppointmentModel extends IResourceModel {
    comment?: string | undefined;
    creationDate?: string | undefined;
    description?: string | undefined;
    durationInMinutes?: number | undefined;
    endDateTime?: Date | undefined;
    indications?: ReferenceModel[] | undefined;
    onlineEditable?: boolean;
    onlineEditableUntil?: string | undefined;
    participants?: ParticipantModel[] | undefined;
    patientInstructions?: string[] | undefined;
    reason?: string | undefined;
    referrals?: ReferenceModel[] | undefined;
    serviceCategory?: string | undefined;
    serviceType?: string | undefined;
    specialty?: string | undefined;
    startDateTime?: Date | undefined;
    status?: OrderStatus | undefined;
    type?: ContactType | undefined;
}

export class ParticipantModel implements IParticipantModel {
    actor?: ReferenceModel | undefined;
    type?: ParticipantType | undefined;

    constructor(data?: IParticipantModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actor = _data["actor"] ? ReferenceModel.fromJS(_data["actor"]) : <any>undefined;
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ParticipantModel {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actor"] = this.actor ? this.actor.toJSON() : <any>undefined;
        data["type"] = this.type;
        return data;
    }
}

export interface IParticipantModel {
    actor?: ReferenceModel | undefined;
    type?: ParticipantType | undefined;
}

export enum ParticipantType {
    Other = 0,
    ResponsibleParty = 1,
    Referrer = 2,
    Performer = 3,
    SecondaryPerformer = 4,
    Consultant = 5,
    Attender = 6,
}

export enum OrderStatus {
    Unknown = 0,
    Requested = 1,
    InProgress = 2,
    Ordered = 3,
    Pending = 4,
    OnHold = 5,
    Cancelled = 6,
    NoShow = 7,
}

export enum ContactType {
    Other = 0,
    Ambulatory = 1,
    Emergency = 2,
    Field = 3,
    Home = 4,
    Inpatient = 5,
    ShortStay = 6,
    Virtual = 7,
}

export class CareTeamModel extends ResourceModel implements ICareTeamModel {
    subject?: ReferenceModel | undefined;
    context?: ReferenceModel | undefined;
    period?: PeriodModel | undefined;
    participants?: CareTeamParticipantModel[] | undefined;
    reasons?: ReferenceModel[] | undefined;
    managingOrganizations?: ReferenceModel[] | undefined;
    practitioner?: NlCorePractitioner | undefined;
    telecom?: TelecomModel[] | undefined;
    address?: AddressModel | undefined;

    constructor(data?: ICareTeamModel) {
        super(data);
        this._discriminator = "CareTeamModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            this.context = _data["context"] ? ReferenceModel.fromJS(_data["context"]) : <any>undefined;
            this.period = _data["period"] ? PeriodModel.fromJS(_data["period"]) : <any>undefined;
            if (Array.isArray(_data["participants"])) {
                this.participants = [] as any;
                for (let item of _data["participants"])
                    this.participants!.push(CareTeamParticipantModel.fromJS(item));
            }
            if (Array.isArray(_data["reasons"])) {
                this.reasons = [] as any;
                for (let item of _data["reasons"])
                    this.reasons!.push(ReferenceModel.fromJS(item));
            }
            if (Array.isArray(_data["managingOrganizations"])) {
                this.managingOrganizations = [] as any;
                for (let item of _data["managingOrganizations"])
                    this.managingOrganizations!.push(ReferenceModel.fromJS(item));
            }
            this.practitioner = _data["practitioner"] ? NlCorePractitioner.fromJS(_data["practitioner"]) : <any>undefined;
            if (Array.isArray(_data["telecom"])) {
                this.telecom = [] as any;
                for (let item of _data["telecom"])
                    this.telecom!.push(TelecomModel.fromJS(item));
            }
            this.address = _data["address"] ? AddressModel.fromJS(_data["address"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): CareTeamModel {
        data = typeof data === 'object' ? data : {};
        let result = new CareTeamModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        data["context"] = this.context ? this.context.toJSON() : <any>undefined;
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        if (Array.isArray(this.participants)) {
            data["participants"] = [];
            for (let item of this.participants)
                data["participants"].push(item.toJSON());
        }
        if (Array.isArray(this.reasons)) {
            data["reasons"] = [];
            for (let item of this.reasons)
                data["reasons"].push(item.toJSON());
        }
        if (Array.isArray(this.managingOrganizations)) {
            data["managingOrganizations"] = [];
            for (let item of this.managingOrganizations)
                data["managingOrganizations"].push(item.toJSON());
        }
        data["practitioner"] = this.practitioner ? this.practitioner.toJSON() : <any>undefined;
        if (Array.isArray(this.telecom)) {
            data["telecom"] = [];
            for (let item of this.telecom)
                data["telecom"].push(item.toJSON());
        }
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICareTeamModel extends IResourceModel {
    subject?: ReferenceModel | undefined;
    context?: ReferenceModel | undefined;
    period?: PeriodModel | undefined;
    participants?: CareTeamParticipantModel[] | undefined;
    reasons?: ReferenceModel[] | undefined;
    managingOrganizations?: ReferenceModel[] | undefined;
    practitioner?: NlCorePractitioner | undefined;
    telecom?: TelecomModel[] | undefined;
    address?: AddressModel | undefined;
}

export class PeriodModel implements IPeriodModel {
    start?: string | undefined;
    end?: string | undefined;
    comparisonDate?: Date | undefined;
    duration?: DurationModel | undefined;

    constructor(data?: IPeriodModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"];
            this.end = _data["end"];
            this.comparisonDate = _data["comparisonDate"] ? new Date(_data["comparisonDate"].toString()) : <any>undefined;
            this.duration = _data["duration"] ? DurationModel.fromJS(_data["duration"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PeriodModel {
        data = typeof data === 'object' ? data : {};
        let result = new PeriodModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start;
        data["end"] = this.end;
        data["comparisonDate"] = this.comparisonDate ? this.comparisonDate.toISOString() : <any>undefined;
        data["duration"] = this.duration ? this.duration.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPeriodModel {
    start?: string | undefined;
    end?: string | undefined;
    comparisonDate?: Date | undefined;
    duration?: DurationModel | undefined;
}

export class DurationModel implements IDurationModel {
    value?: number | undefined;
    unit?: UnitOfTime | undefined;

    constructor(data?: IDurationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.unit = _data["unit"];
        }
    }

    static fromJS(data: any): DurationModel {
        data = typeof data === 'object' ? data : {};
        let result = new DurationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["unit"] = this.unit;
        return data;
    }
}

export interface IDurationModel {
    value?: number | undefined;
    unit?: UnitOfTime | undefined;
}

export enum UnitOfTime {
    Unknown = 0,
    Second = 1,
    Minute = 2,
    Hour = 3,
    Day = 4,
    Week = 5,
    Month = 6,
    Year = 7,
}

export class CareTeamParticipantModel implements ICareTeamParticipantModel {
    role?: PerformerRole | undefined;
    member?: ReferenceModel | undefined;
    onBehalfOf?: ReferenceModel | undefined;

    constructor(data?: ICareTeamParticipantModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"];
            this.member = _data["member"] ? ReferenceModel.fromJS(_data["member"]) : <any>undefined;
            this.onBehalfOf = _data["onBehalfOf"] ? ReferenceModel.fromJS(_data["onBehalfOf"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CareTeamParticipantModel {
        data = typeof data === 'object' ? data : {};
        let result = new CareTeamParticipantModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role;
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        data["onBehalfOf"] = this.onBehalfOf ? this.onBehalfOf.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICareTeamParticipantModel {
    role?: PerformerRole | undefined;
    member?: ReferenceModel | undefined;
    onBehalfOf?: ReferenceModel | undefined;
}

export enum PerformerRole {
    Other = 0,
    ResponsibleParty = 1,
    Referrer = 2,
    Performer = 3,
    SecondaryPerformer = 4,
    Consultant = 5,
    Attender = 6,
}

export class NlCorePractitioner extends ResourceModel implements INlCorePractitioner {
    addresses?: AddressModel[] | undefined;
    identifiers?: PractitionerIdentifierModel[] | undefined;
    names?: NameModel[] | undefined;
    telecoms?: TelecomModel[] | undefined;
    gender?: Gender;

    constructor(data?: INlCorePractitioner) {
        super(data);
        this._discriminator = "NlCorePractitioner";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(AddressModel.fromJS(item));
            }
            if (Array.isArray(_data["identifiers"])) {
                this.identifiers = [] as any;
                for (let item of _data["identifiers"])
                    this.identifiers!.push(PractitionerIdentifierModel.fromJS(item));
            }
            if (Array.isArray(_data["names"])) {
                this.names = [] as any;
                for (let item of _data["names"])
                    this.names!.push(NameModel.fromJS(item));
            }
            if (Array.isArray(_data["telecoms"])) {
                this.telecoms = [] as any;
                for (let item of _data["telecoms"])
                    this.telecoms!.push(TelecomModel.fromJS(item));
            }
            this.gender = _data["gender"];
        }
    }

    static override fromJS(data: any): NlCorePractitioner {
        data = typeof data === 'object' ? data : {};
        let result = new NlCorePractitioner();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        if (Array.isArray(this.identifiers)) {
            data["identifiers"] = [];
            for (let item of this.identifiers)
                data["identifiers"].push(item.toJSON());
        }
        if (Array.isArray(this.names)) {
            data["names"] = [];
            for (let item of this.names)
                data["names"].push(item.toJSON());
        }
        if (Array.isArray(this.telecoms)) {
            data["telecoms"] = [];
            for (let item of this.telecoms)
                data["telecoms"].push(item.toJSON());
        }
        data["gender"] = this.gender;
        super.toJSON(data);
        return data;
    }
}

export interface INlCorePractitioner extends IResourceModel {
    addresses?: AddressModel[] | undefined;
    identifiers?: PractitionerIdentifierModel[] | undefined;
    names?: NameModel[] | undefined;
    telecoms?: TelecomModel[] | undefined;
    gender?: Gender;
}

export class AddressModel implements IAddressModel {
    street?: string | undefined;
    houseNumber?: string | undefined;
    houseNumberSuffix?: string | undefined;
    houseNumberExtraInformation?: string | undefined;
    houseNumberIndication?: string | undefined;
    city?: string | undefined;
    district?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    isPostalAddress?: boolean;
    physicalAddressType?: PhysicalAddressType | undefined;
    display?: string | undefined;

    constructor(data?: IAddressModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.street = _data["street"];
            this.houseNumber = _data["houseNumber"];
            this.houseNumberSuffix = _data["houseNumberSuffix"];
            this.houseNumberExtraInformation = _data["houseNumberExtraInformation"];
            this.houseNumberIndication = _data["houseNumberIndication"];
            this.city = _data["city"];
            this.district = _data["district"];
            this.state = _data["state"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
            this.isPostalAddress = _data["isPostalAddress"];
            this.physicalAddressType = _data["physicalAddressType"];
            this.display = _data["display"];
        }
    }

    static fromJS(data: any): AddressModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddressModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["street"] = this.street;
        data["houseNumber"] = this.houseNumber;
        data["houseNumberSuffix"] = this.houseNumberSuffix;
        data["houseNumberExtraInformation"] = this.houseNumberExtraInformation;
        data["houseNumberIndication"] = this.houseNumberIndication;
        data["city"] = this.city;
        data["district"] = this.district;
        data["state"] = this.state;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        data["isPostalAddress"] = this.isPostalAddress;
        data["physicalAddressType"] = this.physicalAddressType;
        data["display"] = this.display;
        return data;
    }
}

export interface IAddressModel {
    street?: string | undefined;
    houseNumber?: string | undefined;
    houseNumberSuffix?: string | undefined;
    houseNumberExtraInformation?: string | undefined;
    houseNumberIndication?: string | undefined;
    city?: string | undefined;
    district?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    isPostalAddress?: boolean;
    physicalAddressType?: PhysicalAddressType | undefined;
    display?: string | undefined;
}

export enum PhysicalAddressType {
    Unknown = 0,
    PostalAddress = 1,
    PrimaryHome = 2,
    VisitAddress = 3,
    TemporaryAddress = 4,
    WorkPlace = 5,
    VacationHome = 6,
}

export class PractitionerIdentifierModel implements IPractitionerIdentifierModel {
    type?: PractitionerIdentifierType | undefined;
    useType?: PractitionerIdentifierUseType | undefined;
    value?: string | undefined;
    period?: PeriodModel | undefined;
    assigner?: ReferenceModel | undefined;

    constructor(data?: IPractitionerIdentifierModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.useType = _data["useType"];
            this.value = _data["value"];
            this.period = _data["period"] ? PeriodModel.fromJS(_data["period"]) : <any>undefined;
            this.assigner = _data["assigner"] ? ReferenceModel.fromJS(_data["assigner"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PractitionerIdentifierModel {
        data = typeof data === 'object' ? data : {};
        let result = new PractitionerIdentifierModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["useType"] = this.useType;
        data["value"] = this.value;
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        data["assigner"] = this.assigner ? this.assigner.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPractitionerIdentifierModel {
    type?: PractitionerIdentifierType | undefined;
    useType?: PractitionerIdentifierUseType | undefined;
    value?: string | undefined;
    period?: PeriodModel | undefined;
    assigner?: ReferenceModel | undefined;
}

export enum PractitionerIdentifierType {
    Unknown = 0,
    Uzi = 1,
    Agb = 2,
    Big = 3,
}

export enum PractitionerIdentifierUseType {
    Unknown = 0,
    Usual = 1,
    Official = 2,
    Temp = 3,
    Secondary = 4,
}

export class NameModel implements INameModel {
    type?: PatientNameType;
    assemblyOrderType?: NameAssemblyOrder;
    assemblyOrderTypeName?: string | undefined;
    familyName?: string | undefined;
    familyNamePartner?: string | undefined;
    familyNamePrefix?: string | undefined;
    familyNamePrefixPartner?: string | undefined;
    firstName?: string | undefined;
    givenName?: string | undefined;
    initials?: string | undefined;
    display?: string | undefined;
    fhirDisplay?: string | undefined;

    constructor(data?: INameModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.assemblyOrderType = _data["assemblyOrderType"];
            this.assemblyOrderTypeName = _data["assemblyOrderTypeName"];
            this.familyName = _data["familyName"];
            this.familyNamePartner = _data["familyNamePartner"];
            this.familyNamePrefix = _data["familyNamePrefix"];
            this.familyNamePrefixPartner = _data["familyNamePrefixPartner"];
            this.firstName = _data["firstName"];
            this.givenName = _data["givenName"];
            this.initials = _data["initials"];
            this.display = _data["display"];
            this.fhirDisplay = _data["fhirDisplay"];
        }
    }

    static fromJS(data: any): NameModel {
        data = typeof data === 'object' ? data : {};
        let result = new NameModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["assemblyOrderType"] = this.assemblyOrderType;
        data["assemblyOrderTypeName"] = this.assemblyOrderTypeName;
        data["familyName"] = this.familyName;
        data["familyNamePartner"] = this.familyNamePartner;
        data["familyNamePrefix"] = this.familyNamePrefix;
        data["familyNamePrefixPartner"] = this.familyNamePrefixPartner;
        data["firstName"] = this.firstName;
        data["givenName"] = this.givenName;
        data["initials"] = this.initials;
        data["display"] = this.display;
        data["fhirDisplay"] = this.fhirDisplay;
        return data;
    }
}

export interface INameModel {
    type?: PatientNameType;
    assemblyOrderType?: NameAssemblyOrder;
    assemblyOrderTypeName?: string | undefined;
    familyName?: string | undefined;
    familyNamePartner?: string | undefined;
    familyNamePrefix?: string | undefined;
    familyNamePrefixPartner?: string | undefined;
    firstName?: string | undefined;
    givenName?: string | undefined;
    initials?: string | undefined;
    display?: string | undefined;
    fhirDisplay?: string | undefined;
}

export enum PatientNameType {
    Unknown = 0,
    Usual = 1,
    Official = 2,
    Temp = 3,
    Nickname = 4,
    Anonymous = 5,
    Old = 6,
    Maiden = 7,
}

export enum NameAssemblyOrder {
    Unknown = 0,
    Nl1 = 1,
    Nl2 = 2,
    Nl3 = 3,
    Nl4 = 4,
    F = 5,
    G = 6,
}

export class TelecomModel implements ITelecomModel {
    value?: string | undefined;
    type?: TelecomType | undefined;
    system?: TelecomSystem;
    use?: TelecomUse;

    constructor(data?: ITelecomModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.type = _data["type"];
            this.system = _data["system"];
            this.use = _data["use"];
        }
    }

    static fromJS(data: any): TelecomModel {
        data = typeof data === 'object' ? data : {};
        let result = new TelecomModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["type"] = this.type;
        data["system"] = this.system;
        data["use"] = this.use;
        return data;
    }
}

export interface ITelecomModel {
    value?: string | undefined;
    type?: TelecomType | undefined;
    system?: TelecomSystem;
    use?: TelecomUse;
}

export enum TelecomType {
    Unknown = 0,
    MobilePhone = 1,
    Pager = 2,
    LandLine = 3,
    Fax = 4,
}

export enum TelecomSystem {
    Unknown = 0,
    Phone = 1,
    Fax = 2,
    Email = 3,
    Pager = 4,
    Url = 5,
    Sms = 6,
    Other = 7,
}

export enum TelecomUse {
    Unknown = 0,
    Home = 1,
    Work = 2,
    Temp = 3,
    Old = 4,
    Mobile = 5,
}

export enum Gender {
    Unknown = 0,
    Male = 1,
    Female = 2,
    Undifferentiated = 3,
}

export class TextResultModel extends ResourceModel implements ITextResultModel {
    basedOn?: ReferenceModel[] | undefined;
    conclusion?: string | undefined;
    context?: ReferenceModel | undefined;
    effective?: EffectiveModel | undefined;
    performers?: PerformerModel[] | undefined;
    results?: ReferenceModel[] | undefined;
    resultType?: ResultType | undefined;
    specimens?: ReferenceModel[] | undefined;
    status?: DiagnosticReportStatus | undefined;
    subject?: ReferenceModel | undefined;
    type?: DiagnosticReportType | undefined;
    typeString?: string | undefined;

    constructor(data?: ITextResultModel) {
        super(data);
        this._discriminator = "TextResultModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["basedOn"])) {
                this.basedOn = [] as any;
                for (let item of _data["basedOn"])
                    this.basedOn!.push(ReferenceModel.fromJS(item));
            }
            this.conclusion = _data["conclusion"];
            this.context = _data["context"] ? ReferenceModel.fromJS(_data["context"]) : <any>undefined;
            this.effective = _data["effective"] ? EffectiveModel.fromJS(_data["effective"]) : <any>undefined;
            if (Array.isArray(_data["performers"])) {
                this.performers = [] as any;
                for (let item of _data["performers"])
                    this.performers!.push(PerformerModel.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ReferenceModel.fromJS(item));
            }
            this.resultType = _data["resultType"];
            if (Array.isArray(_data["specimens"])) {
                this.specimens = [] as any;
                for (let item of _data["specimens"])
                    this.specimens!.push(ReferenceModel.fromJS(item));
            }
            this.status = _data["status"];
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            this.type = _data["type"];
            this.typeString = _data["typeString"];
        }
    }

    static override fromJS(data: any): TextResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new TextResultModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.basedOn)) {
            data["basedOn"] = [];
            for (let item of this.basedOn)
                data["basedOn"].push(item.toJSON());
        }
        data["conclusion"] = this.conclusion;
        data["context"] = this.context ? this.context.toJSON() : <any>undefined;
        data["effective"] = this.effective ? this.effective.toJSON() : <any>undefined;
        if (Array.isArray(this.performers)) {
            data["performers"] = [];
            for (let item of this.performers)
                data["performers"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["resultType"] = this.resultType;
        if (Array.isArray(this.specimens)) {
            data["specimens"] = [];
            for (let item of this.specimens)
                data["specimens"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["typeString"] = this.typeString;
        super.toJSON(data);
        return data;
    }
}

export interface ITextResultModel extends IResourceModel {
    basedOn?: ReferenceModel[] | undefined;
    conclusion?: string | undefined;
    context?: ReferenceModel | undefined;
    effective?: EffectiveModel | undefined;
    performers?: PerformerModel[] | undefined;
    results?: ReferenceModel[] | undefined;
    resultType?: ResultType | undefined;
    specimens?: ReferenceModel[] | undefined;
    status?: DiagnosticReportStatus | undefined;
    subject?: ReferenceModel | undefined;
    type?: DiagnosticReportType | undefined;
    typeString?: string | undefined;
}

export class EffectiveModel implements IEffectiveModel {
    dateTime?: string | undefined;
    comparisonDate?: Date | undefined;
    period?: PeriodModel | undefined;

    constructor(data?: IEffectiveModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateTime = _data["dateTime"];
            this.comparisonDate = _data["comparisonDate"] ? new Date(_data["comparisonDate"].toString()) : <any>undefined;
            this.period = _data["period"] ? PeriodModel.fromJS(_data["period"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EffectiveModel {
        data = typeof data === 'object' ? data : {};
        let result = new EffectiveModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateTime"] = this.dateTime;
        data["comparisonDate"] = this.comparisonDate ? this.comparisonDate.toISOString() : <any>undefined;
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEffectiveModel {
    dateTime?: string | undefined;
    comparisonDate?: Date | undefined;
    period?: PeriodModel | undefined;
}

export class PerformerModel implements IPerformerModel {
    actor?: ReferenceModel | undefined;
    onBehalfOf?: ReferenceModel | undefined;
    role?: PerformerRole | undefined;

    constructor(data?: IPerformerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actor = _data["actor"] ? ReferenceModel.fromJS(_data["actor"]) : <any>undefined;
            this.onBehalfOf = _data["onBehalfOf"] ? ReferenceModel.fromJS(_data["onBehalfOf"]) : <any>undefined;
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): PerformerModel {
        data = typeof data === 'object' ? data : {};
        let result = new PerformerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actor"] = this.actor ? this.actor.toJSON() : <any>undefined;
        data["onBehalfOf"] = this.onBehalfOf ? this.onBehalfOf.toJSON() : <any>undefined;
        data["role"] = this.role;
        return data;
    }
}

export interface IPerformerModel {
    actor?: ReferenceModel | undefined;
    onBehalfOf?: ReferenceModel | undefined;
    role?: PerformerRole | undefined;
}

export enum ResultType {
    Unknown = 0,
    Hematology = 1,
    Chemistry = 2,
    Serology = 3,
    Virology = 4,
    Toxicology = 5,
    Microbiology = 6,
    MolecularGenetics = 7,
}

export enum DiagnosticReportStatus {
    Unknown = 0,
    Pending = 1,
    Preliminary = 2,
    Final = 3,
    Appended = 4,
    Corrected = 5,
}

export enum DiagnosticReportType {
    Unknown = 0,
    Microbiology = 1,
    Imaging = 2,
    Xray = 3,
    Ultrasound = 4,
    Ct = 5,
    Mri = 6,
    Angiography = 7,
    CardiacEcho = 8,
    NuclearMedicine = 9,
    Pathology = 10,
    Procedure = 11,
}

export class EncounterModel extends ResourceModel implements IEncounterModel {
    contactReasons?: string[] | undefined;
    destinationType?: EncounterDestinationType | undefined;
    problems?: ReferenceModel[] | undefined;
    episodes?: ReferenceModel[] | undefined;
    originType?: EncounterOriginType | undefined;
    participants?: ParticipantModel[] | undefined;
    period?: PeriodModel | undefined;
    serviceProvider?: ReferenceModel | undefined;
    subject?: ReferenceModel | undefined;
    contactType?: ContactType | undefined;
    type?: EncounterType | undefined;

    constructor(data?: IEncounterModel) {
        super(data);
        this._discriminator = "EncounterModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["contactReasons"])) {
                this.contactReasons = [] as any;
                for (let item of _data["contactReasons"])
                    this.contactReasons!.push(item);
            }
            this.destinationType = _data["destinationType"];
            if (Array.isArray(_data["problems"])) {
                this.problems = [] as any;
                for (let item of _data["problems"])
                    this.problems!.push(ReferenceModel.fromJS(item));
            }
            if (Array.isArray(_data["episodes"])) {
                this.episodes = [] as any;
                for (let item of _data["episodes"])
                    this.episodes!.push(ReferenceModel.fromJS(item));
            }
            this.originType = _data["originType"];
            if (Array.isArray(_data["participants"])) {
                this.participants = [] as any;
                for (let item of _data["participants"])
                    this.participants!.push(ParticipantModel.fromJS(item));
            }
            this.period = _data["period"] ? PeriodModel.fromJS(_data["period"]) : <any>undefined;
            this.serviceProvider = _data["serviceProvider"] ? ReferenceModel.fromJS(_data["serviceProvider"]) : <any>undefined;
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            this.contactType = _data["contactType"];
            this.type = _data["type"];
        }
    }

    static override fromJS(data: any): EncounterModel {
        data = typeof data === 'object' ? data : {};
        let result = new EncounterModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contactReasons)) {
            data["contactReasons"] = [];
            for (let item of this.contactReasons)
                data["contactReasons"].push(item);
        }
        data["destinationType"] = this.destinationType;
        if (Array.isArray(this.problems)) {
            data["problems"] = [];
            for (let item of this.problems)
                data["problems"].push(item.toJSON());
        }
        if (Array.isArray(this.episodes)) {
            data["episodes"] = [];
            for (let item of this.episodes)
                data["episodes"].push(item.toJSON());
        }
        data["originType"] = this.originType;
        if (Array.isArray(this.participants)) {
            data["participants"] = [];
            for (let item of this.participants)
                data["participants"].push(item.toJSON());
        }
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        data["serviceProvider"] = this.serviceProvider ? this.serviceProvider.toJSON() : <any>undefined;
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        data["contactType"] = this.contactType;
        data["type"] = this.type;
        super.toJSON(data);
        return data;
    }
}

export interface IEncounterModel extends IResourceModel {
    contactReasons?: string[] | undefined;
    destinationType?: EncounterDestinationType | undefined;
    problems?: ReferenceModel[] | undefined;
    episodes?: ReferenceModel[] | undefined;
    originType?: EncounterOriginType | undefined;
    participants?: ParticipantModel[] | undefined;
    period?: PeriodModel | undefined;
    serviceProvider?: ReferenceModel | undefined;
    subject?: ReferenceModel | undefined;
    contactType?: ContactType | undefined;
    type?: EncounterType | undefined;
}

export enum EncounterDestinationType {
    Other = 0,
    Home = 1,
    LeftAgainstMedicalAdvice = 2,
    RehabilitationHospital = 3,
    NursingHome = 4,
    PsychiatricHospital = 5,
    Hospital = 6,
    DiedInHospital = 7,
    Hospice = 8,
}

export enum EncounterOriginType {
    Other = 0,
    Home = 1,
    RehabilitationHospital = 2,
    NursingHome = 3,
    PsychiatricHospital = 4,
    Hospital = 5,
    LivebornInHospital = 6,
    Hospice = 7,
}

export enum EncounterType {
    Visit = 1,
    NightlyVisit = 2,
    Consultation = 3,
    NightlyConsultation = 4,
    TelephoneCall = 5,
    NightlyTelephoneCall = 6,
    MailProcessing = 7,
    Meeting = 8,
    RepeatPrescription = 9,
    Memo = 10,
    Unknown = 90,
    Other = 99,
}

export class NlCoreEpisodeOfCare extends ResourceModel implements INlCoreEpisodeOfCare {
    title?: string | undefined;
    firstEncounter?: string | undefined;
    lastEncounter?: string | undefined;
    status?: EpisodeOfCareStatus | undefined;
    type?: string | undefined;
    diagnosis?: ReferenceModel[] | undefined;
    patient?: ReferenceModel | undefined;
    managingOrganization?: ReferenceModel | undefined;
    period?: PeriodModel | undefined;
    practitioner?: ReferenceModel | undefined;

    constructor(data?: INlCoreEpisodeOfCare) {
        super(data);
        this._discriminator = "NlCoreEpisodeOfCare";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.title = _data["title"];
            this.firstEncounter = _data["firstEncounter"];
            this.lastEncounter = _data["lastEncounter"];
            this.status = _data["status"];
            this.type = _data["type"];
            if (Array.isArray(_data["diagnosis"])) {
                this.diagnosis = [] as any;
                for (let item of _data["diagnosis"])
                    this.diagnosis!.push(ReferenceModel.fromJS(item));
            }
            this.patient = _data["patient"] ? ReferenceModel.fromJS(_data["patient"]) : <any>undefined;
            this.managingOrganization = _data["managingOrganization"] ? ReferenceModel.fromJS(_data["managingOrganization"]) : <any>undefined;
            this.period = _data["period"] ? PeriodModel.fromJS(_data["period"]) : <any>undefined;
            this.practitioner = _data["practitioner"] ? ReferenceModel.fromJS(_data["practitioner"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): NlCoreEpisodeOfCare {
        data = typeof data === 'object' ? data : {};
        if (data["resourceTypeDiscriminator"] === "BcMaternalRecord") {
            let result = new BcMaternalRecord();
            result.init(data);
            return result;
        }
        let result = new NlCoreEpisodeOfCare();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["firstEncounter"] = this.firstEncounter;
        data["lastEncounter"] = this.lastEncounter;
        data["status"] = this.status;
        data["type"] = this.type;
        if (Array.isArray(this.diagnosis)) {
            data["diagnosis"] = [];
            for (let item of this.diagnosis)
                data["diagnosis"].push(item.toJSON());
        }
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["managingOrganization"] = this.managingOrganization ? this.managingOrganization.toJSON() : <any>undefined;
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        data["practitioner"] = this.practitioner ? this.practitioner.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface INlCoreEpisodeOfCare extends IResourceModel {
    title?: string | undefined;
    firstEncounter?: string | undefined;
    lastEncounter?: string | undefined;
    status?: EpisodeOfCareStatus | undefined;
    type?: string | undefined;
    diagnosis?: ReferenceModel[] | undefined;
    patient?: ReferenceModel | undefined;
    managingOrganization?: ReferenceModel | undefined;
    period?: PeriodModel | undefined;
    practitioner?: ReferenceModel | undefined;
}

export enum EpisodeOfCareStatus {
    Planned = 1,
    Waitlist = 2,
    Active = 3,
    OnHold = 4,
    Finished = 5,
    Cancelled = 6,
    EnteredInError = 7,
}

export class CarePlanModel extends ResourceModel implements ICarePlanModel {
    subject?: ReferenceModel | undefined;
    context?: ReferenceModel | undefined;
    nursingInterventions?: NursingInterventionModel[] | undefined;
    authors?: ReferenceModel[] | undefined;
    goals?: ReferenceModel[] | undefined;
    identifiers?: IdentifierModel[] | undefined;
    period?: PeriodModel | undefined;

    constructor(data?: ICarePlanModel) {
        super(data);
        this._discriminator = "CarePlanModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            this.context = _data["context"] ? ReferenceModel.fromJS(_data["context"]) : <any>undefined;
            if (Array.isArray(_data["nursingInterventions"])) {
                this.nursingInterventions = [] as any;
                for (let item of _data["nursingInterventions"])
                    this.nursingInterventions!.push(NursingInterventionModel.fromJS(item));
            }
            if (Array.isArray(_data["authors"])) {
                this.authors = [] as any;
                for (let item of _data["authors"])
                    this.authors!.push(ReferenceModel.fromJS(item));
            }
            if (Array.isArray(_data["goals"])) {
                this.goals = [] as any;
                for (let item of _data["goals"])
                    this.goals!.push(ReferenceModel.fromJS(item));
            }
            if (Array.isArray(_data["identifiers"])) {
                this.identifiers = [] as any;
                for (let item of _data["identifiers"])
                    this.identifiers!.push(IdentifierModel.fromJS(item));
            }
            this.period = _data["period"] ? PeriodModel.fromJS(_data["period"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): CarePlanModel {
        data = typeof data === 'object' ? data : {};
        let result = new CarePlanModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        data["context"] = this.context ? this.context.toJSON() : <any>undefined;
        if (Array.isArray(this.nursingInterventions)) {
            data["nursingInterventions"] = [];
            for (let item of this.nursingInterventions)
                data["nursingInterventions"].push(item.toJSON());
        }
        if (Array.isArray(this.authors)) {
            data["authors"] = [];
            for (let item of this.authors)
                data["authors"].push(item.toJSON());
        }
        if (Array.isArray(this.goals)) {
            data["goals"] = [];
            for (let item of this.goals)
                data["goals"].push(item.toJSON());
        }
        if (Array.isArray(this.identifiers)) {
            data["identifiers"] = [];
            for (let item of this.identifiers)
                data["identifiers"].push(item.toJSON());
        }
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICarePlanModel extends IResourceModel {
    subject?: ReferenceModel | undefined;
    context?: ReferenceModel | undefined;
    nursingInterventions?: NursingInterventionModel[] | undefined;
    authors?: ReferenceModel[] | undefined;
    goals?: ReferenceModel[] | undefined;
    identifiers?: IdentifierModel[] | undefined;
    period?: PeriodModel | undefined;
}

export class NursingInterventionModel implements INursingInterventionModel {
    healthCondition?: string[] | undefined;
    healthConditionReference?: ReferenceModel[] | undefined;
    comment?: string | undefined;
    detailsReference?: ReferenceModel | undefined;
    detail?: NursingInterventionDetailModel | undefined;

    constructor(data?: INursingInterventionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["healthCondition"])) {
                this.healthCondition = [] as any;
                for (let item of _data["healthCondition"])
                    this.healthCondition!.push(item);
            }
            if (Array.isArray(_data["healthConditionReference"])) {
                this.healthConditionReference = [] as any;
                for (let item of _data["healthConditionReference"])
                    this.healthConditionReference!.push(ReferenceModel.fromJS(item));
            }
            this.comment = _data["comment"];
            this.detailsReference = _data["detailsReference"] ? ReferenceModel.fromJS(_data["detailsReference"]) : <any>undefined;
            this.detail = _data["detail"] ? NursingInterventionDetailModel.fromJS(_data["detail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NursingInterventionModel {
        data = typeof data === 'object' ? data : {};
        let result = new NursingInterventionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.healthCondition)) {
            data["healthCondition"] = [];
            for (let item of this.healthCondition)
                data["healthCondition"].push(item);
        }
        if (Array.isArray(this.healthConditionReference)) {
            data["healthConditionReference"] = [];
            for (let item of this.healthConditionReference)
                data["healthConditionReference"].push(item.toJSON());
        }
        data["comment"] = this.comment;
        data["detailsReference"] = this.detailsReference ? this.detailsReference.toJSON() : <any>undefined;
        data["detail"] = this.detail ? this.detail.toJSON() : <any>undefined;
        return data;
    }
}

export interface INursingInterventionModel {
    healthCondition?: string[] | undefined;
    healthConditionReference?: ReferenceModel[] | undefined;
    comment?: string | undefined;
    detailsReference?: ReferenceModel | undefined;
    detail?: NursingInterventionDetailModel | undefined;
}

export class NursingInterventionDetailModel implements INursingInterventionDetailModel {
    medicalDevice?: ReferenceModel | undefined;
    intervention?: string | undefined;
    reasons?: ReferenceModel[] | undefined;
    goals?: ReferenceModel[] | undefined;
    timing?: string | undefined;
    location?: ReferenceModel | undefined;
    performers?: ReferenceModel[] | undefined;
    description?: string | undefined;

    constructor(data?: INursingInterventionDetailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicalDevice = _data["medicalDevice"] ? ReferenceModel.fromJS(_data["medicalDevice"]) : <any>undefined;
            this.intervention = _data["intervention"];
            if (Array.isArray(_data["reasons"])) {
                this.reasons = [] as any;
                for (let item of _data["reasons"])
                    this.reasons!.push(ReferenceModel.fromJS(item));
            }
            if (Array.isArray(_data["goals"])) {
                this.goals = [] as any;
                for (let item of _data["goals"])
                    this.goals!.push(ReferenceModel.fromJS(item));
            }
            this.timing = _data["timing"];
            this.location = _data["location"] ? ReferenceModel.fromJS(_data["location"]) : <any>undefined;
            if (Array.isArray(_data["performers"])) {
                this.performers = [] as any;
                for (let item of _data["performers"])
                    this.performers!.push(ReferenceModel.fromJS(item));
            }
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): NursingInterventionDetailModel {
        data = typeof data === 'object' ? data : {};
        let result = new NursingInterventionDetailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicalDevice"] = this.medicalDevice ? this.medicalDevice.toJSON() : <any>undefined;
        data["intervention"] = this.intervention;
        if (Array.isArray(this.reasons)) {
            data["reasons"] = [];
            for (let item of this.reasons)
                data["reasons"].push(item.toJSON());
        }
        if (Array.isArray(this.goals)) {
            data["goals"] = [];
            for (let item of this.goals)
                data["goals"].push(item.toJSON());
        }
        data["timing"] = this.timing;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        if (Array.isArray(this.performers)) {
            data["performers"] = [];
            for (let item of this.performers)
                data["performers"].push(item.toJSON());
        }
        data["description"] = this.description;
        return data;
    }
}

export interface INursingInterventionDetailModel {
    medicalDevice?: ReferenceModel | undefined;
    intervention?: string | undefined;
    reasons?: ReferenceModel[] | undefined;
    goals?: ReferenceModel[] | undefined;
    timing?: string | undefined;
    location?: ReferenceModel | undefined;
    performers?: ReferenceModel[] | undefined;
    description?: string | undefined;
}

export class IdentifierModel implements IIdentifierModel {
    use?: IdentifierUse | undefined;
    type?: string | undefined;
    system?: string | undefined;
    value?: string | undefined;
    period?: PeriodModel | undefined;
    assigner?: string | undefined;

    constructor(data?: IIdentifierModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.use = _data["use"];
            this.type = _data["type"];
            this.system = _data["system"];
            this.value = _data["value"];
            this.period = _data["period"] ? PeriodModel.fromJS(_data["period"]) : <any>undefined;
            this.assigner = _data["assigner"];
        }
    }

    static fromJS(data: any): IdentifierModel {
        data = typeof data === 'object' ? data : {};
        let result = new IdentifierModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["use"] = this.use;
        data["type"] = this.type;
        data["system"] = this.system;
        data["value"] = this.value;
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        data["assigner"] = this.assigner;
        return data;
    }
}

export interface IIdentifierModel {
    use?: IdentifierUse | undefined;
    type?: string | undefined;
    system?: string | undefined;
    value?: string | undefined;
    period?: PeriodModel | undefined;
    assigner?: string | undefined;
}

export enum IdentifierUse {
    Usual = 0,
    Official = 1,
    Temp = 2,
    Secondary = 3,
}

export class HelpFromOthersModel extends ResourceModel implements IHelpFromOthersModel {
    subject?: ReferenceModel | undefined;
    context?: ReferenceModel | undefined;
    authors?: ReferenceModel[] | undefined;
    careTeams?: ReferenceModel[] | undefined;
    activityDetails?: HelpFromOthersActivityDetailModel[] | undefined;

    constructor(data?: IHelpFromOthersModel) {
        super(data);
        this._discriminator = "HelpFromOthersModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            this.context = _data["context"] ? ReferenceModel.fromJS(_data["context"]) : <any>undefined;
            if (Array.isArray(_data["authors"])) {
                this.authors = [] as any;
                for (let item of _data["authors"])
                    this.authors!.push(ReferenceModel.fromJS(item));
            }
            if (Array.isArray(_data["careTeams"])) {
                this.careTeams = [] as any;
                for (let item of _data["careTeams"])
                    this.careTeams!.push(ReferenceModel.fromJS(item));
            }
            if (Array.isArray(_data["activityDetails"])) {
                this.activityDetails = [] as any;
                for (let item of _data["activityDetails"])
                    this.activityDetails!.push(HelpFromOthersActivityDetailModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): HelpFromOthersModel {
        data = typeof data === 'object' ? data : {};
        let result = new HelpFromOthersModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        data["context"] = this.context ? this.context.toJSON() : <any>undefined;
        if (Array.isArray(this.authors)) {
            data["authors"] = [];
            for (let item of this.authors)
                data["authors"].push(item.toJSON());
        }
        if (Array.isArray(this.careTeams)) {
            data["careTeams"] = [];
            for (let item of this.careTeams)
                data["careTeams"].push(item.toJSON());
        }
        if (Array.isArray(this.activityDetails)) {
            data["activityDetails"] = [];
            for (let item of this.activityDetails)
                data["activityDetails"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IHelpFromOthersModel extends IResourceModel {
    subject?: ReferenceModel | undefined;
    context?: ReferenceModel | undefined;
    authors?: ReferenceModel[] | undefined;
    careTeams?: ReferenceModel[] | undefined;
    activityDetails?: HelpFromOthersActivityDetailModel[] | undefined;
}

export class HelpFromOthersActivityDetailModel implements IHelpFromOthersActivityDetailModel {
    type?: HelpType | undefined;
    supportNature?: string | undefined;
    frequency?: string | undefined;
    performers?: ReferenceModel[] | undefined;
    description?: string | undefined;

    constructor(data?: IHelpFromOthersActivityDetailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.supportNature = _data["supportNature"];
            this.frequency = _data["frequency"];
            if (Array.isArray(_data["performers"])) {
                this.performers = [] as any;
                for (let item of _data["performers"])
                    this.performers!.push(ReferenceModel.fromJS(item));
            }
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): HelpFromOthersActivityDetailModel {
        data = typeof data === 'object' ? data : {};
        let result = new HelpFromOthersActivityDetailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["supportNature"] = this.supportNature;
        data["frequency"] = this.frequency;
        if (Array.isArray(this.performers)) {
            data["performers"] = [];
            for (let item of this.performers)
                data["performers"].push(item.toJSON());
        }
        data["description"] = this.description;
        return data;
    }
}

export interface IHelpFromOthersActivityDetailModel {
    type?: HelpType | undefined;
    supportNature?: string | undefined;
    frequency?: string | undefined;
    performers?: ReferenceModel[] | undefined;
    description?: string | undefined;
}

export enum HelpType {
    Unknown = 0,
    HomeCare = 1,
    CaregiverSupport = 2,
}

export class LocationModel extends ResourceModel implements ILocationModel {
    name?: string | undefined;
    telecoms?: TelecomModel[] | undefined;
    address?: AddressModel | undefined;
    managingOrganization?: ReferenceModel | undefined;
    partOfLocation?: ReferenceModel | undefined;

    constructor(data?: ILocationModel) {
        super(data);
        this._discriminator = "LocationModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["telecoms"])) {
                this.telecoms = [] as any;
                for (let item of _data["telecoms"])
                    this.telecoms!.push(TelecomModel.fromJS(item));
            }
            this.address = _data["address"] ? AddressModel.fromJS(_data["address"]) : <any>undefined;
            this.managingOrganization = _data["managingOrganization"] ? ReferenceModel.fromJS(_data["managingOrganization"]) : <any>undefined;
            this.partOfLocation = _data["partOfLocation"] ? ReferenceModel.fromJS(_data["partOfLocation"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): LocationModel {
        data = typeof data === 'object' ? data : {};
        let result = new LocationModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.telecoms)) {
            data["telecoms"] = [];
            for (let item of this.telecoms)
                data["telecoms"].push(item.toJSON());
        }
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["managingOrganization"] = this.managingOrganization ? this.managingOrganization.toJSON() : <any>undefined;
        data["partOfLocation"] = this.partOfLocation ? this.partOfLocation.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ILocationModel extends IResourceModel {
    name?: string | undefined;
    telecoms?: TelecomModel[] | undefined;
    address?: AddressModel | undefined;
    managingOrganization?: ReferenceModel | undefined;
    partOfLocation?: ReferenceModel | undefined;
}

export class MedicationAdministrationModel extends ResourceModel implements IMedicationAdministrationModel {
    agreedDateTime?: string | undefined;
    doubleCheckPerformed?: boolean | undefined;
    medicationTreatmentIdentifierString?: string | undefined;
    deviation?: MedicationAdministrationDeviationModel | undefined;
    status?: MedicationAdministrationStatus | undefined;
    medicationReference?: ReferenceModel | undefined;
    subject?: ReferenceModel | undefined;
    supportingInformation?: ReferenceModel[] | undefined;
    effective?: EffectiveModel | undefined;
    performers?: PerformerModel[] | undefined;
    comments?: CommentModel[] | undefined;
    dosage?: MedicationAdministrationDosageModel | undefined;

    constructor(data?: IMedicationAdministrationModel) {
        super(data);
        this._discriminator = "MedicationAdministrationModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.agreedDateTime = _data["agreedDateTime"];
            this.doubleCheckPerformed = _data["doubleCheckPerformed"];
            this.medicationTreatmentIdentifierString = _data["medicationTreatmentIdentifierString"];
            this.deviation = _data["deviation"] ? MedicationAdministrationDeviationModel.fromJS(_data["deviation"]) : <any>undefined;
            this.status = _data["status"];
            this.medicationReference = _data["medicationReference"] ? ReferenceModel.fromJS(_data["medicationReference"]) : <any>undefined;
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            if (Array.isArray(_data["supportingInformation"])) {
                this.supportingInformation = [] as any;
                for (let item of _data["supportingInformation"])
                    this.supportingInformation!.push(ReferenceModel.fromJS(item));
            }
            this.effective = _data["effective"] ? EffectiveModel.fromJS(_data["effective"]) : <any>undefined;
            if (Array.isArray(_data["performers"])) {
                this.performers = [] as any;
                for (let item of _data["performers"])
                    this.performers!.push(PerformerModel.fromJS(item));
            }
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(CommentModel.fromJS(item));
            }
            this.dosage = _data["dosage"] ? MedicationAdministrationDosageModel.fromJS(_data["dosage"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): MedicationAdministrationModel {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationAdministrationModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agreedDateTime"] = this.agreedDateTime;
        data["doubleCheckPerformed"] = this.doubleCheckPerformed;
        data["medicationTreatmentIdentifierString"] = this.medicationTreatmentIdentifierString;
        data["deviation"] = this.deviation ? this.deviation.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["medicationReference"] = this.medicationReference ? this.medicationReference.toJSON() : <any>undefined;
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        if (Array.isArray(this.supportingInformation)) {
            data["supportingInformation"] = [];
            for (let item of this.supportingInformation)
                data["supportingInformation"].push(item.toJSON());
        }
        data["effective"] = this.effective ? this.effective.toJSON() : <any>undefined;
        if (Array.isArray(this.performers)) {
            data["performers"] = [];
            for (let item of this.performers)
                data["performers"].push(item.toJSON());
        }
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        data["dosage"] = this.dosage ? this.dosage.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IMedicationAdministrationModel extends IResourceModel {
    agreedDateTime?: string | undefined;
    doubleCheckPerformed?: boolean | undefined;
    medicationTreatmentIdentifierString?: string | undefined;
    deviation?: MedicationAdministrationDeviationModel | undefined;
    status?: MedicationAdministrationStatus | undefined;
    medicationReference?: ReferenceModel | undefined;
    subject?: ReferenceModel | undefined;
    supportingInformation?: ReferenceModel[] | undefined;
    effective?: EffectiveModel | undefined;
    performers?: PerformerModel[] | undefined;
    comments?: CommentModel[] | undefined;
    dosage?: MedicationAdministrationDosageModel | undefined;
}

export class MedicationAdministrationDeviationModel implements IMedicationAdministrationDeviationModel {
    deviated?: boolean | undefined;
    reason?: MedicationAdministrationDeviationReason | undefined;

    constructor(data?: IMedicationAdministrationDeviationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviated = _data["deviated"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): MedicationAdministrationDeviationModel {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationAdministrationDeviationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviated"] = this.deviated;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IMedicationAdministrationDeviationModel {
    deviated?: boolean | undefined;
    reason?: MedicationAdministrationDeviationReason | undefined;
}

export enum MedicationAdministrationDeviationReason {
    NoInformation = 0,
    ProductDiscontinued = 1,
    PatientNotAvailable = 2,
    PatientRefuse = 3,
    UnableToUse = 4,
    OrderAborted = 5,
    ForgottenToAdminister = 6,
    AdministrationPerformerNotAvailable = 7,
}

export enum MedicationAdministrationStatus {
    Unknown = 0,
    Completed = 1,
    Cancelled = 2,
    Suspended = 3,
    Aborted = 4,
    Active = 5,
    Interrupted = 6,
    Discontinued = 7,
    NotStarted = 8,
}

export class DosageModel implements IDosageModel {
    routeOfAdministrationString?: string | undefined;
    administeredAmountString?: QuantityModel | undefined;
    administeringSpeed?: InstructionRateModel | undefined;

    constructor(data?: IDosageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.routeOfAdministrationString = _data["routeOfAdministrationString"];
            this.administeredAmountString = _data["administeredAmountString"] ? QuantityModel.fromJS(_data["administeredAmountString"]) : <any>undefined;
            this.administeringSpeed = _data["administeringSpeed"] ? InstructionRateModel.fromJS(_data["administeringSpeed"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DosageModel {
        data = typeof data === 'object' ? data : {};
        let result = new DosageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["routeOfAdministrationString"] = this.routeOfAdministrationString;
        data["administeredAmountString"] = this.administeredAmountString ? this.administeredAmountString.toJSON() : <any>undefined;
        data["administeringSpeed"] = this.administeringSpeed ? this.administeringSpeed.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDosageModel {
    routeOfAdministrationString?: string | undefined;
    administeredAmountString?: QuantityModel | undefined;
    administeringSpeed?: InstructionRateModel | undefined;
}

export class MedicationAdministrationDosageModel extends DosageModel implements IMedicationAdministrationDosageModel {

    constructor(data?: IMedicationAdministrationDosageModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): MedicationAdministrationDosageModel {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationAdministrationDosageModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMedicationAdministrationDosageModel extends IDosageModel {
}

export class QuantityModel implements IQuantityModel {
    value?: number | undefined;
    comparator?: QuantityComparator | undefined;
    unit?: string | undefined;

    constructor(data?: IQuantityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.comparator = _data["comparator"];
            this.unit = _data["unit"];
        }
    }

    static fromJS(data: any): QuantityModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuantityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["comparator"] = this.comparator;
        data["unit"] = this.unit;
        return data;
    }
}

export interface IQuantityModel {
    value?: number | undefined;
    comparator?: QuantityComparator | undefined;
    unit?: string | undefined;
}

export enum QuantityComparator {
    Unknown = 0,
    LessThan = 1,
    LessOrEqual = 2,
    GreaterOrEqual = 3,
    GreaterThan = 4,
}

export class InstructionRateModel implements IInstructionRateModel {
    ratio?: RatioModel | undefined;
    range?: RangeModel | undefined;
    quantity?: QuantityModel | undefined;

    constructor(data?: IInstructionRateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ratio = _data["ratio"] ? RatioModel.fromJS(_data["ratio"]) : <any>undefined;
            this.range = _data["range"] ? RangeModel.fromJS(_data["range"]) : <any>undefined;
            this.quantity = _data["quantity"] ? QuantityModel.fromJS(_data["quantity"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InstructionRateModel {
        data = typeof data === 'object' ? data : {};
        let result = new InstructionRateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ratio"] = this.ratio ? this.ratio.toJSON() : <any>undefined;
        data["range"] = this.range ? this.range.toJSON() : <any>undefined;
        data["quantity"] = this.quantity ? this.quantity.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInstructionRateModel {
    ratio?: RatioModel | undefined;
    range?: RangeModel | undefined;
    quantity?: QuantityModel | undefined;
}

export class RatioModel implements IRatioModel {
    numerator?: QuantityModel | undefined;
    denominator?: QuantityModel | undefined;

    constructor(data?: IRatioModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numerator = _data["numerator"] ? QuantityModel.fromJS(_data["numerator"]) : <any>undefined;
            this.denominator = _data["denominator"] ? QuantityModel.fromJS(_data["denominator"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RatioModel {
        data = typeof data === 'object' ? data : {};
        let result = new RatioModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numerator"] = this.numerator ? this.numerator.toJSON() : <any>undefined;
        data["denominator"] = this.denominator ? this.denominator.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRatioModel {
    numerator?: QuantityModel | undefined;
    denominator?: QuantityModel | undefined;
}

export class RangeModel implements IRangeModel {
    low?: QuantityModel | undefined;
    high?: QuantityModel | undefined;

    constructor(data?: IRangeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.low = _data["low"] ? QuantityModel.fromJS(_data["low"]) : <any>undefined;
            this.high = _data["high"] ? QuantityModel.fromJS(_data["high"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RangeModel {
        data = typeof data === 'object' ? data : {};
        let result = new RangeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["low"] = this.low ? this.low.toJSON() : <any>undefined;
        data["high"] = this.high ? this.high.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRangeModel {
    low?: QuantityModel | undefined;
    high?: QuantityModel | undefined;
}

export class MedicalDeviceProductModel extends ResourceModel implements IMedicalDeviceProductModel {
    deviceIdentifier?: string | undefined;
    productIdentifier?: string | undefined;
    type?: string | undefined;
    description?: string | undefined;
    lotNumber?: string | undefined;
    expirationDate?: string | undefined;
    patient?: ReferenceModel | undefined;
    owner?: ReferenceModel | undefined;
    location?: ReferenceModel | undefined;
    comments?: CommentModel[] | undefined;

    constructor(data?: IMedicalDeviceProductModel) {
        super(data);
        this._discriminator = "MedicalDeviceProductModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.deviceIdentifier = _data["deviceIdentifier"];
            this.productIdentifier = _data["productIdentifier"];
            this.type = _data["type"];
            this.description = _data["description"];
            this.lotNumber = _data["lotNumber"];
            this.expirationDate = _data["expirationDate"];
            this.patient = _data["patient"] ? ReferenceModel.fromJS(_data["patient"]) : <any>undefined;
            this.owner = _data["owner"] ? ReferenceModel.fromJS(_data["owner"]) : <any>undefined;
            this.location = _data["location"] ? ReferenceModel.fromJS(_data["location"]) : <any>undefined;
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(CommentModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): MedicalDeviceProductModel {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalDeviceProductModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceIdentifier"] = this.deviceIdentifier;
        data["productIdentifier"] = this.productIdentifier;
        data["type"] = this.type;
        data["description"] = this.description;
        data["lotNumber"] = this.lotNumber;
        data["expirationDate"] = this.expirationDate;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["owner"] = this.owner ? this.owner.toJSON() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IMedicalDeviceProductModel extends IResourceModel {
    deviceIdentifier?: string | undefined;
    productIdentifier?: string | undefined;
    type?: string | undefined;
    description?: string | undefined;
    lotNumber?: string | undefined;
    expirationDate?: string | undefined;
    patient?: ReferenceModel | undefined;
    owner?: ReferenceModel | undefined;
    location?: ReferenceModel | undefined;
    comments?: CommentModel[] | undefined;
}

export class MedicalDeviceUseModel extends ResourceModel implements IMedicalDeviceUseModel {
    bodySite?: BodySite | undefined;
    comments?: CommentModel[] | undefined;
    device?: ReferenceModel | undefined;
    healthCareProfessional?: ReferenceModel | undefined;
    healthCareProvider?: ReferenceModel | undefined;
    identifiers?: IdentifierModel[] | undefined;
    indications?: ReferenceModel[] | undefined;
    source?: ReferenceModel | undefined;
    subject?: ReferenceModel | undefined;
    whenUsed?: PeriodModel | undefined;
    anatomicLocationString?: string | undefined;

    constructor(data?: IMedicalDeviceUseModel) {
        super(data);
        this._discriminator = "MedicalDeviceUseModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.bodySite = _data["bodySite"];
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(CommentModel.fromJS(item));
            }
            this.device = _data["device"] ? ReferenceModel.fromJS(_data["device"]) : <any>undefined;
            this.healthCareProfessional = _data["healthCareProfessional"] ? ReferenceModel.fromJS(_data["healthCareProfessional"]) : <any>undefined;
            this.healthCareProvider = _data["healthCareProvider"] ? ReferenceModel.fromJS(_data["healthCareProvider"]) : <any>undefined;
            if (Array.isArray(_data["identifiers"])) {
                this.identifiers = [] as any;
                for (let item of _data["identifiers"])
                    this.identifiers!.push(IdentifierModel.fromJS(item));
            }
            if (Array.isArray(_data["indications"])) {
                this.indications = [] as any;
                for (let item of _data["indications"])
                    this.indications!.push(ReferenceModel.fromJS(item));
            }
            this.source = _data["source"] ? ReferenceModel.fromJS(_data["source"]) : <any>undefined;
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            this.whenUsed = _data["whenUsed"] ? PeriodModel.fromJS(_data["whenUsed"]) : <any>undefined;
            this.anatomicLocationString = _data["anatomicLocationString"];
        }
    }

    static override fromJS(data: any): MedicalDeviceUseModel {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalDeviceUseModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bodySite"] = this.bodySite;
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        data["device"] = this.device ? this.device.toJSON() : <any>undefined;
        data["healthCareProfessional"] = this.healthCareProfessional ? this.healthCareProfessional.toJSON() : <any>undefined;
        data["healthCareProvider"] = this.healthCareProvider ? this.healthCareProvider.toJSON() : <any>undefined;
        if (Array.isArray(this.identifiers)) {
            data["identifiers"] = [];
            for (let item of this.identifiers)
                data["identifiers"].push(item.toJSON());
        }
        if (Array.isArray(this.indications)) {
            data["indications"] = [];
            for (let item of this.indications)
                data["indications"].push(item.toJSON());
        }
        data["source"] = this.source ? this.source.toJSON() : <any>undefined;
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        data["whenUsed"] = this.whenUsed ? this.whenUsed.toJSON() : <any>undefined;
        data["anatomicLocationString"] = this.anatomicLocationString;
        super.toJSON(data);
        return data;
    }
}

export interface IMedicalDeviceUseModel extends IResourceModel {
    bodySite?: BodySite | undefined;
    comments?: CommentModel[] | undefined;
    device?: ReferenceModel | undefined;
    healthCareProfessional?: ReferenceModel | undefined;
    healthCareProvider?: ReferenceModel | undefined;
    identifiers?: IdentifierModel[] | undefined;
    indications?: ReferenceModel[] | undefined;
    source?: ReferenceModel | undefined;
    subject?: ReferenceModel | undefined;
    whenUsed?: PeriodModel | undefined;
    anatomicLocationString?: string | undefined;
}

export enum BodySite {
    Unknown = 0,
    Left = 1,
    Right = 2,
    RightAndLeft = 3,
}

export class ObservationBaseModel extends ResourceModel implements IObservationBaseModel {
    effective?: EffectiveModel | undefined;

    constructor(data?: IObservationBaseModel) {
        super(data);
        this._discriminator = "ObservationBaseModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.effective = _data["effective"] ? EffectiveModel.fromJS(_data["effective"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ObservationBaseModel {
        data = typeof data === 'object' ? data : {};
        if (data["resourceTypeDiscriminator"] === "BloodGlucoseModel") {
            let result = new BloodGlucoseModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BloodPressureModel") {
            let result = new BloodPressureModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BodyHeightModel") {
            let result = new BodyHeightModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BodyTemperatureModel") {
            let result = new BodyTemperatureModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BodyWeightModel") {
            let result = new BodyWeightModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "FamilySituationChildModel") {
            let result = new FamilySituationChildModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "FamilySituationModel") {
            let result = new FamilySituationModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "GeneralMeasurementModel") {
            let result = new GeneralMeasurementModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "HeartRateModel") {
            let result = new HeartRateModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "ZibLaboratoryTestResult") {
            let result = new ZibLaboratoryTestResult();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "OxygenSaturationModel") {
            let result = new OxygenSaturationModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "PulseRateModel") {
            let result = new PulseRateModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "AlcoholUseModel") {
            let result = new AlcoholUseModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "DrugUseModel") {
            let result = new DrugUseModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "FunctionalOrMentalStatusModel") {
            let result = new FunctionalOrMentalStatusModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "LivingSituationModel") {
            let result = new LivingSituationModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "TobaccoUseModel") {
            let result = new TobaccoUseModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "ParticipationInSocietyModel") {
            let result = new ParticipationInSocietyModel();
            result.init(data);
            return result;
        }
        let result = new ObservationBaseModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["effective"] = this.effective ? this.effective.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IObservationBaseModel extends IResourceModel {
    effective?: EffectiveModel | undefined;
}

export class BloodGlucoseModel extends ObservationBaseModel implements IBloodGlucoseModel {
    eventTiming?: EventTimingModel | undefined;
    type?: BloodGlucoseType | undefined;
    value?: QuantityModel | undefined;
    subject?: ReferenceModel | undefined;
    performers?: ReferenceModel[] | undefined;

    constructor(data?: IBloodGlucoseModel) {
        super(data);
        this._discriminator = "BloodGlucoseModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.eventTiming = _data["eventTiming"] ? EventTimingModel.fromJS(_data["eventTiming"]) : <any>undefined;
            this.type = _data["type"];
            this.value = _data["value"] ? QuantityModel.fromJS(_data["value"]) : <any>undefined;
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            if (Array.isArray(_data["performers"])) {
                this.performers = [] as any;
                for (let item of _data["performers"])
                    this.performers!.push(ReferenceModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): BloodGlucoseModel {
        data = typeof data === 'object' ? data : {};
        let result = new BloodGlucoseModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventTiming"] = this.eventTiming ? this.eventTiming.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        if (Array.isArray(this.performers)) {
            data["performers"] = [];
            for (let item of this.performers)
                data["performers"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IBloodGlucoseModel extends IObservationBaseModel {
    eventTiming?: EventTimingModel | undefined;
    type?: BloodGlucoseType | undefined;
    value?: QuantityModel | undefined;
    subject?: ReferenceModel | undefined;
    performers?: ReferenceModel[] | undefined;
}

export class EventTimingModel implements IEventTimingModel {
    event?: EventTimingEvent | undefined;
    offset?: QuantityModel | undefined;
    otherEvent?: string | undefined;

    constructor(data?: IEventTimingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.event = _data["event"];
            this.offset = _data["offset"] ? QuantityModel.fromJS(_data["offset"]) : <any>undefined;
            this.otherEvent = _data["otherEvent"];
        }
    }

    static fromJS(data: any): EventTimingModel {
        data = typeof data === 'object' ? data : {};
        let result = new EventTimingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["event"] = this.event;
        data["offset"] = this.offset ? this.offset.toJSON() : <any>undefined;
        data["otherEvent"] = this.otherEvent;
        return data;
    }
}

export interface IEventTimingModel {
    event?: EventTimingEvent | undefined;
    offset?: QuantityModel | undefined;
    otherEvent?: string | undefined;
}

export enum EventTimingEvent {
    Unknown = 0,
    BeforeMeal = 1,
    BeforeLunch = 2,
    BeforeBreakfast = 3,
    BeforeDinner = 4,
    Meal = 5,
    Lunch = 6,
    Breakfast = 7,
    Dinner = 8,
    BeforeExtendedSleep = 9,
    BetweenMeals = 10,
    BetweenLunchAndDinner = 11,
    BetweenBreakfastAndLunch = 12,
    BetweenDinnerAndSleep = 13,
    AfterMeal = 14,
    AfterLunch = 15,
    AfterBreakfast = 16,
    AfterDinner = 17,
    WakingUpFromExtendedSleep = 18,
}

export enum BloodGlucoseType {
    Unknown = 0,
    Fasting = 1,
    General = 2,
    PostMeal = 3,
    PostDiner = 4,
    PostLunch = 5,
    PostBreakfast = 6,
    BeforeLunch = 7,
    BeforeNight = 8,
    BeforeDiner = 9,
}

export class BloodPressureModel extends ObservationBaseModel implements IBloodPressureModel {
    diagnosticDetermination?: string | undefined;
    comment?: string | undefined;
    bodySite?: BloodPressureBodySite | undefined;
    measuringMethod?: MeasuringMethod | undefined;
    subject?: ReferenceModel | undefined;
    performers?: ReferenceModel[] | undefined;
    systolic?: QuantityModel | undefined;
    diastolic?: QuantityModel | undefined;
    average?: QuantityModel | undefined;
    diastolicEndpoint?: DiastolicEndpoint | undefined;
    cuffType?: CuffType | undefined;
    bodyPosition?: BodyPosition | undefined;

    constructor(data?: IBloodPressureModel) {
        super(data);
        this._discriminator = "BloodPressureModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.diagnosticDetermination = _data["diagnosticDetermination"];
            this.comment = _data["comment"];
            this.bodySite = _data["bodySite"];
            this.measuringMethod = _data["measuringMethod"];
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            if (Array.isArray(_data["performers"])) {
                this.performers = [] as any;
                for (let item of _data["performers"])
                    this.performers!.push(ReferenceModel.fromJS(item));
            }
            this.systolic = _data["systolic"] ? QuantityModel.fromJS(_data["systolic"]) : <any>undefined;
            this.diastolic = _data["diastolic"] ? QuantityModel.fromJS(_data["diastolic"]) : <any>undefined;
            this.average = _data["average"] ? QuantityModel.fromJS(_data["average"]) : <any>undefined;
            this.diastolicEndpoint = _data["diastolicEndpoint"];
            this.cuffType = _data["cuffType"];
            this.bodyPosition = _data["bodyPosition"];
        }
    }

    static override fromJS(data: any): BloodPressureModel {
        data = typeof data === 'object' ? data : {};
        let result = new BloodPressureModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagnosticDetermination"] = this.diagnosticDetermination;
        data["comment"] = this.comment;
        data["bodySite"] = this.bodySite;
        data["measuringMethod"] = this.measuringMethod;
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        if (Array.isArray(this.performers)) {
            data["performers"] = [];
            for (let item of this.performers)
                data["performers"].push(item.toJSON());
        }
        data["systolic"] = this.systolic ? this.systolic.toJSON() : <any>undefined;
        data["diastolic"] = this.diastolic ? this.diastolic.toJSON() : <any>undefined;
        data["average"] = this.average ? this.average.toJSON() : <any>undefined;
        data["diastolicEndpoint"] = this.diastolicEndpoint;
        data["cuffType"] = this.cuffType;
        data["bodyPosition"] = this.bodyPosition;
        super.toJSON(data);
        return data;
    }
}

export interface IBloodPressureModel extends IObservationBaseModel {
    diagnosticDetermination?: string | undefined;
    comment?: string | undefined;
    bodySite?: BloodPressureBodySite | undefined;
    measuringMethod?: MeasuringMethod | undefined;
    subject?: ReferenceModel | undefined;
    performers?: ReferenceModel[] | undefined;
    systolic?: QuantityModel | undefined;
    diastolic?: QuantityModel | undefined;
    average?: QuantityModel | undefined;
    diastolicEndpoint?: DiastolicEndpoint | undefined;
    cuffType?: CuffType | undefined;
    bodyPosition?: BodyPosition | undefined;
}

export enum BloodPressureBodySite {
    UpperArm = 0,
    UpperArmRight = 1,
    UpperArmLeft = 2,
    Thigh = 3,
    ThighRight = 4,
    ThighLeft = 5,
    Wrist = 6,
    WristRight = 7,
    WristLeft = 8,
    Finger = 9,
    Ankle = 10,
    AnkleRight = 11,
    AnkleLeft = 12,
}

export enum MeasuringMethod {
    Unknown = 0,
    NonInvasive = 1,
    Invasive = 2,
}

export enum DiastolicEndpoint {
    Unknown = 0,
    Phase4 = 1,
    Phase5 = 2,
}

export enum CuffType {
    Unknown = 0,
    Standard = 1,
    Large = 2,
    Small = 3,
    ExtraLarge = 4,
    Child = 5,
    YoungChild = 6,
    Neonate = 7,
}

export enum BodyPosition {
    Unknown = 0,
    Orthostatic = 1,
    Recumbent = 2,
    Sitting = 3,
    Tilt = 4,
    Trendelenburg = 5,
}

export class BodyHeightModel extends ObservationBaseModel implements IBodyHeightModel {
    diagnosticDetermination?: string | undefined;
    comment?: string | undefined;
    performers?: ReferenceModel[] | undefined;
    subject?: ReferenceModel | undefined;
    type?: BodyHeightType | undefined;
    value?: QuantityModel | undefined;

    constructor(data?: IBodyHeightModel) {
        super(data);
        this._discriminator = "BodyHeightModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.diagnosticDetermination = _data["diagnosticDetermination"];
            this.comment = _data["comment"];
            if (Array.isArray(_data["performers"])) {
                this.performers = [] as any;
                for (let item of _data["performers"])
                    this.performers!.push(ReferenceModel.fromJS(item));
            }
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            this.type = _data["type"];
            this.value = _data["value"] ? QuantityModel.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): BodyHeightModel {
        data = typeof data === 'object' ? data : {};
        let result = new BodyHeightModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagnosticDetermination"] = this.diagnosticDetermination;
        data["comment"] = this.comment;
        if (Array.isArray(this.performers)) {
            data["performers"] = [];
            for (let item of this.performers)
                data["performers"].push(item.toJSON());
        }
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IBodyHeightModel extends IObservationBaseModel {
    diagnosticDetermination?: string | undefined;
    comment?: string | undefined;
    performers?: ReferenceModel[] | undefined;
    subject?: ReferenceModel | undefined;
    type?: BodyHeightType | undefined;
    value?: QuantityModel | undefined;
}

export enum BodyHeightType {
    Unknown = 0,
    Lying = 1,
    Standing = 2,
}

export class BodyTemperatureModel extends ObservationBaseModel implements IBodyTemperatureModel {
    diagnosticDetermination?: string | undefined;
    comment?: string | undefined;
    performers?: ReferenceModel[] | undefined;
    subject?: ReferenceModel | undefined;
    type?: TemperatureType | undefined;
    value?: ValueModel | undefined;
    context?: ReferenceModel | undefined;
    bodySite?: string | undefined;

    constructor(data?: IBodyTemperatureModel) {
        super(data);
        this._discriminator = "BodyTemperatureModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.diagnosticDetermination = _data["diagnosticDetermination"];
            this.comment = _data["comment"];
            if (Array.isArray(_data["performers"])) {
                this.performers = [] as any;
                for (let item of _data["performers"])
                    this.performers!.push(ReferenceModel.fromJS(item));
            }
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            this.type = _data["type"];
            this.value = _data["value"] ? ValueModel.fromJS(_data["value"]) : <any>undefined;
            this.context = _data["context"] ? ReferenceModel.fromJS(_data["context"]) : <any>undefined;
            this.bodySite = _data["bodySite"];
        }
    }

    static override fromJS(data: any): BodyTemperatureModel {
        data = typeof data === 'object' ? data : {};
        let result = new BodyTemperatureModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagnosticDetermination"] = this.diagnosticDetermination;
        data["comment"] = this.comment;
        if (Array.isArray(this.performers)) {
            data["performers"] = [];
            for (let item of this.performers)
                data["performers"].push(item.toJSON());
        }
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        data["context"] = this.context ? this.context.toJSON() : <any>undefined;
        data["bodySite"] = this.bodySite;
        super.toJSON(data);
        return data;
    }
}

export interface IBodyTemperatureModel extends IObservationBaseModel {
    diagnosticDetermination?: string | undefined;
    comment?: string | undefined;
    performers?: ReferenceModel[] | undefined;
    subject?: ReferenceModel | undefined;
    type?: TemperatureType | undefined;
    value?: ValueModel | undefined;
    context?: ReferenceModel | undefined;
    bodySite?: string | undefined;
}

export enum TemperatureType {
    Unknown = 0,
    Rectal = 1,
    Oral = 2,
    Axillary = 3,
    Groin = 4,
    Tympanic = 5,
    Forehead = 6,
    Vaginal = 7,
    Bladder = 8,
    Core = 9,
}

export class ValueModel implements IValueModel {
    attachment?: AttachmentModel | undefined;
    codeableConceptString?: string | undefined;
    confirmation?: boolean | undefined;
    dateTime?: string | undefined;
    period?: PeriodModel | undefined;
    quantity?: QuantityModel | undefined;
    range?: RangeModel | undefined;
    ratio?: RatioModel | undefined;
    sampledData?: SampledDataModel | undefined;
    text?: string | undefined;
    time?: string | undefined;

    constructor(data?: IValueModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attachment = _data["attachment"] ? AttachmentModel.fromJS(_data["attachment"]) : <any>undefined;
            this.codeableConceptString = _data["codeableConceptString"];
            this.confirmation = _data["confirmation"];
            this.dateTime = _data["dateTime"];
            this.period = _data["period"] ? PeriodModel.fromJS(_data["period"]) : <any>undefined;
            this.quantity = _data["quantity"] ? QuantityModel.fromJS(_data["quantity"]) : <any>undefined;
            this.range = _data["range"] ? RangeModel.fromJS(_data["range"]) : <any>undefined;
            this.ratio = _data["ratio"] ? RatioModel.fromJS(_data["ratio"]) : <any>undefined;
            this.sampledData = _data["sampledData"] ? SampledDataModel.fromJS(_data["sampledData"]) : <any>undefined;
            this.text = _data["text"];
            this.time = _data["time"];
        }
    }

    static fromJS(data: any): ValueModel {
        data = typeof data === 'object' ? data : {};
        let result = new ValueModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachment"] = this.attachment ? this.attachment.toJSON() : <any>undefined;
        data["codeableConceptString"] = this.codeableConceptString;
        data["confirmation"] = this.confirmation;
        data["dateTime"] = this.dateTime;
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        data["quantity"] = this.quantity ? this.quantity.toJSON() : <any>undefined;
        data["range"] = this.range ? this.range.toJSON() : <any>undefined;
        data["ratio"] = this.ratio ? this.ratio.toJSON() : <any>undefined;
        data["sampledData"] = this.sampledData ? this.sampledData.toJSON() : <any>undefined;
        data["text"] = this.text;
        data["time"] = this.time;
        return data;
    }
}

export interface IValueModel {
    attachment?: AttachmentModel | undefined;
    codeableConceptString?: string | undefined;
    confirmation?: boolean | undefined;
    dateTime?: string | undefined;
    period?: PeriodModel | undefined;
    quantity?: QuantityModel | undefined;
    range?: RangeModel | undefined;
    ratio?: RatioModel | undefined;
    sampledData?: SampledDataModel | undefined;
    text?: string | undefined;
    time?: string | undefined;
}

export class AttachmentModel implements IAttachmentModel {
    contentType?: string | undefined;
    language?: string | undefined;
    data?: string | undefined;
    url?: string | undefined;
    size?: number | undefined;
    hash?: string | undefined;
    title?: string | undefined;
    creationDateTime?: string | undefined;

    constructor(data?: IAttachmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contentType = _data["contentType"];
            this.language = _data["language"];
            this.data = _data["data"];
            this.url = _data["url"];
            this.size = _data["size"];
            this.hash = _data["hash"];
            this.title = _data["title"];
            this.creationDateTime = _data["creationDateTime"];
        }
    }

    static fromJS(data: any): AttachmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentType"] = this.contentType;
        data["language"] = this.language;
        data["data"] = this.data;
        data["url"] = this.url;
        data["size"] = this.size;
        data["hash"] = this.hash;
        data["title"] = this.title;
        data["creationDateTime"] = this.creationDateTime;
        return data;
    }
}

export interface IAttachmentModel {
    contentType?: string | undefined;
    language?: string | undefined;
    data?: string | undefined;
    url?: string | undefined;
    size?: number | undefined;
    hash?: string | undefined;
    title?: string | undefined;
    creationDateTime?: string | undefined;
}

export class SampledDataModel implements ISampledDataModel {
    origin?: QuantityModel | undefined;
    period?: number | undefined;
    factor?: number | undefined;
    lowerLimit?: number | undefined;
    upperLimit?: number | undefined;
    dimensions?: number | undefined;
    data?: string | undefined;

    constructor(data?: ISampledDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.origin = _data["origin"] ? QuantityModel.fromJS(_data["origin"]) : <any>undefined;
            this.period = _data["period"];
            this.factor = _data["factor"];
            this.lowerLimit = _data["lowerLimit"];
            this.upperLimit = _data["upperLimit"];
            this.dimensions = _data["dimensions"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): SampledDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new SampledDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["period"] = this.period;
        data["factor"] = this.factor;
        data["lowerLimit"] = this.lowerLimit;
        data["upperLimit"] = this.upperLimit;
        data["dimensions"] = this.dimensions;
        data["data"] = this.data;
        return data;
    }
}

export interface ISampledDataModel {
    origin?: QuantityModel | undefined;
    period?: number | undefined;
    factor?: number | undefined;
    lowerLimit?: number | undefined;
    upperLimit?: number | undefined;
    dimensions?: number | undefined;
    data?: string | undefined;
}

export class BodyWeightModel extends ObservationBaseModel implements IBodyWeightModel {
    diagnosticDetermination?: string | undefined;
    comment?: string | undefined;
    performers?: ReferenceModel[] | undefined;
    subject?: ReferenceModel | undefined;
    value?: QuantityModel | undefined;
    clothingCode?: ClothingCode | undefined;

    constructor(data?: IBodyWeightModel) {
        super(data);
        this._discriminator = "BodyWeightModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.diagnosticDetermination = _data["diagnosticDetermination"];
            this.comment = _data["comment"];
            if (Array.isArray(_data["performers"])) {
                this.performers = [] as any;
                for (let item of _data["performers"])
                    this.performers!.push(ReferenceModel.fromJS(item));
            }
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            this.value = _data["value"] ? QuantityModel.fromJS(_data["value"]) : <any>undefined;
            this.clothingCode = _data["clothingCode"];
        }
    }

    static override fromJS(data: any): BodyWeightModel {
        data = typeof data === 'object' ? data : {};
        let result = new BodyWeightModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagnosticDetermination"] = this.diagnosticDetermination;
        data["comment"] = this.comment;
        if (Array.isArray(this.performers)) {
            data["performers"] = [];
            for (let item of this.performers)
                data["performers"].push(item.toJSON());
        }
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        data["clothingCode"] = this.clothingCode;
        super.toJSON(data);
        return data;
    }
}

export interface IBodyWeightModel extends IObservationBaseModel {
    diagnosticDetermination?: string | undefined;
    comment?: string | undefined;
    performers?: ReferenceModel[] | undefined;
    subject?: ReferenceModel | undefined;
    value?: QuantityModel | undefined;
    clothingCode?: ClothingCode | undefined;
}

export enum ClothingCode {
    Unknown = 0,
    Undressed = 1,
    MinimalDressed = 2,
    FullyDressed = 3,
    Diaper = 4,
}

export class FamilySituationChildModel extends ObservationBaseModel implements IFamilySituationChildModel {
    subject?: ReferenceModel | undefined;
    context?: ReferenceModel | undefined;
    performers?: ReferenceModel[] | undefined;
    comment?: string | undefined;
    composition?: FamilyCompositionChild | undefined;
    numberOfSiblings?: QuantityModel | undefined;
    parentCarerReferences?: ReferenceModel[] | undefined;
    children?: FamilySituationChildInformationModel[] | undefined;
    siblings?: FamilySituationChildSiblingInformationModel[] | undefined;

    constructor(data?: IFamilySituationChildModel) {
        super(data);
        this._discriminator = "FamilySituationChildModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            this.context = _data["context"] ? ReferenceModel.fromJS(_data["context"]) : <any>undefined;
            if (Array.isArray(_data["performers"])) {
                this.performers = [] as any;
                for (let item of _data["performers"])
                    this.performers!.push(ReferenceModel.fromJS(item));
            }
            this.comment = _data["comment"];
            this.composition = _data["composition"];
            this.numberOfSiblings = _data["numberOfSiblings"] ? QuantityModel.fromJS(_data["numberOfSiblings"]) : <any>undefined;
            if (Array.isArray(_data["parentCarerReferences"])) {
                this.parentCarerReferences = [] as any;
                for (let item of _data["parentCarerReferences"])
                    this.parentCarerReferences!.push(ReferenceModel.fromJS(item));
            }
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(FamilySituationChildInformationModel.fromJS(item));
            }
            if (Array.isArray(_data["siblings"])) {
                this.siblings = [] as any;
                for (let item of _data["siblings"])
                    this.siblings!.push(FamilySituationChildSiblingInformationModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): FamilySituationChildModel {
        data = typeof data === 'object' ? data : {};
        let result = new FamilySituationChildModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        data["context"] = this.context ? this.context.toJSON() : <any>undefined;
        if (Array.isArray(this.performers)) {
            data["performers"] = [];
            for (let item of this.performers)
                data["performers"].push(item.toJSON());
        }
        data["comment"] = this.comment;
        data["composition"] = this.composition;
        data["numberOfSiblings"] = this.numberOfSiblings ? this.numberOfSiblings.toJSON() : <any>undefined;
        if (Array.isArray(this.parentCarerReferences)) {
            data["parentCarerReferences"] = [];
            for (let item of this.parentCarerReferences)
                data["parentCarerReferences"].push(item.toJSON());
        }
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        if (Array.isArray(this.siblings)) {
            data["siblings"] = [];
            for (let item of this.siblings)
                data["siblings"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IFamilySituationChildModel extends IObservationBaseModel {
    subject?: ReferenceModel | undefined;
    context?: ReferenceModel | undefined;
    performers?: ReferenceModel[] | undefined;
    comment?: string | undefined;
    composition?: FamilyCompositionChild | undefined;
    numberOfSiblings?: QuantityModel | undefined;
    parentCarerReferences?: ReferenceModel[] | undefined;
    children?: FamilySituationChildInformationModel[] | undefined;
    siblings?: FamilySituationChildSiblingInformationModel[] | undefined;
}

export enum FamilyCompositionChild {
    Other = 0,
    WithMother = 1,
    WithFather = 2,
    WithGrandparents = 3,
    WithParents = 4,
    WithFosterParents = 5,
    WithRelatives = 6,
    InSupportedHome = 7,
    InInstitutionForDisabledCare = 8,
    InInstitutionForMentalHealthCare = 9,
    InChildrensHome = 10,
    InBoardingSchool = 11,
}

export class FamilySituationChildInformationModel implements IFamilySituationChildInformationModel {
    contactPerson?: ReferenceModel | undefined;
    dateOfBirth?: string | undefined;
    livingAtHome?: boolean | undefined;

    constructor(data?: IFamilySituationChildInformationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactPerson = _data["contactPerson"] ? ReferenceModel.fromJS(_data["contactPerson"]) : <any>undefined;
            this.dateOfBirth = _data["dateOfBirth"];
            this.livingAtHome = _data["livingAtHome"];
        }
    }

    static fromJS(data: any): FamilySituationChildInformationModel {
        data = typeof data === 'object' ? data : {};
        let result = new FamilySituationChildInformationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactPerson"] = this.contactPerson ? this.contactPerson.toJSON() : <any>undefined;
        data["dateOfBirth"] = this.dateOfBirth;
        data["livingAtHome"] = this.livingAtHome;
        return data;
    }
}

export interface IFamilySituationChildInformationModel {
    contactPerson?: ReferenceModel | undefined;
    dateOfBirth?: string | undefined;
    livingAtHome?: boolean | undefined;
}

export class FamilySituationChildSiblingInformationModel implements IFamilySituationChildSiblingInformationModel {
    contactPerson?: ReferenceModel | undefined;
    dateOfBirth?: string | undefined;

    constructor(data?: IFamilySituationChildSiblingInformationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactPerson = _data["contactPerson"] ? ReferenceModel.fromJS(_data["contactPerson"]) : <any>undefined;
            this.dateOfBirth = _data["dateOfBirth"];
        }
    }

    static fromJS(data: any): FamilySituationChildSiblingInformationModel {
        data = typeof data === 'object' ? data : {};
        let result = new FamilySituationChildSiblingInformationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactPerson"] = this.contactPerson ? this.contactPerson.toJSON() : <any>undefined;
        data["dateOfBirth"] = this.dateOfBirth;
        return data;
    }
}

export interface IFamilySituationChildSiblingInformationModel {
    contactPerson?: ReferenceModel | undefined;
    dateOfBirth?: string | undefined;
}

export class FamilySituationModel extends ObservationBaseModel implements IFamilySituationModel {
    subject?: ReferenceModel | undefined;
    context?: ReferenceModel | undefined;
    performers?: ReferenceModel[] | undefined;
    comment?: string | undefined;
    composition?: FamilyComposition | undefined;
    numberOfChildren?: QuantityModel | undefined;
    numberOfChildrenLivingAtHome?: QuantityModel | undefined;
    careResponsibility?: string[] | undefined;
    children?: FamilySituationChildInformationModel[] | undefined;

    constructor(data?: IFamilySituationModel) {
        super(data);
        this._discriminator = "FamilySituationModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            this.context = _data["context"] ? ReferenceModel.fromJS(_data["context"]) : <any>undefined;
            if (Array.isArray(_data["performers"])) {
                this.performers = [] as any;
                for (let item of _data["performers"])
                    this.performers!.push(ReferenceModel.fromJS(item));
            }
            this.comment = _data["comment"];
            this.composition = _data["composition"];
            this.numberOfChildren = _data["numberOfChildren"] ? QuantityModel.fromJS(_data["numberOfChildren"]) : <any>undefined;
            this.numberOfChildrenLivingAtHome = _data["numberOfChildrenLivingAtHome"] ? QuantityModel.fromJS(_data["numberOfChildrenLivingAtHome"]) : <any>undefined;
            if (Array.isArray(_data["careResponsibility"])) {
                this.careResponsibility = [] as any;
                for (let item of _data["careResponsibility"])
                    this.careResponsibility!.push(item);
            }
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(FamilySituationChildInformationModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): FamilySituationModel {
        data = typeof data === 'object' ? data : {};
        let result = new FamilySituationModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        data["context"] = this.context ? this.context.toJSON() : <any>undefined;
        if (Array.isArray(this.performers)) {
            data["performers"] = [];
            for (let item of this.performers)
                data["performers"].push(item.toJSON());
        }
        data["comment"] = this.comment;
        data["composition"] = this.composition;
        data["numberOfChildren"] = this.numberOfChildren ? this.numberOfChildren.toJSON() : <any>undefined;
        data["numberOfChildrenLivingAtHome"] = this.numberOfChildrenLivingAtHome ? this.numberOfChildrenLivingAtHome.toJSON() : <any>undefined;
        if (Array.isArray(this.careResponsibility)) {
            data["careResponsibility"] = [];
            for (let item of this.careResponsibility)
                data["careResponsibility"].push(item);
        }
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IFamilySituationModel extends IObservationBaseModel {
    subject?: ReferenceModel | undefined;
    context?: ReferenceModel | undefined;
    performers?: ReferenceModel[] | undefined;
    comment?: string | undefined;
    composition?: FamilyComposition | undefined;
    numberOfChildren?: QuantityModel | undefined;
    numberOfChildrenLivingAtHome?: QuantityModel | undefined;
    careResponsibility?: string[] | undefined;
    children?: FamilySituationChildInformationModel[] | undefined;
}

export enum FamilyComposition {
    Other = 0,
    Alone = 1,
    WithPartner = 2,
    WithUnderageChildren = 3,
    WithAdultChildren = 4,
    WithParents = 5,
    WithRelatives = 6,
    WithFriends = 7,
}

export class GeneralMeasurementModel extends ObservationBaseModel implements IGeneralMeasurementModel {
    status?: ObservationResultStatus | undefined;
    researchCodeString?: string | undefined;
    subject?: ReferenceModel | undefined;
    performers?: ReferenceModel[] | undefined;
    value?: ValueModel | undefined;
    comment?: string | undefined;
    measuringMethod?: string | undefined;
    relatedMeasurements?: GeneralMeasurementRelatedModel[] | undefined;
    components?: GeneralMeasurementComponentModel[] | undefined;

    constructor(data?: IGeneralMeasurementModel) {
        super(data);
        this._discriminator = "GeneralMeasurementModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
            this.researchCodeString = _data["researchCodeString"];
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            if (Array.isArray(_data["performers"])) {
                this.performers = [] as any;
                for (let item of _data["performers"])
                    this.performers!.push(ReferenceModel.fromJS(item));
            }
            this.value = _data["value"] ? ValueModel.fromJS(_data["value"]) : <any>undefined;
            this.comment = _data["comment"];
            this.measuringMethod = _data["measuringMethod"];
            if (Array.isArray(_data["relatedMeasurements"])) {
                this.relatedMeasurements = [] as any;
                for (let item of _data["relatedMeasurements"])
                    this.relatedMeasurements!.push(GeneralMeasurementRelatedModel.fromJS(item));
            }
            if (Array.isArray(_data["components"])) {
                this.components = [] as any;
                for (let item of _data["components"])
                    this.components!.push(GeneralMeasurementComponentModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GeneralMeasurementModel {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralMeasurementModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["researchCodeString"] = this.researchCodeString;
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        if (Array.isArray(this.performers)) {
            data["performers"] = [];
            for (let item of this.performers)
                data["performers"].push(item.toJSON());
        }
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        data["comment"] = this.comment;
        data["measuringMethod"] = this.measuringMethod;
        if (Array.isArray(this.relatedMeasurements)) {
            data["relatedMeasurements"] = [];
            for (let item of this.relatedMeasurements)
                data["relatedMeasurements"].push(item.toJSON());
        }
        if (Array.isArray(this.components)) {
            data["components"] = [];
            for (let item of this.components)
                data["components"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGeneralMeasurementModel extends IObservationBaseModel {
    status?: ObservationResultStatus | undefined;
    researchCodeString?: string | undefined;
    subject?: ReferenceModel | undefined;
    performers?: ReferenceModel[] | undefined;
    value?: ValueModel | undefined;
    comment?: string | undefined;
    measuringMethod?: string | undefined;
    relatedMeasurements?: GeneralMeasurementRelatedModel[] | undefined;
    components?: GeneralMeasurementComponentModel[] | undefined;
}

export enum ObservationResultStatus {
    Unknown = 0,
    Pending = 1,
    Preliminary = 2,
    Final = 3,
    Appended = 4,
    Corrected = 5,
}

export class GeneralMeasurementRelatedModel implements IGeneralMeasurementRelatedModel {
    type?: string | undefined;
    target?: ReferenceModel | undefined;

    constructor(data?: IGeneralMeasurementRelatedModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.target = _data["target"] ? ReferenceModel.fromJS(_data["target"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GeneralMeasurementRelatedModel {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralMeasurementRelatedModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["target"] = this.target ? this.target.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGeneralMeasurementRelatedModel {
    type?: string | undefined;
    target?: ReferenceModel | undefined;
}

export class GeneralMeasurementComponentModel implements IGeneralMeasurementComponentModel {
    codeString?: string | undefined;
    value?: ValueModel | undefined;

    constructor(data?: IGeneralMeasurementComponentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeString = _data["codeString"];
            this.value = _data["value"] ? ValueModel.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GeneralMeasurementComponentModel {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralMeasurementComponentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeString"] = this.codeString;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGeneralMeasurementComponentModel {
    codeString?: string | undefined;
    value?: ValueModel | undefined;
}

export class HeartRateModel extends ObservationBaseModel implements IHeartRateModel {
    diagnosticDetermination?: string | undefined;
    subject?: ReferenceModel | undefined;
    performers?: ReferenceModel[] | undefined;
    value?: QuantityModel | undefined;
    regularity?: HeartbeatRegularity | undefined;
    comment?: string | undefined;
    measuringMethod?: HeartbeatMeasuringMethod | undefined;

    constructor(data?: IHeartRateModel) {
        super(data);
        this._discriminator = "HeartRateModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.diagnosticDetermination = _data["diagnosticDetermination"];
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            if (Array.isArray(_data["performers"])) {
                this.performers = [] as any;
                for (let item of _data["performers"])
                    this.performers!.push(ReferenceModel.fromJS(item));
            }
            this.value = _data["value"] ? QuantityModel.fromJS(_data["value"]) : <any>undefined;
            this.regularity = _data["regularity"];
            this.comment = _data["comment"];
            this.measuringMethod = _data["measuringMethod"];
        }
    }

    static override fromJS(data: any): HeartRateModel {
        data = typeof data === 'object' ? data : {};
        let result = new HeartRateModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagnosticDetermination"] = this.diagnosticDetermination;
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        if (Array.isArray(this.performers)) {
            data["performers"] = [];
            for (let item of this.performers)
                data["performers"].push(item.toJSON());
        }
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        data["regularity"] = this.regularity;
        data["comment"] = this.comment;
        data["measuringMethod"] = this.measuringMethod;
        super.toJSON(data);
        return data;
    }
}

export interface IHeartRateModel extends IObservationBaseModel {
    diagnosticDetermination?: string | undefined;
    subject?: ReferenceModel | undefined;
    performers?: ReferenceModel[] | undefined;
    value?: QuantityModel | undefined;
    regularity?: HeartbeatRegularity | undefined;
    comment?: string | undefined;
    measuringMethod?: HeartbeatMeasuringMethod | undefined;
}

export enum HeartbeatRegularity {
    Unknown = 0,
    Regular = 1,
    Irregular = 2,
}

export enum HeartbeatMeasuringMethod {
    Unknown = 0,
    Palpation = 1,
    Auscultation = 2,
    CardiacMonitoring = 3,
    Ecg = 4,
}

export class ZibLaboratoryTestResult extends ObservationBaseModel implements IZibLaboratoryTestResult {
    basedOn?: ReferenceModel[] | undefined;
    status?: LaboratoryTestResultStatus | undefined;
    type?: ResultType | undefined;
    code?: string | undefined;
    name?: string | undefined;
    subject?: ReferenceModel | undefined;
    context?: ReferenceModel | undefined;
    performers?: ReferenceModel[] | undefined;
    value?: ValueModel | undefined;
    interpretation?: Interpretation | undefined;
    comment?: string | undefined;
    method?: string | undefined;
    specimen?: ReferenceModel | undefined;
    device?: ReferenceModel | undefined;
    reference?: RangeModel | undefined;
    related?: ReferenceModel[] | undefined;
    components?: LaboratoryTestResultComponent[] | undefined;

    constructor(data?: IZibLaboratoryTestResult) {
        super(data);
        this._discriminator = "ZibLaboratoryTestResult";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["basedOn"])) {
                this.basedOn = [] as any;
                for (let item of _data["basedOn"])
                    this.basedOn!.push(ReferenceModel.fromJS(item));
            }
            this.status = _data["status"];
            this.type = _data["type"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            this.context = _data["context"] ? ReferenceModel.fromJS(_data["context"]) : <any>undefined;
            if (Array.isArray(_data["performers"])) {
                this.performers = [] as any;
                for (let item of _data["performers"])
                    this.performers!.push(ReferenceModel.fromJS(item));
            }
            this.value = _data["value"] ? ValueModel.fromJS(_data["value"]) : <any>undefined;
            this.interpretation = _data["interpretation"];
            this.comment = _data["comment"];
            this.method = _data["method"];
            this.specimen = _data["specimen"] ? ReferenceModel.fromJS(_data["specimen"]) : <any>undefined;
            this.device = _data["device"] ? ReferenceModel.fromJS(_data["device"]) : <any>undefined;
            this.reference = _data["reference"] ? RangeModel.fromJS(_data["reference"]) : <any>undefined;
            if (Array.isArray(_data["related"])) {
                this.related = [] as any;
                for (let item of _data["related"])
                    this.related!.push(ReferenceModel.fromJS(item));
            }
            if (Array.isArray(_data["components"])) {
                this.components = [] as any;
                for (let item of _data["components"])
                    this.components!.push(LaboratoryTestResultComponent.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ZibLaboratoryTestResult {
        data = typeof data === 'object' ? data : {};
        let result = new ZibLaboratoryTestResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.basedOn)) {
            data["basedOn"] = [];
            for (let item of this.basedOn)
                data["basedOn"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["type"] = this.type;
        data["code"] = this.code;
        data["name"] = this.name;
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        data["context"] = this.context ? this.context.toJSON() : <any>undefined;
        if (Array.isArray(this.performers)) {
            data["performers"] = [];
            for (let item of this.performers)
                data["performers"].push(item.toJSON());
        }
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        data["interpretation"] = this.interpretation;
        data["comment"] = this.comment;
        data["method"] = this.method;
        data["specimen"] = this.specimen ? this.specimen.toJSON() : <any>undefined;
        data["device"] = this.device ? this.device.toJSON() : <any>undefined;
        data["reference"] = this.reference ? this.reference.toJSON() : <any>undefined;
        if (Array.isArray(this.related)) {
            data["related"] = [];
            for (let item of this.related)
                data["related"].push(item.toJSON());
        }
        if (Array.isArray(this.components)) {
            data["components"] = [];
            for (let item of this.components)
                data["components"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IZibLaboratoryTestResult extends IObservationBaseModel {
    basedOn?: ReferenceModel[] | undefined;
    status?: LaboratoryTestResultStatus | undefined;
    type?: ResultType | undefined;
    code?: string | undefined;
    name?: string | undefined;
    subject?: ReferenceModel | undefined;
    context?: ReferenceModel | undefined;
    performers?: ReferenceModel[] | undefined;
    value?: ValueModel | undefined;
    interpretation?: Interpretation | undefined;
    comment?: string | undefined;
    method?: string | undefined;
    specimen?: ReferenceModel | undefined;
    device?: ReferenceModel | undefined;
    reference?: RangeModel | undefined;
    related?: ReferenceModel[] | undefined;
    components?: LaboratoryTestResultComponent[] | undefined;
}

export enum LaboratoryTestResultStatus {
    Unknown = 0,
    Pending = 1,
    Preliminary = 2,
    Final = 3,
    Appended = 4,
    Corrected = 5,
    Cancelled = 6,
    Registered = 7,
}

export enum Interpretation {
    Unknown = 0,
    AboveReferenceRange = 1,
    BelowReferenceRange = 2,
    Intermediate = 3,
    Resistant = 4,
    Susceptible = 5,
    WithinReferenceRange = 6,
    Abnormal = 7,
}

export class LaboratoryTestResultComponent implements ILaboratoryTestResultComponent {
    name?: string | undefined;
    value?: ValueModel | undefined;
    interpretation?: Interpretation | undefined;

    constructor(data?: ILaboratoryTestResultComponent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"] ? ValueModel.fromJS(_data["value"]) : <any>undefined;
            this.interpretation = _data["interpretation"];
        }
    }

    static fromJS(data: any): LaboratoryTestResultComponent {
        data = typeof data === 'object' ? data : {};
        let result = new LaboratoryTestResultComponent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        data["interpretation"] = this.interpretation;
        return data;
    }
}

export interface ILaboratoryTestResultComponent {
    name?: string | undefined;
    value?: ValueModel | undefined;
    interpretation?: Interpretation | undefined;
}

export class OxygenSaturationModel extends ObservationBaseModel implements IOxygenSaturationModel {
    diagnosticDetermination?: string | undefined;
    comment?: string | undefined;
    extraOxygenAdministration?: Affirmation | undefined;
    performers?: ReferenceModel[] | undefined;
    subject?: ReferenceModel | undefined;
    value?: QuantityModel | undefined;

    constructor(data?: IOxygenSaturationModel) {
        super(data);
        this._discriminator = "OxygenSaturationModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.diagnosticDetermination = _data["diagnosticDetermination"];
            this.comment = _data["comment"];
            this.extraOxygenAdministration = _data["extraOxygenAdministration"];
            if (Array.isArray(_data["performers"])) {
                this.performers = [] as any;
                for (let item of _data["performers"])
                    this.performers!.push(ReferenceModel.fromJS(item));
            }
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            this.value = _data["value"] ? QuantityModel.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): OxygenSaturationModel {
        data = typeof data === 'object' ? data : {};
        let result = new OxygenSaturationModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagnosticDetermination"] = this.diagnosticDetermination;
        data["comment"] = this.comment;
        data["extraOxygenAdministration"] = this.extraOxygenAdministration;
        if (Array.isArray(this.performers)) {
            data["performers"] = [];
            for (let item of this.performers)
                data["performers"].push(item.toJSON());
        }
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IOxygenSaturationModel extends IObservationBaseModel {
    diagnosticDetermination?: string | undefined;
    comment?: string | undefined;
    extraOxygenAdministration?: Affirmation | undefined;
    performers?: ReferenceModel[] | undefined;
    subject?: ReferenceModel | undefined;
    value?: QuantityModel | undefined;
}

export enum Affirmation {
    Unknown = 0,
    No = 1,
    Yes = 2,
}

export class PulseRateModel extends ObservationBaseModel implements IPulseRateModel {
    diagnosticDetermination?: string | undefined;
    subject?: ReferenceModel | undefined;
    value?: QuantityModel | undefined;
    comment?: string | undefined;
    regularity?: PulseRegularity | undefined;

    constructor(data?: IPulseRateModel) {
        super(data);
        this._discriminator = "PulseRateModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.diagnosticDetermination = _data["diagnosticDetermination"];
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            this.value = _data["value"] ? QuantityModel.fromJS(_data["value"]) : <any>undefined;
            this.comment = _data["comment"];
            this.regularity = _data["regularity"];
        }
    }

    static override fromJS(data: any): PulseRateModel {
        data = typeof data === 'object' ? data : {};
        let result = new PulseRateModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagnosticDetermination"] = this.diagnosticDetermination;
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        data["comment"] = this.comment;
        data["regularity"] = this.regularity;
        super.toJSON(data);
        return data;
    }
}

export interface IPulseRateModel extends IObservationBaseModel {
    diagnosticDetermination?: string | undefined;
    subject?: ReferenceModel | undefined;
    value?: QuantityModel | undefined;
    comment?: string | undefined;
    regularity?: PulseRegularity | undefined;
}

export enum PulseRegularity {
    Unknown = 0,
    Regular = 1,
    Irregular = 2,
}

export class OrganizationModel extends ResourceModel implements IOrganizationModel {
    addresses?: AddressModel[] | undefined;
    aliases?: string[] | undefined;
    departmentSpecialty?: string | undefined;
    identifier?: string | undefined;
    identifierType?: OrganizationIdentifierType | undefined;
    name?: string | undefined;
    partOfOrganization?: ReferenceModel | undefined;
    telecoms?: TelecomModel[] | undefined;
    type?: OrganizationType | undefined;

    constructor(data?: IOrganizationModel) {
        super(data);
        this._discriminator = "OrganizationModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(AddressModel.fromJS(item));
            }
            if (Array.isArray(_data["aliases"])) {
                this.aliases = [] as any;
                for (let item of _data["aliases"])
                    this.aliases!.push(item);
            }
            this.departmentSpecialty = _data["departmentSpecialty"];
            this.identifier = _data["identifier"];
            this.identifierType = _data["identifierType"];
            this.name = _data["name"];
            this.partOfOrganization = _data["partOfOrganization"] ? ReferenceModel.fromJS(_data["partOfOrganization"]) : <any>undefined;
            if (Array.isArray(_data["telecoms"])) {
                this.telecoms = [] as any;
                for (let item of _data["telecoms"])
                    this.telecoms!.push(TelecomModel.fromJS(item));
            }
            this.type = _data["type"];
        }
    }

    static override fromJS(data: any): OrganizationModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        if (Array.isArray(this.aliases)) {
            data["aliases"] = [];
            for (let item of this.aliases)
                data["aliases"].push(item);
        }
        data["departmentSpecialty"] = this.departmentSpecialty;
        data["identifier"] = this.identifier;
        data["identifierType"] = this.identifierType;
        data["name"] = this.name;
        data["partOfOrganization"] = this.partOfOrganization ? this.partOfOrganization.toJSON() : <any>undefined;
        if (Array.isArray(this.telecoms)) {
            data["telecoms"] = [];
            for (let item of this.telecoms)
                data["telecoms"].push(item.toJSON());
        }
        data["type"] = this.type;
        super.toJSON(data);
        return data;
    }
}

export interface IOrganizationModel extends IResourceModel {
    addresses?: AddressModel[] | undefined;
    aliases?: string[] | undefined;
    departmentSpecialty?: string | undefined;
    identifier?: string | undefined;
    identifierType?: OrganizationIdentifierType | undefined;
    name?: string | undefined;
    partOfOrganization?: ReferenceModel | undefined;
    telecoms?: TelecomModel[] | undefined;
    type?: OrganizationType | undefined;
}

export enum OrganizationIdentifierType {
    Unknown = 0,
    Ura = 1,
    Agb = 2,
    Uzovi = 3,
}

export enum OrganizationType {
    Unknown = 0,
    Hospital = 1,
    UniversityMedicalCenter = 2,
    GeneralHospital = 3,
    IndependentTreatmentCenter = 4,
    DiagnosticCenter = 5,
    EchoCenter = 6,
    NursingOrCareInstitution = 7,
    NursingHome = 8,
    CareHome = 9,
    PublicPharmacy = 10,
    IndependentHospitalPharmacy = 11,
    GeneralPractice = 12,
    PharmacyBasedGeneralPractice = 13,
    GeneralPracticeCenter = 14,
    Laboratory = 15,
    OutpatientClinic = 16,
    RehabilitationCenter = 17,
    PreventiveHealthcare = 18,
    MentalHealthcare = 19,
    MentallyDisabledCare = 20,
    HomeCare = 21,
    YouthHealthcare = 22,
    MidwiferyPractice = 23,
}

export class PharmaceuticalProductModel extends ResourceModel implements IPharmaceuticalProductModel {
    description?: string | undefined;
    name?: string | undefined;
    hpkName?: string | undefined;
    gpkName?: string | undefined;
    prkName?: string | undefined;
    form?: string | undefined;
    ingredients?: PharmaceuticalProductIngredientModel[] | undefined;
    contents?: string[] | undefined;
    contentReferences?: ReferenceModel[] | undefined;

    constructor(data?: IPharmaceuticalProductModel) {
        super(data);
        this._discriminator = "PharmaceuticalProductModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.description = _data["description"];
            this.name = _data["name"];
            this.hpkName = _data["hpkName"];
            this.gpkName = _data["gpkName"];
            this.prkName = _data["prkName"];
            this.form = _data["form"];
            if (Array.isArray(_data["ingredients"])) {
                this.ingredients = [] as any;
                for (let item of _data["ingredients"])
                    this.ingredients!.push(PharmaceuticalProductIngredientModel.fromJS(item));
            }
            if (Array.isArray(_data["contents"])) {
                this.contents = [] as any;
                for (let item of _data["contents"])
                    this.contents!.push(item);
            }
            if (Array.isArray(_data["contentReferences"])) {
                this.contentReferences = [] as any;
                for (let item of _data["contentReferences"])
                    this.contentReferences!.push(ReferenceModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PharmaceuticalProductModel {
        data = typeof data === 'object' ? data : {};
        let result = new PharmaceuticalProductModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["name"] = this.name;
        data["hpkName"] = this.hpkName;
        data["gpkName"] = this.gpkName;
        data["prkName"] = this.prkName;
        data["form"] = this.form;
        if (Array.isArray(this.ingredients)) {
            data["ingredients"] = [];
            for (let item of this.ingredients)
                data["ingredients"].push(item.toJSON());
        }
        if (Array.isArray(this.contents)) {
            data["contents"] = [];
            for (let item of this.contents)
                data["contents"].push(item);
        }
        if (Array.isArray(this.contentReferences)) {
            data["contentReferences"] = [];
            for (let item of this.contentReferences)
                data["contentReferences"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPharmaceuticalProductModel extends IResourceModel {
    description?: string | undefined;
    name?: string | undefined;
    hpkName?: string | undefined;
    gpkName?: string | undefined;
    prkName?: string | undefined;
    form?: string | undefined;
    ingredients?: PharmaceuticalProductIngredientModel[] | undefined;
    contents?: string[] | undefined;
    contentReferences?: ReferenceModel[] | undefined;
}

export class PharmaceuticalProductIngredientModel implements IPharmaceuticalProductIngredientModel {
    display?: string | undefined;
    amount?: QuantityModel | undefined;
    productAmount?: QuantityModel | undefined;

    constructor(data?: IPharmaceuticalProductIngredientModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.display = _data["display"];
            this.amount = _data["amount"] ? QuantityModel.fromJS(_data["amount"]) : <any>undefined;
            this.productAmount = _data["productAmount"] ? QuantityModel.fromJS(_data["productAmount"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PharmaceuticalProductIngredientModel {
        data = typeof data === 'object' ? data : {};
        let result = new PharmaceuticalProductIngredientModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["display"] = this.display;
        data["amount"] = this.amount ? this.amount.toJSON() : <any>undefined;
        data["productAmount"] = this.productAmount ? this.productAmount.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPharmaceuticalProductIngredientModel {
    display?: string | undefined;
    amount?: QuantityModel | undefined;
    productAmount?: QuantityModel | undefined;
}

export class PatientModel extends ResourceModel implements IPatientModel {
    bsn?: IdentifierModel | undefined;
    names?: NameModel[] | undefined;
    gender?: Gender;
    dateOfBirth?: string | undefined;
    isDeceased?: boolean | undefined;
    dateOfDeath?: string | undefined;
    telecoms?: TelecomModel[] | undefined;
    addresses?: AddressModel[] | undefined;
    maritalStatus?: MaritalStatus | undefined;
    isMultipleBirth?: boolean | undefined;
    multipleBirthAmount?: number | undefined;
    active?: boolean | undefined;
    communications?: CommunicationModel[] | undefined;
    generalPractitioners?: ReferenceModel[] | undefined;
    contact?: ContactModel | undefined;
    legalStatus?: LegalStatus | undefined;
    preferredPharmacy?: ReferenceModel | undefined;
    nationalities?: NationalityModel[] | undefined;

    constructor(data?: IPatientModel) {
        super(data);
        this._discriminator = "PatientModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.bsn = _data["bsn"] ? IdentifierModel.fromJS(_data["bsn"]) : <any>undefined;
            if (Array.isArray(_data["names"])) {
                this.names = [] as any;
                for (let item of _data["names"])
                    this.names!.push(NameModel.fromJS(item));
            }
            this.gender = _data["gender"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.isDeceased = _data["isDeceased"];
            this.dateOfDeath = _data["dateOfDeath"];
            if (Array.isArray(_data["telecoms"])) {
                this.telecoms = [] as any;
                for (let item of _data["telecoms"])
                    this.telecoms!.push(TelecomModel.fromJS(item));
            }
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(AddressModel.fromJS(item));
            }
            this.maritalStatus = _data["maritalStatus"];
            this.isMultipleBirth = _data["isMultipleBirth"];
            this.multipleBirthAmount = _data["multipleBirthAmount"];
            this.active = _data["active"];
            if (Array.isArray(_data["communications"])) {
                this.communications = [] as any;
                for (let item of _data["communications"])
                    this.communications!.push(CommunicationModel.fromJS(item));
            }
            if (Array.isArray(_data["generalPractitioners"])) {
                this.generalPractitioners = [] as any;
                for (let item of _data["generalPractitioners"])
                    this.generalPractitioners!.push(ReferenceModel.fromJS(item));
            }
            this.contact = _data["contact"] ? ContactModel.fromJS(_data["contact"]) : <any>undefined;
            this.legalStatus = _data["legalStatus"];
            this.preferredPharmacy = _data["preferredPharmacy"] ? ReferenceModel.fromJS(_data["preferredPharmacy"]) : <any>undefined;
            if (Array.isArray(_data["nationalities"])) {
                this.nationalities = [] as any;
                for (let item of _data["nationalities"])
                    this.nationalities!.push(NationalityModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PatientModel {
        data = typeof data === 'object' ? data : {};
        if (data["resourceTypeDiscriminator"] === "BcChild") {
            let result = new BcChild();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BcWoman") {
            let result = new BcWoman();
            result.init(data);
            return result;
        }
        let result = new PatientModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bsn"] = this.bsn ? this.bsn.toJSON() : <any>undefined;
        if (Array.isArray(this.names)) {
            data["names"] = [];
            for (let item of this.names)
                data["names"].push(item.toJSON());
        }
        data["gender"] = this.gender;
        data["dateOfBirth"] = this.dateOfBirth;
        data["isDeceased"] = this.isDeceased;
        data["dateOfDeath"] = this.dateOfDeath;
        if (Array.isArray(this.telecoms)) {
            data["telecoms"] = [];
            for (let item of this.telecoms)
                data["telecoms"].push(item.toJSON());
        }
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        data["maritalStatus"] = this.maritalStatus;
        data["isMultipleBirth"] = this.isMultipleBirth;
        data["multipleBirthAmount"] = this.multipleBirthAmount;
        data["active"] = this.active;
        if (Array.isArray(this.communications)) {
            data["communications"] = [];
            for (let item of this.communications)
                data["communications"].push(item.toJSON());
        }
        if (Array.isArray(this.generalPractitioners)) {
            data["generalPractitioners"] = [];
            for (let item of this.generalPractitioners)
                data["generalPractitioners"].push(item.toJSON());
        }
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["legalStatus"] = this.legalStatus;
        data["preferredPharmacy"] = this.preferredPharmacy ? this.preferredPharmacy.toJSON() : <any>undefined;
        if (Array.isArray(this.nationalities)) {
            data["nationalities"] = [];
            for (let item of this.nationalities)
                data["nationalities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPatientModel extends IResourceModel {
    bsn?: IdentifierModel | undefined;
    names?: NameModel[] | undefined;
    gender?: Gender;
    dateOfBirth?: string | undefined;
    isDeceased?: boolean | undefined;
    dateOfDeath?: string | undefined;
    telecoms?: TelecomModel[] | undefined;
    addresses?: AddressModel[] | undefined;
    maritalStatus?: MaritalStatus | undefined;
    isMultipleBirth?: boolean | undefined;
    multipleBirthAmount?: number | undefined;
    active?: boolean | undefined;
    communications?: CommunicationModel[] | undefined;
    generalPractitioners?: ReferenceModel[] | undefined;
    contact?: ContactModel | undefined;
    legalStatus?: LegalStatus | undefined;
    preferredPharmacy?: ReferenceModel | undefined;
    nationalities?: NationalityModel[] | undefined;
}

export enum MaritalStatus {
    Unknown = 0,
    Divorced = 1,
    Married = 2,
    NeverMarried = 3,
    DomesticPartner = 4,
    Widowed = 5,
}

export class CommunicationModel implements ICommunicationModel {
    language?: string | undefined;
    comment?: string | undefined;
    proficiencies?: LanguageProficiencyModel[] | undefined;

    constructor(data?: ICommunicationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"];
            this.comment = _data["comment"];
            if (Array.isArray(_data["proficiencies"])) {
                this.proficiencies = [] as any;
                for (let item of _data["proficiencies"])
                    this.proficiencies!.push(LanguageProficiencyModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CommunicationModel {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        data["comment"] = this.comment;
        if (Array.isArray(this.proficiencies)) {
            data["proficiencies"] = [];
            for (let item of this.proficiencies)
                data["proficiencies"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICommunicationModel {
    language?: string | undefined;
    comment?: string | undefined;
    proficiencies?: LanguageProficiencyModel[] | undefined;
}

export class LanguageProficiencyModel implements ILanguageProficiencyModel {
    level?: LanguageProficiencyLevel | undefined;
    mode?: LanguageProficiencyMode | undefined;

    constructor(data?: ILanguageProficiencyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.level = _data["level"];
            this.mode = _data["mode"];
        }
    }

    static fromJS(data: any): LanguageProficiencyModel {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageProficiencyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level;
        data["mode"] = this.mode;
        return data;
    }
}

export interface ILanguageProficiencyModel {
    level?: LanguageProficiencyLevel | undefined;
    mode?: LanguageProficiencyMode | undefined;
}

export enum LanguageProficiencyLevel {
    Excellent = 0,
    Fair = 1,
    Good = 2,
    Poor = 3,
}

export enum LanguageProficiencyMode {
    ExpressedSigned = 0,
    ExpressedSpoken = 1,
    ExpressedWritten = 2,
    ReceivedSigned = 3,
    ReceivedSpoken = 4,
    ReceivedWritten = 5,
}

export class ContactModel implements IContactModel {
    address?: AddressModel | undefined;
    name?: NameModel | undefined;
    relationshipRole?: RelationshipRole | undefined;
    relationship?: Relationship | undefined;
    telecoms?: TelecomModel[] | undefined;

    constructor(data?: IContactModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"] ? AddressModel.fromJS(_data["address"]) : <any>undefined;
            this.name = _data["name"] ? NameModel.fromJS(_data["name"]) : <any>undefined;
            this.relationshipRole = _data["relationshipRole"];
            this.relationship = _data["relationship"];
            if (Array.isArray(_data["telecoms"])) {
                this.telecoms = [] as any;
                for (let item of _data["telecoms"])
                    this.telecoms!.push(TelecomModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContactModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContactModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["name"] = this.name ? this.name.toJSON() : <any>undefined;
        data["relationshipRole"] = this.relationshipRole;
        data["relationship"] = this.relationship;
        if (Array.isArray(this.telecoms)) {
            data["telecoms"] = [];
            for (let item of this.telecoms)
                data["telecoms"].push(item.toJSON());
        }
        return data;
    }
}

export interface IContactModel {
    address?: AddressModel | undefined;
    name?: NameModel | undefined;
    relationshipRole?: RelationshipRole | undefined;
    relationship?: Relationship | undefined;
    telecoms?: TelecomModel[] | undefined;
}

export enum RelationshipRole {
    Unknown = 0,
    FirstRelation = 1,
    SecondRelation = 2,
    Curator = 3,
    FinancialAuthorized = 4,
    FinancialReview = 5,
    Commune = 6,
    Caregiver = 7,
    Other = 9,
    Guardian = 11,
    Receivership = 14,
    Mentor = 15,
    Neighbour = 19,
    Friend = 20,
    ClientSupport = 21,
    ContactPerson = 23,
    LegalRepresentative = 24,
}

export enum Relationship {
    Other = 0,
    AdoptiveFather = 1,
    AdoptiveMother = 2,
    Aunt = 3,
    Brother = 4,
    BrotherInLaw = 5,
    Cousin = 6,
    Daughter = 7,
    DaughterInLaw = 8,
    DomesticPartner = 9,
    Father = 10,
    FatherInLaw = 11,
    FosterDaughter = 12,
    FosterFather = 13,
    FosterMother = 14,
    FosterSon = 15,
    Granddaughter = 16,
    Grandfather = 17,
    Grandmother = 18,
    Grandson = 19,
    GreatGrandfather = 20,
    GreatGrandmother = 21,
    Husband = 22,
    Mother = 23,
    MotherInLaw = 24,
    Nephew = 25,
    Niece = 26,
    Sister = 27,
    SisterInLaw = 28,
    Son = 29,
    SonInLaw = 30,
    Stepfather = 31,
    Stepmother = 32,
    Uncle = 33,
    Wife = 34,
}

export enum LegalStatus {
    Unknown = 0,
    JudicialAuthorizationProvisional = 1,
    JudicialAuthorizationOwnRequest = 2,
    JudicialAuthorizationConditionalDismissal = 3,
    UnderSupervision = 4,
    InCustody = 5,
    Guardianship = 6,
    Administration = 7,
    Mentorship = 8,
    Curated = 9,
    ManagementOfBusiness = 10,
    CriminalJudicalContactsTbs = 11,
    CriminalJudicalContactsOther = 12,
}

export class NationalityModel implements INationalityModel {
    nationality?: string | undefined;
    period?: PeriodModel | undefined;

    constructor(data?: INationalityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nationality = _data["nationality"];
            this.period = _data["period"] ? PeriodModel.fromJS(_data["period"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NationalityModel {
        data = typeof data === 'object' ? data : {};
        let result = new NationalityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nationality"] = this.nationality;
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        return data;
    }
}

export interface INationalityModel {
    nationality?: string | undefined;
    period?: PeriodModel | undefined;
}

export class PractitionerRoleModel extends ResourceModel implements IPractitionerRoleModel {
    practitioner?: ReferenceModel | undefined;
    organization?: ReferenceModel | undefined;
    codes?: string[] | undefined;
    specialties?: string[] | undefined;
    telecoms?: TelecomModel[] | undefined;

    constructor(data?: IPractitionerRoleModel) {
        super(data);
        this._discriminator = "PractitionerRoleModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.practitioner = _data["practitioner"] ? ReferenceModel.fromJS(_data["practitioner"]) : <any>undefined;
            this.organization = _data["organization"] ? ReferenceModel.fromJS(_data["organization"]) : <any>undefined;
            if (Array.isArray(_data["codes"])) {
                this.codes = [] as any;
                for (let item of _data["codes"])
                    this.codes!.push(item);
            }
            if (Array.isArray(_data["specialties"])) {
                this.specialties = [] as any;
                for (let item of _data["specialties"])
                    this.specialties!.push(item);
            }
            if (Array.isArray(_data["telecoms"])) {
                this.telecoms = [] as any;
                for (let item of _data["telecoms"])
                    this.telecoms!.push(TelecomModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PractitionerRoleModel {
        data = typeof data === 'object' ? data : {};
        let result = new PractitionerRoleModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["practitioner"] = this.practitioner ? this.practitioner.toJSON() : <any>undefined;
        data["organization"] = this.organization ? this.organization.toJSON() : <any>undefined;
        if (Array.isArray(this.codes)) {
            data["codes"] = [];
            for (let item of this.codes)
                data["codes"].push(item);
        }
        if (Array.isArray(this.specialties)) {
            data["specialties"] = [];
            for (let item of this.specialties)
                data["specialties"].push(item);
        }
        if (Array.isArray(this.telecoms)) {
            data["telecoms"] = [];
            for (let item of this.telecoms)
                data["telecoms"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPractitionerRoleModel extends IResourceModel {
    practitioner?: ReferenceModel | undefined;
    organization?: ReferenceModel | undefined;
    codes?: string[] | undefined;
    specialties?: string[] | undefined;
    telecoms?: TelecomModel[] | undefined;
}

export class ProblemModel extends ResourceModel implements IProblemModel {
    anatomicalLocation?: string | undefined;
    bodySite?: BodySite | undefined;
    clinicalStatus?: ClinicalStatus | undefined;
    comments?: CommentModel[] | undefined;
    name?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    type?: ProblemType | undefined;
    verificationStatus?: ProblemVerificationStatus | undefined;
    subject?: ReferenceModel | undefined;
    context?: ReferenceModel | undefined;
    asserter?: ReferenceModel | undefined;

    constructor(data?: IProblemModel) {
        super(data);
        this._discriminator = "ProblemModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.anatomicalLocation = _data["anatomicalLocation"];
            this.bodySite = _data["bodySite"];
            this.clinicalStatus = _data["clinicalStatus"];
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(CommentModel.fromJS(item));
            }
            this.name = _data["name"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.type = _data["type"];
            this.verificationStatus = _data["verificationStatus"];
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            this.context = _data["context"] ? ReferenceModel.fromJS(_data["context"]) : <any>undefined;
            this.asserter = _data["asserter"] ? ReferenceModel.fromJS(_data["asserter"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ProblemModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["anatomicalLocation"] = this.anatomicalLocation;
        data["bodySite"] = this.bodySite;
        data["clinicalStatus"] = this.clinicalStatus;
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["type"] = this.type;
        data["verificationStatus"] = this.verificationStatus;
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        data["context"] = this.context ? this.context.toJSON() : <any>undefined;
        data["asserter"] = this.asserter ? this.asserter.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IProblemModel extends IResourceModel {
    anatomicalLocation?: string | undefined;
    bodySite?: BodySite | undefined;
    clinicalStatus?: ClinicalStatus | undefined;
    comments?: CommentModel[] | undefined;
    name?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    type?: ProblemType | undefined;
    verificationStatus?: ProblemVerificationStatus | undefined;
    subject?: ReferenceModel | undefined;
    context?: ReferenceModel | undefined;
    asserter?: ReferenceModel | undefined;
}

export enum ClinicalStatus {
    Unknown = 0,
    Active = 1,
    Inactive = 2,
}

export enum ProblemType {
    Unknown = 0,
    Diagnosis = 1,
    Symptom = 2,
    Complaint = 3,
    FunctionalLimitation = 4,
    Complication = 5,
}

export enum ProblemVerificationStatus {
    Unknown = 0,
    Suspected = 1,
    KnownPossible = 2,
    ConfirmedPresent = 3,
    KnownAbsent = 4,
}

export class RelatedPersonModel extends ResourceModel implements IRelatedPersonModel {
    address?: AddressModel[] | undefined;
    names?: NameModel[] | undefined;
    period?: PeriodModel | undefined;
    relationship?: Relationship | undefined;
    relationshipRole?: RelationshipRole | undefined;
    telecoms?: TelecomModel[] | undefined;

    constructor(data?: IRelatedPersonModel) {
        super(data);
        this._discriminator = "RelatedPersonModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["address"])) {
                this.address = [] as any;
                for (let item of _data["address"])
                    this.address!.push(AddressModel.fromJS(item));
            }
            if (Array.isArray(_data["names"])) {
                this.names = [] as any;
                for (let item of _data["names"])
                    this.names!.push(NameModel.fromJS(item));
            }
            this.period = _data["period"] ? PeriodModel.fromJS(_data["period"]) : <any>undefined;
            this.relationship = _data["relationship"];
            this.relationshipRole = _data["relationshipRole"];
            if (Array.isArray(_data["telecoms"])) {
                this.telecoms = [] as any;
                for (let item of _data["telecoms"])
                    this.telecoms!.push(TelecomModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): RelatedPersonModel {
        data = typeof data === 'object' ? data : {};
        let result = new RelatedPersonModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.address)) {
            data["address"] = [];
            for (let item of this.address)
                data["address"].push(item.toJSON());
        }
        if (Array.isArray(this.names)) {
            data["names"] = [];
            for (let item of this.names)
                data["names"].push(item.toJSON());
        }
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        data["relationship"] = this.relationship;
        data["relationshipRole"] = this.relationshipRole;
        if (Array.isArray(this.telecoms)) {
            data["telecoms"] = [];
            for (let item of this.telecoms)
                data["telecoms"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IRelatedPersonModel extends IResourceModel {
    address?: AddressModel[] | undefined;
    names?: NameModel[] | undefined;
    period?: PeriodModel | undefined;
    relationship?: Relationship | undefined;
    relationshipRole?: RelationshipRole | undefined;
    telecoms?: TelecomModel[] | undefined;
}

export class SpecimenModel extends ResourceModel implements ISpecimenModel {
    identifier?: IdentifierModel | undefined;
    typeString?: string | undefined;
    subject?: ReferenceModel | undefined;
    receivedDateTime?: string | undefined;
    parents?: ReferenceModel[] | undefined;
    collection?: SpecimenCollectionModel | undefined;
    containers?: SpecimenContainerModel[] | undefined;
    comments?: CommentModel[] | undefined;

    constructor(data?: ISpecimenModel) {
        super(data);
        this._discriminator = "SpecimenModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"] ? IdentifierModel.fromJS(_data["identifier"]) : <any>undefined;
            this.typeString = _data["typeString"];
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            this.receivedDateTime = _data["receivedDateTime"];
            if (Array.isArray(_data["parents"])) {
                this.parents = [] as any;
                for (let item of _data["parents"])
                    this.parents!.push(ReferenceModel.fromJS(item));
            }
            this.collection = _data["collection"] ? SpecimenCollectionModel.fromJS(_data["collection"]) : <any>undefined;
            if (Array.isArray(_data["containers"])) {
                this.containers = [] as any;
                for (let item of _data["containers"])
                    this.containers!.push(SpecimenContainerModel.fromJS(item));
            }
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(CommentModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SpecimenModel {
        data = typeof data === 'object' ? data : {};
        let result = new SpecimenModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier ? this.identifier.toJSON() : <any>undefined;
        data["typeString"] = this.typeString;
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        data["receivedDateTime"] = this.receivedDateTime;
        if (Array.isArray(this.parents)) {
            data["parents"] = [];
            for (let item of this.parents)
                data["parents"].push(item.toJSON());
        }
        data["collection"] = this.collection ? this.collection.toJSON() : <any>undefined;
        if (Array.isArray(this.containers)) {
            data["containers"] = [];
            for (let item of this.containers)
                data["containers"].push(item.toJSON());
        }
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISpecimenModel extends IResourceModel {
    identifier?: IdentifierModel | undefined;
    typeString?: string | undefined;
    subject?: ReferenceModel | undefined;
    receivedDateTime?: string | undefined;
    parents?: ReferenceModel[] | undefined;
    collection?: SpecimenCollectionModel | undefined;
    containers?: SpecimenContainerModel[] | undefined;
    comments?: CommentModel[] | undefined;
}

export class SpecimenCollectionModel implements ISpecimenCollectionModel {
    anatomicLocation?: string | undefined;
    bodySiteLaterality?: BodySite | undefined;
    bodySiteMorphologyString?: string | undefined;
    collected?: CollectedModel | undefined;
    methodString?: string | undefined;
    quantity?: QuantityModel | undefined;

    constructor(data?: ISpecimenCollectionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.anatomicLocation = _data["anatomicLocation"];
            this.bodySiteLaterality = _data["bodySiteLaterality"];
            this.bodySiteMorphologyString = _data["bodySiteMorphologyString"];
            this.collected = _data["collected"] ? CollectedModel.fromJS(_data["collected"]) : <any>undefined;
            this.methodString = _data["methodString"];
            this.quantity = _data["quantity"] ? QuantityModel.fromJS(_data["quantity"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SpecimenCollectionModel {
        data = typeof data === 'object' ? data : {};
        let result = new SpecimenCollectionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["anatomicLocation"] = this.anatomicLocation;
        data["bodySiteLaterality"] = this.bodySiteLaterality;
        data["bodySiteMorphologyString"] = this.bodySiteMorphologyString;
        data["collected"] = this.collected ? this.collected.toJSON() : <any>undefined;
        data["methodString"] = this.methodString;
        data["quantity"] = this.quantity ? this.quantity.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISpecimenCollectionModel {
    anatomicLocation?: string | undefined;
    bodySiteLaterality?: BodySite | undefined;
    bodySiteMorphologyString?: string | undefined;
    collected?: CollectedModel | undefined;
    methodString?: string | undefined;
    quantity?: QuantityModel | undefined;
}

export class CollectedModel implements ICollectedModel {
    dateTime?: string | undefined;
    period?: PeriodModel | undefined;

    constructor(data?: ICollectedModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateTime = _data["dateTime"];
            this.period = _data["period"] ? PeriodModel.fromJS(_data["period"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CollectedModel {
        data = typeof data === 'object' ? data : {};
        let result = new CollectedModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateTime"] = this.dateTime;
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICollectedModel {
    dateTime?: string | undefined;
    period?: PeriodModel | undefined;
}

export class SpecimenContainerModel implements ISpecimenContainerModel {
    identifierValue?: string | undefined;
    typeString?: string | undefined;

    constructor(data?: ISpecimenContainerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifierValue = _data["identifierValue"];
            this.typeString = _data["typeString"];
        }
    }

    static fromJS(data: any): SpecimenContainerModel {
        data = typeof data === 'object' ? data : {};
        let result = new SpecimenContainerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifierValue"] = this.identifierValue;
        data["typeString"] = this.typeString;
        return data;
    }
}

export interface ISpecimenContainerModel {
    identifierValue?: string | undefined;
    typeString?: string | undefined;
}

export class VaccinationModel extends ResourceModel implements IVaccinationModel {
    comments?: CommentModel[] | undefined;
    date?: string | undefined;
    doseQuantity?: QuantityModel | undefined;
    encounter?: ReferenceModel | undefined;
    identifiers?: IdentifierModel[] | undefined;
    location?: ReferenceModel | undefined;
    manufacturer?: ReferenceModel | undefined;
    patient?: ReferenceModel | undefined;
    practitioners?: VaccinationPractitionerModel[] | undefined;
    reportOriginDisplay?: string | undefined;
    nameDisplay?: string | undefined;

    constructor(data?: IVaccinationModel) {
        super(data);
        this._discriminator = "VaccinationModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(CommentModel.fromJS(item));
            }
            this.date = _data["date"];
            this.doseQuantity = _data["doseQuantity"] ? QuantityModel.fromJS(_data["doseQuantity"]) : <any>undefined;
            this.encounter = _data["encounter"] ? ReferenceModel.fromJS(_data["encounter"]) : <any>undefined;
            if (Array.isArray(_data["identifiers"])) {
                this.identifiers = [] as any;
                for (let item of _data["identifiers"])
                    this.identifiers!.push(IdentifierModel.fromJS(item));
            }
            this.location = _data["location"] ? ReferenceModel.fromJS(_data["location"]) : <any>undefined;
            this.manufacturer = _data["manufacturer"] ? ReferenceModel.fromJS(_data["manufacturer"]) : <any>undefined;
            this.patient = _data["patient"] ? ReferenceModel.fromJS(_data["patient"]) : <any>undefined;
            if (Array.isArray(_data["practitioners"])) {
                this.practitioners = [] as any;
                for (let item of _data["practitioners"])
                    this.practitioners!.push(VaccinationPractitionerModel.fromJS(item));
            }
            this.reportOriginDisplay = _data["reportOriginDisplay"];
            this.nameDisplay = _data["nameDisplay"];
        }
    }

    static override fromJS(data: any): VaccinationModel {
        data = typeof data === 'object' ? data : {};
        let result = new VaccinationModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        data["date"] = this.date;
        data["doseQuantity"] = this.doseQuantity ? this.doseQuantity.toJSON() : <any>undefined;
        data["encounter"] = this.encounter ? this.encounter.toJSON() : <any>undefined;
        if (Array.isArray(this.identifiers)) {
            data["identifiers"] = [];
            for (let item of this.identifiers)
                data["identifiers"].push(item.toJSON());
        }
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["manufacturer"] = this.manufacturer ? this.manufacturer.toJSON() : <any>undefined;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        if (Array.isArray(this.practitioners)) {
            data["practitioners"] = [];
            for (let item of this.practitioners)
                data["practitioners"].push(item.toJSON());
        }
        data["reportOriginDisplay"] = this.reportOriginDisplay;
        data["nameDisplay"] = this.nameDisplay;
        super.toJSON(data);
        return data;
    }
}

export interface IVaccinationModel extends IResourceModel {
    comments?: CommentModel[] | undefined;
    date?: string | undefined;
    doseQuantity?: QuantityModel | undefined;
    encounter?: ReferenceModel | undefined;
    identifiers?: IdentifierModel[] | undefined;
    location?: ReferenceModel | undefined;
    manufacturer?: ReferenceModel | undefined;
    patient?: ReferenceModel | undefined;
    practitioners?: VaccinationPractitionerModel[] | undefined;
    reportOriginDisplay?: string | undefined;
    nameDisplay?: string | undefined;
}

export class VaccinationPractitionerModel implements IVaccinationPractitionerModel {
    actor?: ReferenceModel | undefined;
    roles?: string[] | undefined;

    constructor(data?: IVaccinationPractitionerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actor = _data["actor"] ? ReferenceModel.fromJS(_data["actor"]) : <any>undefined;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): VaccinationPractitionerModel {
        data = typeof data === 'object' ? data : {};
        let result = new VaccinationPractitionerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actor"] = this.actor ? this.actor.toJSON() : <any>undefined;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface IVaccinationPractitionerModel {
    actor?: ReferenceModel | undefined;
    roles?: string[] | undefined;
}

export class NlCoreObservation extends ResourceModel implements INlCoreObservation {
    subject?: ReferenceModel | undefined;
    context?: ReferenceModel | undefined;
    effective?: EffectiveModel | undefined;
    performers?: ReferenceModel[] | undefined;

    constructor(data?: INlCoreObservation) {
        super(data);
        this._discriminator = "NlCoreObservation";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            this.context = _data["context"] ? ReferenceModel.fromJS(_data["context"]) : <any>undefined;
            this.effective = _data["effective"] ? EffectiveModel.fromJS(_data["effective"]) : <any>undefined;
            if (Array.isArray(_data["performers"])) {
                this.performers = [] as any;
                for (let item of _data["performers"])
                    this.performers!.push(ReferenceModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): NlCoreObservation {
        data = typeof data === 'object' ? data : {};
        if (data["resourceTypeDiscriminator"] === "BcBirth") {
            let result = new BcBirth();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BcBirthObservation") {
            let result = new BcBirthObservation();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BcBirthObservationOnsetOfPushing") {
            let result = new BcBirthObservationOnsetOfPushing();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BcBirthObservationPartus") {
            let result = new BcBirthObservationPartus();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BcDeliveryObservation") {
            let result = new BcDeliveryObservation();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BcDeliveryObservationBloodloss") {
            let result = new BcDeliveryObservationBloodloss();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BcDeliveryObservationOnsetLaborFirstStage") {
            let result = new BcDeliveryObservationOnsetLaborFirstStage();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BcDeliveryObservationPerineumCondition") {
            let result = new BcDeliveryObservationPerineumCondition();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BcPregnancyObservation") {
            let result = new BcPregnancyObservation();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BcPregnancyObservationTerminationDate") {
            let result = new BcPregnancyObservationTerminationDate();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BcPregnancyObservationTerminationType") {
            let result = new BcPregnancyObservationTerminationType();
            result.init(data);
            return result;
        }
        let result = new NlCoreObservation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        data["context"] = this.context ? this.context.toJSON() : <any>undefined;
        data["effective"] = this.effective ? this.effective.toJSON() : <any>undefined;
        if (Array.isArray(this.performers)) {
            data["performers"] = [];
            for (let item of this.performers)
                data["performers"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface INlCoreObservation extends IResourceModel {
    subject?: ReferenceModel | undefined;
    context?: ReferenceModel | undefined;
    effective?: EffectiveModel | undefined;
    performers?: ReferenceModel[] | undefined;
}

export class BcBirth extends NlCoreObservation implements IBcBirth {
    deliveryProcedure?: ReferenceModel | undefined;
    child?: ReferenceModel | undefined;
    value?: string | undefined;

    constructor(data?: IBcBirth) {
        super(data);
        this._discriminator = "BcBirth";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.deliveryProcedure = _data["deliveryProcedure"] ? ReferenceModel.fromJS(_data["deliveryProcedure"]) : <any>undefined;
            this.child = _data["child"] ? ReferenceModel.fromJS(_data["child"]) : <any>undefined;
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): BcBirth {
        data = typeof data === 'object' ? data : {};
        let result = new BcBirth();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deliveryProcedure"] = this.deliveryProcedure ? this.deliveryProcedure.toJSON() : <any>undefined;
        data["child"] = this.child ? this.child.toJSON() : <any>undefined;
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IBcBirth extends INlCoreObservation {
    deliveryProcedure?: ReferenceModel | undefined;
    child?: ReferenceModel | undefined;
    value?: string | undefined;
}

export class BcBirthObservation extends NlCoreObservation implements IBcBirthObservation {
    birth?: ReferenceModel | undefined;
    type?: BirthObservationType | undefined;

    constructor(data?: IBcBirthObservation) {
        super(data);
        this._discriminator = "BcBirthObservation";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.birth = _data["birth"] ? ReferenceModel.fromJS(_data["birth"]) : <any>undefined;
            this.type = _data["type"];
        }
    }

    static override fromJS(data: any): BcBirthObservation {
        data = typeof data === 'object' ? data : {};
        if (data["resourceTypeDiscriminator"] === "BcBirthObservationOnsetOfPushing") {
            let result = new BcBirthObservationOnsetOfPushing();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BcBirthObservationPartus") {
            let result = new BcBirthObservationPartus();
            result.init(data);
            return result;
        }
        let result = new BcBirthObservation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["birth"] = this.birth ? this.birth.toJSON() : <any>undefined;
        data["type"] = this.type;
        super.toJSON(data);
        return data;
    }
}

export interface IBcBirthObservation extends INlCoreObservation {
    birth?: ReferenceModel | undefined;
    type?: BirthObservationType | undefined;
}

export enum BirthObservationType {
    OnsetOfPushing = 1,
    Partus = 2,
}

export class BcBirthObservationOnsetOfPushing extends BcBirthObservation implements IBcBirthObservationOnsetOfPushing {
    value?: ValueModel | undefined;

    constructor(data?: IBcBirthObservationOnsetOfPushing) {
        super(data);
        this._discriminator = "BcBirthObservationOnsetOfPushing";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? ValueModel.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): BcBirthObservationOnsetOfPushing {
        data = typeof data === 'object' ? data : {};
        let result = new BcBirthObservationOnsetOfPushing();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IBcBirthObservationOnsetOfPushing extends IBcBirthObservation {
    value?: ValueModel | undefined;
}

export class BcBirthObservationPartus extends BcBirthObservation implements IBcBirthObservationPartus {
    value?: PartusType | undefined;

    constructor(data?: IBcBirthObservationPartus) {
        super(data);
        this._discriminator = "BcBirthObservationPartus";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): BcBirthObservationPartus {
        data = typeof data === 'object' ? data : {};
        let result = new BcBirthObservationPartus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IBcBirthObservationPartus extends IBcBirthObservation {
    value?: PartusType | undefined;
}

export enum PartusType {
    Ni = 0,
    NormalDelivery = 1,
    AssistedDelivery = 2,
    CaesareanSection = 3,
    ElectiveCaesarianDelivery = 4,
    EmergencyCaesarianSection = 5,
    TerminationOfPregnancy = 6,
    MedicalTerminationOfPregnancyProstaglandin = 7,
    PostmortemCaesarianSection = 8,
    Other = 9,
}

export class BcBirthWeight extends ResourceModel implements IBcBirthWeight {
    child?: ReferenceModel | undefined;
    interpretation?: PercentileBirthWeight;
    weight?: QuantityModel | undefined;

    constructor(data?: IBcBirthWeight) {
        super(data);
        this._discriminator = "BcBirthWeight";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.child = _data["child"] ? ReferenceModel.fromJS(_data["child"]) : <any>undefined;
            this.interpretation = _data["interpretation"];
            this.weight = _data["weight"] ? QuantityModel.fromJS(_data["weight"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): BcBirthWeight {
        data = typeof data === 'object' ? data : {};
        let result = new BcBirthWeight();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["child"] = this.child ? this.child.toJSON() : <any>undefined;
        data["interpretation"] = this.interpretation;
        data["weight"] = this.weight ? this.weight.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IBcBirthWeight extends IResourceModel {
    child?: ReferenceModel | undefined;
    interpretation?: PercentileBirthWeight;
    weight?: QuantityModel | undefined;
}

export enum PercentileBirthWeight {
    Ni = 0,
    LtP2 = 1,
    P2P10 = 2,
    P10P50 = 3,
    P50P90 = 4,
    P90P97 = 5,
    GeP97 = 6,
}

export class BcChild extends PatientModel implements IBcChild {

    constructor(data?: IBcChild) {
        super(data);
        this._discriminator = "BcChild";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): BcChild {
        data = typeof data === 'object' ? data : {};
        let result = new BcChild();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IBcChild extends IPatientModel {
}

export class BcChildBirthAssistance extends ResourceModel implements IBcChildBirthAssistance {
    deliveryLocation?: DeliveryLocation | undefined;
    subject?: ReferenceModel | undefined;
    episodesOfCare?: ReferenceModel[] | undefined;
    participants?: BcChildBirthAssistanceParticipant[] | undefined;
    pregnancies?: ReferenceModel[] | undefined;

    constructor(data?: IBcChildBirthAssistance) {
        super(data);
        this._discriminator = "BcChildBirthAssistance";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.deliveryLocation = _data["deliveryLocation"];
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            if (Array.isArray(_data["episodesOfCare"])) {
                this.episodesOfCare = [] as any;
                for (let item of _data["episodesOfCare"])
                    this.episodesOfCare!.push(ReferenceModel.fromJS(item));
            }
            if (Array.isArray(_data["participants"])) {
                this.participants = [] as any;
                for (let item of _data["participants"])
                    this.participants!.push(BcChildBirthAssistanceParticipant.fromJS(item));
            }
            if (Array.isArray(_data["pregnancies"])) {
                this.pregnancies = [] as any;
                for (let item of _data["pregnancies"])
                    this.pregnancies!.push(ReferenceModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): BcChildBirthAssistance {
        data = typeof data === 'object' ? data : {};
        let result = new BcChildBirthAssistance();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deliveryLocation"] = this.deliveryLocation;
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        if (Array.isArray(this.episodesOfCare)) {
            data["episodesOfCare"] = [];
            for (let item of this.episodesOfCare)
                data["episodesOfCare"].push(item.toJSON());
        }
        if (Array.isArray(this.participants)) {
            data["participants"] = [];
            for (let item of this.participants)
                data["participants"].push(item.toJSON());
        }
        if (Array.isArray(this.pregnancies)) {
            data["pregnancies"] = [];
            for (let item of this.pregnancies)
                data["pregnancies"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IBcChildBirthAssistance extends IResourceModel {
    deliveryLocation?: DeliveryLocation | undefined;
    subject?: ReferenceModel | undefined;
    episodesOfCare?: ReferenceModel[] | undefined;
    participants?: BcChildBirthAssistanceParticipant[] | undefined;
    pregnancies?: ReferenceModel[] | undefined;
}

export enum DeliveryLocation {
    Unknown = 0,
    NoInformation = 1,
    HomeBirth = 2,
    BirthCenter = 3,
    Hospital = 4,
    OnTheWay = 5,
}

export class BcChildBirthAssistanceParticipant implements IBcChildBirthAssistanceParticipant {
    laborStage?: LaborStage | undefined;
    practitioner?: ReferenceModel | undefined;

    constructor(data?: IBcChildBirthAssistanceParticipant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.laborStage = _data["laborStage"];
            this.practitioner = _data["practitioner"] ? ReferenceModel.fromJS(_data["practitioner"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BcChildBirthAssistanceParticipant {
        data = typeof data === 'object' ? data : {};
        let result = new BcChildBirthAssistanceParticipant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["laborStage"] = this.laborStage;
        data["practitioner"] = this.practitioner ? this.practitioner.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBcChildBirthAssistanceParticipant {
    laborStage?: LaborStage | undefined;
    practitioner?: ReferenceModel | undefined;
}

export enum LaborStage {
    Unknown = 0,
    NoInformation = 1,
    FirstStage = 2,
    SecondStage = 3,
    ArrivedAfterBirth = 4,
}

export class BcDeliveryObservation extends NlCoreObservation implements IBcDeliveryObservation {
    delivery?: ReferenceModel | undefined;
    type?: DeliveryObservationType;

    constructor(data?: IBcDeliveryObservation) {
        super(data);
        this._discriminator = "BcDeliveryObservation";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.delivery = _data["delivery"] ? ReferenceModel.fromJS(_data["delivery"]) : <any>undefined;
            this.type = _data["type"];
        }
    }

    static override fromJS(data: any): BcDeliveryObservation {
        data = typeof data === 'object' ? data : {};
        if (data["resourceTypeDiscriminator"] === "BcDeliveryObservationBloodloss") {
            let result = new BcDeliveryObservationBloodloss();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BcDeliveryObservationOnsetLaborFirstStage") {
            let result = new BcDeliveryObservationOnsetLaborFirstStage();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BcDeliveryObservationPerineumCondition") {
            let result = new BcDeliveryObservationPerineumCondition();
            result.init(data);
            return result;
        }
        let result = new BcDeliveryObservation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["delivery"] = this.delivery ? this.delivery.toJSON() : <any>undefined;
        data["type"] = this.type;
        super.toJSON(data);
        return data;
    }
}

export interface IBcDeliveryObservation extends INlCoreObservation {
    delivery?: ReferenceModel | undefined;
    type?: DeliveryObservationType;
}

export enum DeliveryObservationType {
    OnsetLaborFirstStage = 1,
    Bloodloss = 2,
    PerineumCondition = 3,
}

export class BcDeliveryObservationBloodloss extends BcDeliveryObservation implements IBcDeliveryObservationBloodloss {
    value?: ValueModel | undefined;

    constructor(data?: IBcDeliveryObservationBloodloss) {
        super(data);
        this._discriminator = "BcDeliveryObservationBloodloss";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? ValueModel.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): BcDeliveryObservationBloodloss {
        data = typeof data === 'object' ? data : {};
        let result = new BcDeliveryObservationBloodloss();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IBcDeliveryObservationBloodloss extends IBcDeliveryObservation {
    value?: ValueModel | undefined;
}

export class BcDeliveryObservationOnsetLaborFirstStage extends BcDeliveryObservation implements IBcDeliveryObservationOnsetLaborFirstStage {
    value?: ValueModel | undefined;

    constructor(data?: IBcDeliveryObservationOnsetLaborFirstStage) {
        super(data);
        this._discriminator = "BcDeliveryObservationOnsetLaborFirstStage";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? ValueModel.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): BcDeliveryObservationOnsetLaborFirstStage {
        data = typeof data === 'object' ? data : {};
        let result = new BcDeliveryObservationOnsetLaborFirstStage();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IBcDeliveryObservationOnsetLaborFirstStage extends IBcDeliveryObservation {
    value?: ValueModel | undefined;
}

export class BcDeliveryObservationPerineumCondition extends BcDeliveryObservation implements IBcDeliveryObservationPerineumCondition {
    value?: PerineumCondition | undefined;

    constructor(data?: IBcDeliveryObservationPerineumCondition) {
        super(data);
        this._discriminator = "BcDeliveryObservationPerineumCondition";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): BcDeliveryObservationPerineumCondition {
        data = typeof data === 'object' ? data : {};
        let result = new BcDeliveryObservationPerineumCondition();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IBcDeliveryObservationPerineumCondition extends IBcDeliveryObservation {
    value?: PerineumCondition | undefined;
}

export enum PerineumCondition {
    Unknown = 0,
    NoInformation = 1,
    Other = 2,
    Intact = 3,
    FirstDegreeTearDuringDelivery = 4,
    SecondDegreeTearDuringDelivery = 5,
    ThirdDegreeTearDuringDelivery = 6,
    Type3ADegreeLaceration = 7,
    Type3BDegreeLaceration = 8,
    Type3CDegreeLaceration = 9,
    FourthDegreeTearDuringDelivery = 10,
    EpisiotomyWound = 11,
}

export class BcDeliveryProcedure extends ResourceModel implements IBcDeliveryProcedure {
    subject?: ReferenceModel | undefined;
    context?: ReferenceModel | undefined;
    reason?: ReferenceModel | undefined;

    constructor(data?: IBcDeliveryProcedure) {
        super(data);
        this._discriminator = "BcDeliveryProcedure";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            this.context = _data["context"] ? ReferenceModel.fromJS(_data["context"]) : <any>undefined;
            this.reason = _data["reason"] ? ReferenceModel.fromJS(_data["reason"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): BcDeliveryProcedure {
        data = typeof data === 'object' ? data : {};
        let result = new BcDeliveryProcedure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        data["context"] = this.context ? this.context.toJSON() : <any>undefined;
        data["reason"] = this.reason ? this.reason.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IBcDeliveryProcedure extends IResourceModel {
    subject?: ReferenceModel | undefined;
    context?: ReferenceModel | undefined;
    reason?: ReferenceModel | undefined;
}

export class BcMaternalRecord extends NlCoreEpisodeOfCare implements IBcMaternalRecord {

    constructor(data?: IBcMaternalRecord) {
        super(data);
        this._discriminator = "BcMaternalRecord";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): BcMaternalRecord {
        data = typeof data === 'object' ? data : {};
        let result = new BcMaternalRecord();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IBcMaternalRecord extends INlCoreEpisodeOfCare {
}

export class BcMotherOf extends ResourceModel implements IBcMotherOf {
    child?: ReferenceModel | undefined;

    constructor(data?: IBcMotherOf) {
        super(data);
        this._discriminator = "BcMotherOf";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.child = _data["child"] ? ReferenceModel.fromJS(_data["child"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): BcMotherOf {
        data = typeof data === 'object' ? data : {};
        let result = new BcMotherOf();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["child"] = this.child ? this.child.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IBcMotherOf extends IResourceModel {
    child?: ReferenceModel | undefined;
}

export class BcObstetricProcedure extends ResourceModel implements IBcObstetricProcedure {
    deliveryProcedure?: ReferenceModel | undefined;
    stageOfLabor?: ReferenceModel | undefined;
    startDeliveryIntervention?: InterventionStartDelivery | undefined;
    instrumentalDelivery?: InstrumentalDelivery | undefined;
    otherDeliveryIntervention?: OtherDeliveryIntervention | undefined;
    subject?: ReferenceModel | undefined;
    startDeliveryInterventionReason?: IndicationInterventionStartDelivery | undefined;

    constructor(data?: IBcObstetricProcedure) {
        super(data);
        this._discriminator = "BcObstetricProcedure";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.deliveryProcedure = _data["deliveryProcedure"] ? ReferenceModel.fromJS(_data["deliveryProcedure"]) : <any>undefined;
            this.stageOfLabor = _data["stageOfLabor"] ? ReferenceModel.fromJS(_data["stageOfLabor"]) : <any>undefined;
            this.startDeliveryIntervention = _data["startDeliveryIntervention"];
            this.instrumentalDelivery = _data["instrumentalDelivery"];
            this.otherDeliveryIntervention = _data["otherDeliveryIntervention"];
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            this.startDeliveryInterventionReason = _data["startDeliveryInterventionReason"];
        }
    }

    static override fromJS(data: any): BcObstetricProcedure {
        data = typeof data === 'object' ? data : {};
        let result = new BcObstetricProcedure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deliveryProcedure"] = this.deliveryProcedure ? this.deliveryProcedure.toJSON() : <any>undefined;
        data["stageOfLabor"] = this.stageOfLabor ? this.stageOfLabor.toJSON() : <any>undefined;
        data["startDeliveryIntervention"] = this.startDeliveryIntervention;
        data["instrumentalDelivery"] = this.instrumentalDelivery;
        data["otherDeliveryIntervention"] = this.otherDeliveryIntervention;
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        data["startDeliveryInterventionReason"] = this.startDeliveryInterventionReason;
        super.toJSON(data);
        return data;
    }
}

export interface IBcObstetricProcedure extends IResourceModel {
    deliveryProcedure?: ReferenceModel | undefined;
    stageOfLabor?: ReferenceModel | undefined;
    startDeliveryIntervention?: InterventionStartDelivery | undefined;
    instrumentalDelivery?: InstrumentalDelivery | undefined;
    otherDeliveryIntervention?: OtherDeliveryIntervention | undefined;
    subject?: ReferenceModel | undefined;
    startDeliveryInterventionReason?: IndicationInterventionStartDelivery | undefined;
}

export enum InterventionStartDelivery {
    NoInformation = 0,
    Other = 1,
    SweepingOfMembrane = 2,
    InductionOfLabourArtificialRupture = 3,
    CervicalRipeningBalloon = 4,
    CervicalRipeningProstaglandin = 5,
    InductionOfLabourOxytocin = 6,
    InductionOfLabourProstaglandin = 7,
    ElectiveCaesareanSection = 8,
}

export enum InstrumentalDelivery {
    NoInformation = 0,
    Other = 1,
    Forceps = 2,
    VacuumExtraction = 3,
    ObstetricalWithExtraction = 4,
    PartialBreechExtraction = 5,
    TotalBreechExtraction = 6,
}

export enum OtherDeliveryIntervention {
    Other = 0,
    Pubiotomy = 1,
    ManeuversInShoulderDystocia = 2,
    McRobertManeuver = 3,
    SuprapubicPressure = 4,
    FreeingPosteriorArm = 5,
    WoodsScrewManeuver = 6,
    HalfKneelingPosition = 7,
    KristellerManeuver = 8,
}

export enum IndicationInterventionStartDelivery {
    Unknown = 0,
    NoInformation = 1,
    Other = 2,
    ConditionMother = 3,
    ConditionMotherLifeThreatening = 4,
    ConditionMotherNotLifeThreatening = 5,
    ConditionMotherUnknown = 6,
    ConditionChild = 7,
    FetalDistress = 8,
    ConditionChildNotLifeThreatening = 9,
    CongenitalAbnormality = 10,
    ConditionChildUnknown = 11,
    Research = 12,
    PatientRequest = 13,
}

export class BcPregnancyObservation extends NlCoreObservation implements IBcPregnancyObservation {
    pregnancy?: ReferenceModel | undefined;
    type?: PregnancyObservationType;

    constructor(data?: IBcPregnancyObservation) {
        super(data);
        this._discriminator = "BcPregnancyObservation";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pregnancy = _data["pregnancy"] ? ReferenceModel.fromJS(_data["pregnancy"]) : <any>undefined;
            this.type = _data["type"];
        }
    }

    static override fromJS(data: any): BcPregnancyObservation {
        data = typeof data === 'object' ? data : {};
        if (data["resourceTypeDiscriminator"] === "BcPregnancyObservationTerminationDate") {
            let result = new BcPregnancyObservationTerminationDate();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "BcPregnancyObservationTerminationType") {
            let result = new BcPregnancyObservationTerminationType();
            result.init(data);
            return result;
        }
        let result = new BcPregnancyObservation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pregnancy"] = this.pregnancy ? this.pregnancy.toJSON() : <any>undefined;
        data["type"] = this.type;
        super.toJSON(data);
        return data;
    }
}

export interface IBcPregnancyObservation extends INlCoreObservation {
    pregnancy?: ReferenceModel | undefined;
    type?: PregnancyObservationType;
}

export enum PregnancyObservationType {
    PregnancyTerminationDate = 1,
    PregnancyTerminationType = 2,
}

export class BcPregnancyObservationTerminationDate extends BcPregnancyObservation implements IBcPregnancyObservationTerminationDate {
    value?: string | undefined;

    constructor(data?: IBcPregnancyObservationTerminationDate) {
        super(data);
        this._discriminator = "BcPregnancyObservationTerminationDate";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): BcPregnancyObservationTerminationDate {
        data = typeof data === 'object' ? data : {};
        let result = new BcPregnancyObservationTerminationDate();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IBcPregnancyObservationTerminationDate extends IBcPregnancyObservation {
    value?: string | undefined;
}

export class BcPregnancyObservationTerminationType extends BcPregnancyObservation implements IBcPregnancyObservationTerminationType {
    value?: PregnancyTerminationType | undefined;

    constructor(data?: IBcPregnancyObservationTerminationType) {
        super(data);
        this._discriminator = "BcPregnancyObservationTerminationType";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): BcPregnancyObservationTerminationType {
        data = typeof data === 'object' ? data : {};
        let result = new BcPregnancyObservationTerminationType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IBcPregnancyObservationTerminationType extends IBcPregnancyObservation {
    value?: PregnancyTerminationType | undefined;
}

export enum PregnancyTerminationType {
    NoInformation = 0,
    Partus = 1,
    Miscarriage = 2,
    MiscarriageSpontaneous = 3,
    MiscarriageMedicinal = 4,
    MiscarriageInstrumental = 5,
    Apla = 6,
    AplaMedicinal = 7,
    AplaInstrumental = 8,
    EugTreated = 9,
    MolaTreated = 10,
}

export class BcWoman extends PatientModel implements IBcWoman {
    motherOf?: ReferenceModel | undefined;

    constructor(data?: IBcWoman) {
        super(data);
        this._discriminator = "BcWoman";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.motherOf = _data["motherOf"] ? ReferenceModel.fromJS(_data["motherOf"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): BcWoman {
        data = typeof data === 'object' ? data : {};
        let result = new BcWoman();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["motherOf"] = this.motherOf ? this.motherOf.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IBcWoman extends IPatientModel {
    motherOf?: ReferenceModel | undefined;
}

export class ZibApgarScore extends ResourceModel implements IZibApgarScore {
    type?: ApgarScoreType | undefined;
    dateTime?: string | undefined;
    value?: QuantityModel | undefined;
    comment?: string | undefined;
    respiratoryScore?: RespiratoryScore | undefined;
    appearanceScore?: AppearanceScore | undefined;
    pulseScore?: PulseScore | undefined;
    grimaceScore?: GrimaceScore | undefined;
    muscleToneScore?: MuscleToneScore | undefined;

    constructor(data?: IZibApgarScore) {
        super(data);
        this._discriminator = "ZibApgarScore";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            this.dateTime = _data["dateTime"];
            this.value = _data["value"] ? QuantityModel.fromJS(_data["value"]) : <any>undefined;
            this.comment = _data["comment"];
            this.respiratoryScore = _data["respiratoryScore"];
            this.appearanceScore = _data["appearanceScore"];
            this.pulseScore = _data["pulseScore"];
            this.grimaceScore = _data["grimaceScore"];
            this.muscleToneScore = _data["muscleToneScore"];
        }
    }

    static override fromJS(data: any): ZibApgarScore {
        data = typeof data === 'object' ? data : {};
        let result = new ZibApgarScore();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["dateTime"] = this.dateTime;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        data["comment"] = this.comment;
        data["respiratoryScore"] = this.respiratoryScore;
        data["appearanceScore"] = this.appearanceScore;
        data["pulseScore"] = this.pulseScore;
        data["grimaceScore"] = this.grimaceScore;
        data["muscleToneScore"] = this.muscleToneScore;
        super.toJSON(data);
        return data;
    }
}

export interface IZibApgarScore extends IResourceModel {
    type?: ApgarScoreType | undefined;
    dateTime?: string | undefined;
    value?: QuantityModel | undefined;
    comment?: string | undefined;
    respiratoryScore?: RespiratoryScore | undefined;
    appearanceScore?: AppearanceScore | undefined;
    pulseScore?: PulseScore | undefined;
    grimaceScore?: GrimaceScore | undefined;
    muscleToneScore?: MuscleToneScore | undefined;
}

export enum ApgarScoreType {
    OneMinute = 1,
    FiveMinute = 2,
    TenMinute = 3,
}

export enum RespiratoryScore {
    NotBreathing = 1,
    WeakCry = 2,
    StrongCry = 3,
}

export enum AppearanceScore {
    Bluish = 1,
    GoodColorWithBluish = 2,
    GoodColor = 3,
}

export enum PulseScore {
    NoHeartRate = 1,
    FewerThan100Bpm = 2,
    AtLeast100Bpm = 3,
}

export enum GrimaceScore {
    NoResponse = 0,
    WeakResponse = 1,
    Response = 2,
}

export enum MuscleToneScore {
    Limp = 1,
    SomeFlexion = 2,
    ActiveMotion = 3,
}

export class ZibPregnancy extends ResourceModel implements IZibPregnancy {
    clinicalStatus?: ClinicalStatus | undefined;
    comments?: CommentModel[] | undefined;

    constructor(data?: IZibPregnancy) {
        super(data);
        this._discriminator = "ZibPregnancy";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.clinicalStatus = _data["clinicalStatus"];
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(CommentModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ZibPregnancy {
        data = typeof data === 'object' ? data : {};
        let result = new ZibPregnancy();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clinicalStatus"] = this.clinicalStatus;
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IZibPregnancy extends IResourceModel {
    clinicalStatus?: ClinicalStatus | undefined;
    comments?: CommentModel[] | undefined;
}

export class ZibPregnancyGravidity extends ResourceModel implements IZibPregnancyGravidity {
    pregnancy?: ReferenceModel | undefined;
    gravidity?: QuantityModel | undefined;

    constructor(data?: IZibPregnancyGravidity) {
        super(data);
        this._discriminator = "ZibPregnancyGravidity";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pregnancy = _data["pregnancy"] ? ReferenceModel.fromJS(_data["pregnancy"]) : <any>undefined;
            this.gravidity = _data["gravidity"] ? QuantityModel.fromJS(_data["gravidity"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ZibPregnancyGravidity {
        data = typeof data === 'object' ? data : {};
        let result = new ZibPregnancyGravidity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pregnancy"] = this.pregnancy ? this.pregnancy.toJSON() : <any>undefined;
        data["gravidity"] = this.gravidity ? this.gravidity.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IZibPregnancyGravidity extends IResourceModel {
    pregnancy?: ReferenceModel | undefined;
    gravidity?: QuantityModel | undefined;
}

export class ZibPregnancyParity extends ResourceModel implements IZibPregnancyParity {
    pregnancy?: ReferenceModel | undefined;
    parity?: QuantityModel | undefined;

    constructor(data?: IZibPregnancyParity) {
        super(data);
        this._discriminator = "ZibPregnancyParity";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pregnancy = _data["pregnancy"] ? ReferenceModel.fromJS(_data["pregnancy"]) : <any>undefined;
            this.parity = _data["parity"] ? QuantityModel.fromJS(_data["parity"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ZibPregnancyParity {
        data = typeof data === 'object' ? data : {};
        let result = new ZibPregnancyParity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pregnancy"] = this.pregnancy ? this.pregnancy.toJSON() : <any>undefined;
        data["parity"] = this.parity ? this.parity.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IZibPregnancyParity extends IResourceModel {
    pregnancy?: ReferenceModel | undefined;
    parity?: QuantityModel | undefined;
}

export class ZibPregnancyTermDate extends ResourceModel implements IZibPregnancyTermDate {
    pregnancy?: ReferenceModel | undefined;
    termDate?: string | undefined;

    constructor(data?: IZibPregnancyTermDate) {
        super(data);
        this._discriminator = "ZibPregnancyTermDate";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pregnancy = _data["pregnancy"] ? ReferenceModel.fromJS(_data["pregnancy"]) : <any>undefined;
            this.termDate = _data["termDate"];
        }
    }

    static override fromJS(data: any): ZibPregnancyTermDate {
        data = typeof data === 'object' ? data : {};
        let result = new ZibPregnancyTermDate();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pregnancy"] = this.pregnancy ? this.pregnancy.toJSON() : <any>undefined;
        data["termDate"] = this.termDate;
        super.toJSON(data);
        return data;
    }
}

export interface IZibPregnancyTermDate extends IResourceModel {
    pregnancy?: ReferenceModel | undefined;
    termDate?: string | undefined;
}

export class GoalModel extends ResourceModel implements IGoalModel {
    addresses?: ReferenceModel[] | undefined;
    expressedBy?: ReferenceModel | undefined;
    subject?: ReferenceModel | undefined;
    description?: string | undefined;
    status?: GoalStatus;
    target?: TargetModel | undefined;

    constructor(data?: IGoalModel) {
        super(data);
        this._discriminator = "GoalModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(ReferenceModel.fromJS(item));
            }
            this.expressedBy = _data["expressedBy"] ? ReferenceModel.fromJS(_data["expressedBy"]) : <any>undefined;
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            this.description = _data["description"];
            this.status = _data["status"];
            this.target = _data["target"] ? TargetModel.fromJS(_data["target"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): GoalModel {
        data = typeof data === 'object' ? data : {};
        let result = new GoalModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        data["expressedBy"] = this.expressedBy ? this.expressedBy.toJSON() : <any>undefined;
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        data["description"] = this.description;
        data["status"] = this.status;
        data["target"] = this.target ? this.target.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGoalModel extends IResourceModel {
    addresses?: ReferenceModel[] | undefined;
    expressedBy?: ReferenceModel | undefined;
    subject?: ReferenceModel | undefined;
    description?: string | undefined;
    status?: GoalStatus;
    target?: TargetModel | undefined;
}

export enum GoalStatus {
    Proposed = 0,
    Accepted = 1,
    Planned = 2,
    InProgress = 3,
    OnTarget = 4,
    AheadOfTarget = 5,
    BehindTarget = 6,
    Sustaining = 7,
    Achieved = 8,
    OnHold = 9,
    Cancelled = 10,
    EnteredInError = 11,
    Rejected = 12,
    Unknown = 999,
}

export class TargetModel implements ITargetModel {
    measure?: string | undefined;
    detail?: QuantityModel | undefined;

    constructor(data?: ITargetModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.measure = _data["measure"];
            this.detail = _data["detail"] ? QuantityModel.fromJS(_data["detail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TargetModel {
        data = typeof data === 'object' ? data : {};
        let result = new TargetModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["measure"] = this.measure;
        data["detail"] = this.detail ? this.detail.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITargetModel {
    measure?: string | undefined;
    detail?: QuantityModel | undefined;
}

export class NutritionAdviceModel extends ResourceModel implements INutritionAdviceModel {
    comment?: string | undefined;
    dateTime?: string | undefined;
    types?: string[] | undefined;
    textures?: TextureModel[] | undefined;
    fluidTypes?: string[] | undefined;
    patient?: ReferenceModel | undefined;
    encounter?: ReferenceModel | undefined;
    orderer?: ReferenceModel | undefined;
    allergyIntolerance?: ReferenceModel[] | undefined;

    constructor(data?: INutritionAdviceModel) {
        super(data);
        this._discriminator = "NutritionAdviceModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.comment = _data["comment"];
            this.dateTime = _data["dateTime"];
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
            if (Array.isArray(_data["textures"])) {
                this.textures = [] as any;
                for (let item of _data["textures"])
                    this.textures!.push(TextureModel.fromJS(item));
            }
            if (Array.isArray(_data["fluidTypes"])) {
                this.fluidTypes = [] as any;
                for (let item of _data["fluidTypes"])
                    this.fluidTypes!.push(item);
            }
            this.patient = _data["patient"] ? ReferenceModel.fromJS(_data["patient"]) : <any>undefined;
            this.encounter = _data["encounter"] ? ReferenceModel.fromJS(_data["encounter"]) : <any>undefined;
            this.orderer = _data["orderer"] ? ReferenceModel.fromJS(_data["orderer"]) : <any>undefined;
            if (Array.isArray(_data["allergyIntolerance"])) {
                this.allergyIntolerance = [] as any;
                for (let item of _data["allergyIntolerance"])
                    this.allergyIntolerance!.push(ReferenceModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): NutritionAdviceModel {
        data = typeof data === 'object' ? data : {};
        let result = new NutritionAdviceModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment;
        data["dateTime"] = this.dateTime;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        if (Array.isArray(this.textures)) {
            data["textures"] = [];
            for (let item of this.textures)
                data["textures"].push(item.toJSON());
        }
        if (Array.isArray(this.fluidTypes)) {
            data["fluidTypes"] = [];
            for (let item of this.fluidTypes)
                data["fluidTypes"].push(item);
        }
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["encounter"] = this.encounter ? this.encounter.toJSON() : <any>undefined;
        data["orderer"] = this.orderer ? this.orderer.toJSON() : <any>undefined;
        if (Array.isArray(this.allergyIntolerance)) {
            data["allergyIntolerance"] = [];
            for (let item of this.allergyIntolerance)
                data["allergyIntolerance"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface INutritionAdviceModel extends IResourceModel {
    comment?: string | undefined;
    dateTime?: string | undefined;
    types?: string[] | undefined;
    textures?: TextureModel[] | undefined;
    fluidTypes?: string[] | undefined;
    patient?: ReferenceModel | undefined;
    encounter?: ReferenceModel | undefined;
    orderer?: ReferenceModel | undefined;
    allergyIntolerance?: ReferenceModel[] | undefined;
}

export class TextureModel implements ITextureModel {
    modifier?: string | undefined;
    foodType?: string | undefined;

    constructor(data?: ITextureModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modifier = _data["modifier"];
            this.foodType = _data["foodType"];
        }
    }

    static fromJS(data: any): TextureModel {
        data = typeof data === 'object' ? data : {};
        let result = new TextureModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modifier"] = this.modifier;
        data["foodType"] = this.foodType;
        return data;
    }
}

export interface ITextureModel {
    modifier?: string | undefined;
    foodType?: string | undefined;
}

export class CategoryModel implements ICategoryModel {
    code?: string | undefined;
    text?: string | undefined;

    constructor(data?: ICategoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): CategoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["text"] = this.text;
        return data;
    }
}

export interface ICategoryModel {
    code?: string | undefined;
    text?: string | undefined;
}

export enum MedicationDispenseStatus {
    Unknown = 0,
    Preparation = 1,
    InProgress = 2,
    OnHold = 3,
    Completed = 4,
    EnteredInError = 5,
    Stopped = 6,
}

export enum TreatmentStopType {
    Unknown = 0,
    Temporary = 1,
    Permanent = 2,
}

export class InstructionsModel implements IInstructionsModel {
    description?: string | undefined;
    instructions?: InstructionModel[] | undefined;

    constructor(data?: IInstructionsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            if (Array.isArray(_data["instructions"])) {
                this.instructions = [] as any;
                for (let item of _data["instructions"])
                    this.instructions!.push(InstructionModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InstructionsModel {
        data = typeof data === 'object' ? data : {};
        let result = new InstructionsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        if (Array.isArray(this.instructions)) {
            data["instructions"] = [];
            for (let item of this.instructions)
                data["instructions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInstructionsModel {
    description?: string | undefined;
    instructions?: InstructionModel[] | undefined;
}

export class InstructionModel implements IInstructionModel {
    sequence?: number | undefined;
    additionalInstructions?: string[] | undefined;
    timing?: AdministrationScheduleModel | undefined;
    criteria?: string[] | undefined;
    route?: string | undefined;
    dose?: InstructionDoseModel | undefined;
    maxDosePerPeriod?: RatioModel | undefined;
    rate?: InstructionRateModel | undefined;

    constructor(data?: IInstructionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sequence = _data["sequence"];
            if (Array.isArray(_data["additionalInstructions"])) {
                this.additionalInstructions = [] as any;
                for (let item of _data["additionalInstructions"])
                    this.additionalInstructions!.push(item);
            }
            this.timing = _data["timing"] ? AdministrationScheduleModel.fromJS(_data["timing"]) : <any>undefined;
            if (Array.isArray(_data["criteria"])) {
                this.criteria = [] as any;
                for (let item of _data["criteria"])
                    this.criteria!.push(item);
            }
            this.route = _data["route"];
            this.dose = _data["dose"] ? InstructionDoseModel.fromJS(_data["dose"]) : <any>undefined;
            this.maxDosePerPeriod = _data["maxDosePerPeriod"] ? RatioModel.fromJS(_data["maxDosePerPeriod"]) : <any>undefined;
            this.rate = _data["rate"] ? InstructionRateModel.fromJS(_data["rate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InstructionModel {
        data = typeof data === 'object' ? data : {};
        let result = new InstructionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sequence"] = this.sequence;
        if (Array.isArray(this.additionalInstructions)) {
            data["additionalInstructions"] = [];
            for (let item of this.additionalInstructions)
                data["additionalInstructions"].push(item);
        }
        data["timing"] = this.timing ? this.timing.toJSON() : <any>undefined;
        if (Array.isArray(this.criteria)) {
            data["criteria"] = [];
            for (let item of this.criteria)
                data["criteria"].push(item);
        }
        data["route"] = this.route;
        data["dose"] = this.dose ? this.dose.toJSON() : <any>undefined;
        data["maxDosePerPeriod"] = this.maxDosePerPeriod ? this.maxDosePerPeriod.toJSON() : <any>undefined;
        data["rate"] = this.rate ? this.rate.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInstructionModel {
    sequence?: number | undefined;
    additionalInstructions?: string[] | undefined;
    timing?: AdministrationScheduleModel | undefined;
    criteria?: string[] | undefined;
    route?: string | undefined;
    dose?: InstructionDoseModel | undefined;
    maxDosePerPeriod?: RatioModel | undefined;
    rate?: InstructionRateModel | undefined;
}

export class AdministrationScheduleModel implements IAdministrationScheduleModel {
    exact?: boolean;
    bounds?: AdministrationScheduleBoundsModel | undefined;
    duration?: number | undefined;
    durationUnit?: string | undefined;
    frequency?: number | undefined;
    frequencyMax?: number | undefined;
    period?: number | undefined;
    periodUnit?: string | undefined;
    daysOfWeek?: DayOfWeek[] | undefined;
    timesOfDay?: string[] | undefined;
    eventTimings?: EventTiming[] | undefined;

    constructor(data?: IAdministrationScheduleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exact = _data["exact"];
            this.bounds = _data["bounds"] ? AdministrationScheduleBoundsModel.fromJS(_data["bounds"]) : <any>undefined;
            this.duration = _data["duration"];
            this.durationUnit = _data["durationUnit"];
            this.frequency = _data["frequency"];
            this.frequencyMax = _data["frequencyMax"];
            this.period = _data["period"];
            this.periodUnit = _data["periodUnit"];
            if (Array.isArray(_data["daysOfWeek"])) {
                this.daysOfWeek = [] as any;
                for (let item of _data["daysOfWeek"])
                    this.daysOfWeek!.push(item);
            }
            if (Array.isArray(_data["timesOfDay"])) {
                this.timesOfDay = [] as any;
                for (let item of _data["timesOfDay"])
                    this.timesOfDay!.push(item);
            }
            if (Array.isArray(_data["eventTimings"])) {
                this.eventTimings = [] as any;
                for (let item of _data["eventTimings"])
                    this.eventTimings!.push(item);
            }
        }
    }

    static fromJS(data: any): AdministrationScheduleModel {
        data = typeof data === 'object' ? data : {};
        let result = new AdministrationScheduleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exact"] = this.exact;
        data["bounds"] = this.bounds ? this.bounds.toJSON() : <any>undefined;
        data["duration"] = this.duration;
        data["durationUnit"] = this.durationUnit;
        data["frequency"] = this.frequency;
        data["frequencyMax"] = this.frequencyMax;
        data["period"] = this.period;
        data["periodUnit"] = this.periodUnit;
        if (Array.isArray(this.daysOfWeek)) {
            data["daysOfWeek"] = [];
            for (let item of this.daysOfWeek)
                data["daysOfWeek"].push(item);
        }
        if (Array.isArray(this.timesOfDay)) {
            data["timesOfDay"] = [];
            for (let item of this.timesOfDay)
                data["timesOfDay"].push(item);
        }
        if (Array.isArray(this.eventTimings)) {
            data["eventTimings"] = [];
            for (let item of this.eventTimings)
                data["eventTimings"].push(item);
        }
        return data;
    }
}

export interface IAdministrationScheduleModel {
    exact?: boolean;
    bounds?: AdministrationScheduleBoundsModel | undefined;
    duration?: number | undefined;
    durationUnit?: string | undefined;
    frequency?: number | undefined;
    frequencyMax?: number | undefined;
    period?: number | undefined;
    periodUnit?: string | undefined;
    daysOfWeek?: DayOfWeek[] | undefined;
    timesOfDay?: string[] | undefined;
    eventTimings?: EventTiming[] | undefined;
}

export class AdministrationScheduleBoundsModel implements IAdministrationScheduleBoundsModel {
    duration?: DurationModel | undefined;
    period?: PeriodModel | undefined;
    range?: RangeModel | undefined;

    constructor(data?: IAdministrationScheduleBoundsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.duration = _data["duration"] ? DurationModel.fromJS(_data["duration"]) : <any>undefined;
            this.period = _data["period"] ? PeriodModel.fromJS(_data["period"]) : <any>undefined;
            this.range = _data["range"] ? RangeModel.fromJS(_data["range"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AdministrationScheduleBoundsModel {
        data = typeof data === 'object' ? data : {};
        let result = new AdministrationScheduleBoundsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["duration"] = this.duration ? this.duration.toJSON() : <any>undefined;
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        data["range"] = this.range ? this.range.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAdministrationScheduleBoundsModel {
    duration?: DurationModel | undefined;
    period?: PeriodModel | undefined;
    range?: RangeModel | undefined;
}

export enum DayOfWeek {
    Unknown = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
    Sunday = 7,
}

export enum EventTiming {
    Unknown = 0,
    Morning = 1,
    Afternoon = 2,
    Evening = 3,
    Night = 4,
}

export class InstructionDoseModel implements IInstructionDoseModel {
    quantity?: QuantityModel | undefined;
    range?: RangeModel | undefined;

    constructor(data?: IInstructionDoseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantity = _data["quantity"] ? QuantityModel.fromJS(_data["quantity"]) : <any>undefined;
            this.range = _data["range"] ? RangeModel.fromJS(_data["range"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InstructionDoseModel {
        data = typeof data === 'object' ? data : {};
        let result = new InstructionDoseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity ? this.quantity.toJSON() : <any>undefined;
        data["range"] = this.range ? this.range.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInstructionDoseModel {
    quantity?: QuantityModel | undefined;
    range?: RangeModel | undefined;
}

export class AdvanceDirectiveModel extends ResourceModel implements IAdvanceDirectiveModel {
    date?: string | undefined;
    consentingParty?: ReferenceModel | undefined;
    type?: AdvanceDirectiveType;
    comment?: string | undefined;
    disorder?: ReferenceModel | undefined;
    organization?: ReferenceModel | undefined;
    patientReference?: ReferenceModel | undefined;
    consentingPartyReferences?: ReferenceModel[] | undefined;
    actors?: ActorModel[] | undefined;
    organizationReferences?: ReferenceModel[] | undefined;
    livingWillDocument?: AttachmentModel | undefined;
    livingWillDocumentReference?: ReferenceModel | undefined;
    policies?: string[] | undefined;

    constructor(data?: IAdvanceDirectiveModel) {
        super(data);
        this._discriminator = "AdvanceDirectiveModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.date = _data["date"];
            this.consentingParty = _data["consentingParty"] ? ReferenceModel.fromJS(_data["consentingParty"]) : <any>undefined;
            this.type = _data["type"];
            this.comment = _data["comment"];
            this.disorder = _data["disorder"] ? ReferenceModel.fromJS(_data["disorder"]) : <any>undefined;
            this.organization = _data["organization"] ? ReferenceModel.fromJS(_data["organization"]) : <any>undefined;
            this.patientReference = _data["patientReference"] ? ReferenceModel.fromJS(_data["patientReference"]) : <any>undefined;
            if (Array.isArray(_data["consentingPartyReferences"])) {
                this.consentingPartyReferences = [] as any;
                for (let item of _data["consentingPartyReferences"])
                    this.consentingPartyReferences!.push(ReferenceModel.fromJS(item));
            }
            if (Array.isArray(_data["actors"])) {
                this.actors = [] as any;
                for (let item of _data["actors"])
                    this.actors!.push(ActorModel.fromJS(item));
            }
            if (Array.isArray(_data["organizationReferences"])) {
                this.organizationReferences = [] as any;
                for (let item of _data["organizationReferences"])
                    this.organizationReferences!.push(ReferenceModel.fromJS(item));
            }
            this.livingWillDocument = _data["livingWillDocument"] ? AttachmentModel.fromJS(_data["livingWillDocument"]) : <any>undefined;
            this.livingWillDocumentReference = _data["livingWillDocumentReference"] ? ReferenceModel.fromJS(_data["livingWillDocumentReference"]) : <any>undefined;
            if (Array.isArray(_data["policies"])) {
                this.policies = [] as any;
                for (let item of _data["policies"])
                    this.policies!.push(item);
            }
        }
    }

    static override fromJS(data: any): AdvanceDirectiveModel {
        data = typeof data === 'object' ? data : {};
        let result = new AdvanceDirectiveModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["consentingParty"] = this.consentingParty ? this.consentingParty.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["comment"] = this.comment;
        data["disorder"] = this.disorder ? this.disorder.toJSON() : <any>undefined;
        data["organization"] = this.organization ? this.organization.toJSON() : <any>undefined;
        data["patientReference"] = this.patientReference ? this.patientReference.toJSON() : <any>undefined;
        if (Array.isArray(this.consentingPartyReferences)) {
            data["consentingPartyReferences"] = [];
            for (let item of this.consentingPartyReferences)
                data["consentingPartyReferences"].push(item.toJSON());
        }
        if (Array.isArray(this.actors)) {
            data["actors"] = [];
            for (let item of this.actors)
                data["actors"].push(item.toJSON());
        }
        if (Array.isArray(this.organizationReferences)) {
            data["organizationReferences"] = [];
            for (let item of this.organizationReferences)
                data["organizationReferences"].push(item.toJSON());
        }
        data["livingWillDocument"] = this.livingWillDocument ? this.livingWillDocument.toJSON() : <any>undefined;
        data["livingWillDocumentReference"] = this.livingWillDocumentReference ? this.livingWillDocumentReference.toJSON() : <any>undefined;
        if (Array.isArray(this.policies)) {
            data["policies"] = [];
            for (let item of this.policies)
                data["policies"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IAdvanceDirectiveModel extends IResourceModel {
    date?: string | undefined;
    consentingParty?: ReferenceModel | undefined;
    type?: AdvanceDirectiveType;
    comment?: string | undefined;
    disorder?: ReferenceModel | undefined;
    organization?: ReferenceModel | undefined;
    patientReference?: ReferenceModel | undefined;
    consentingPartyReferences?: ReferenceModel[] | undefined;
    actors?: ActorModel[] | undefined;
    organizationReferences?: ReferenceModel[] | undefined;
    livingWillDocument?: AttachmentModel | undefined;
    livingWillDocumentReference?: ReferenceModel | undefined;
    policies?: string[] | undefined;
}

export enum AdvanceDirectiveType {
    Other = 0,
    DoNotResuscitate = 1,
    Proxy = 2,
    Contraindication = 3,
    ContraindicationWithEndOfLife = 4,
    OralAgreement = 5,
    EuthanasiaRequest = 6,
    EuthanasiaRequestWithDementia = 7,
    DeclarationOfLife = 8,
    DeclerationOfDonorship = 9,
}

export class ActorModel implements IActorModel {
    reference?: ReferenceModel | undefined;

    constructor(data?: IActorModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reference = _data["reference"] ? ReferenceModel.fromJS(_data["reference"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ActorModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActorModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reference"] = this.reference ? this.reference.toJSON() : <any>undefined;
        return data;
    }
}

export interface IActorModel {
    reference?: ReferenceModel | undefined;
}

export class AlcoholUseModel extends ObservationBaseModel implements IAlcoholUseModel {
    period?: PeriodModel | undefined;
    type?: AlcoholUseType;
    comment?: string | undefined;
    subject?: ReferenceModel | undefined;
    performers?: ReferenceModel[] | undefined;
    alcoholAmount?: QuantityModel | undefined;

    constructor(data?: IAlcoholUseModel) {
        super(data);
        this._discriminator = "AlcoholUseModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.period = _data["period"] ? PeriodModel.fromJS(_data["period"]) : <any>undefined;
            this.type = _data["type"];
            this.comment = _data["comment"];
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            if (Array.isArray(_data["performers"])) {
                this.performers = [] as any;
                for (let item of _data["performers"])
                    this.performers!.push(ReferenceModel.fromJS(item));
            }
            this.alcoholAmount = _data["alcoholAmount"] ? QuantityModel.fromJS(_data["alcoholAmount"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): AlcoholUseModel {
        data = typeof data === 'object' ? data : {};
        let result = new AlcoholUseModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["comment"] = this.comment;
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        if (Array.isArray(this.performers)) {
            data["performers"] = [];
            for (let item of this.performers)
                data["performers"].push(item.toJSON());
        }
        data["alcoholAmount"] = this.alcoholAmount ? this.alcoholAmount.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAlcoholUseModel extends IObservationBaseModel {
    period?: PeriodModel | undefined;
    type?: AlcoholUseType;
    comment?: string | undefined;
    subject?: ReferenceModel | undefined;
    performers?: ReferenceModel[] | undefined;
    alcoholAmount?: QuantityModel | undefined;
}

export enum AlcoholUseType {
    Other = 0,
    CurrentDrinker = 1,
    CurrentNonDrinker = 2,
    ExDrinker = 3,
    LifetimeNonDrinker = 4,
}

export class AlertModel extends ResourceModel implements IAlertModel {
    author?: ReferenceModel | undefined;
    problem?: ReferenceModel | undefined;
    encounter?: ReferenceModel | undefined;
    name?: AlertName | undefined;
    nameString?: string | undefined;
    period?: PeriodModel | undefined;
    subject?: ReferenceModel | undefined;
    type?: AlertType | undefined;

    constructor(data?: IAlertModel) {
        super(data);
        this._discriminator = "AlertModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.author = _data["author"] ? ReferenceModel.fromJS(_data["author"]) : <any>undefined;
            this.problem = _data["problem"] ? ReferenceModel.fromJS(_data["problem"]) : <any>undefined;
            this.encounter = _data["encounter"] ? ReferenceModel.fromJS(_data["encounter"]) : <any>undefined;
            this.name = _data["name"];
            this.nameString = _data["nameString"];
            this.period = _data["period"] ? PeriodModel.fromJS(_data["period"]) : <any>undefined;
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            this.type = _data["type"];
        }
    }

    static override fromJS(data: any): AlertModel {
        data = typeof data === 'object' ? data : {};
        let result = new AlertModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["author"] = this.author ? this.author.toJSON() : <any>undefined;
        data["problem"] = this.problem ? this.problem.toJSON() : <any>undefined;
        data["encounter"] = this.encounter ? this.encounter.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["nameString"] = this.nameString;
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        data["type"] = this.type;
        super.toJSON(data);
        return data;
    }
}

export interface IAlertModel extends IResourceModel {
    author?: ReferenceModel | undefined;
    problem?: ReferenceModel | undefined;
    encounter?: ReferenceModel | undefined;
    name?: AlertName | undefined;
    nameString?: string | undefined;
    period?: PeriodModel | undefined;
    subject?: ReferenceModel | undefined;
    type?: AlertType | undefined;
}

export enum AlertName {
    Other = 0,
    InfectiousDiseaseCarrier = 1,
    MrsaCarrier = 2,
    VreCarrier = 3,
    HivCarrier = 4,
    VictimOfChildAbuse = 5,
}

export enum AlertType {
    Condition = 0,
    Alert = 1,
}

export class DrugUseModel extends ObservationBaseModel implements IDrugUseModel {
    period?: PeriodModel | undefined;
    type?: DrugUseType;
    comment?: string | undefined;
    subject?: ReferenceModel | undefined;
    performers?: ReferenceModel[] | undefined;
    drugType?: DrugType;
    drugAdministrationRoute?: AdministrationRoute;
    drugAmount?: string | undefined;

    constructor(data?: IDrugUseModel) {
        super(data);
        this._discriminator = "DrugUseModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.period = _data["period"] ? PeriodModel.fromJS(_data["period"]) : <any>undefined;
            this.type = _data["type"];
            this.comment = _data["comment"];
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            if (Array.isArray(_data["performers"])) {
                this.performers = [] as any;
                for (let item of _data["performers"])
                    this.performers!.push(ReferenceModel.fromJS(item));
            }
            this.drugType = _data["drugType"];
            this.drugAdministrationRoute = _data["drugAdministrationRoute"];
            this.drugAmount = _data["drugAmount"];
        }
    }

    static override fromJS(data: any): DrugUseModel {
        data = typeof data === 'object' ? data : {};
        let result = new DrugUseModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["comment"] = this.comment;
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        if (Array.isArray(this.performers)) {
            data["performers"] = [];
            for (let item of this.performers)
                data["performers"].push(item.toJSON());
        }
        data["drugType"] = this.drugType;
        data["drugAdministrationRoute"] = this.drugAdministrationRoute;
        data["drugAmount"] = this.drugAmount;
        super.toJSON(data);
        return data;
    }
}

export interface IDrugUseModel extends IObservationBaseModel {
    period?: PeriodModel | undefined;
    type?: DrugUseType;
    comment?: string | undefined;
    subject?: ReferenceModel | undefined;
    performers?: ReferenceModel[] | undefined;
    drugType?: DrugType;
    drugAdministrationRoute?: AdministrationRoute;
    drugAmount?: string | undefined;
}

export enum DrugUseType {
    Other = 0,
    Misuses = 1,
    DoesNotMisuse = 2,
    NeverMisused = 3,
    MisusedInThePast = 4,
}

export enum DrugType {
    Other = 0,
    Heroin = 1,
    Benzodiazepine = 2,
    Methadone = 3,
    HydroxybutyricAcid = 4,
    Cocaine = 5,
    CocaineFreebase = 6,
    Methylenedioxymethamphetamine = 7,
    Amphetamine = 8,
    Cannabis = 9,
    HallucinogenicMushrooms = 10,
    LysergicAcidDiethylamide = 11,
    Ketamine = 12,
    Phencyclidine = 13,
    Methamphetamine = 14,
    AnabolicSteroid = 15,
    Laxative = 16,
    Buprenorphine = 17,
    Fentanyl = 18,
    Barbiturate = 19,
}

export enum AdministrationRoute {
    Other = 0,
    Oral = 1,
    Nasal = 2,
    Inhalation = 3,
    Intravenous = 4,
}

export class LastFunctionalAndMentalStatusModel implements ILastFunctionalAndMentalStatusModel {
    lastFunctionalStatus?: FunctionalOrMentalStatusModel | undefined;
    lastMentalStatus?: FunctionalOrMentalStatusModel | undefined;

    constructor(data?: ILastFunctionalAndMentalStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastFunctionalStatus = _data["lastFunctionalStatus"] ? FunctionalOrMentalStatusModel.fromJS(_data["lastFunctionalStatus"]) : <any>undefined;
            this.lastMentalStatus = _data["lastMentalStatus"] ? FunctionalOrMentalStatusModel.fromJS(_data["lastMentalStatus"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LastFunctionalAndMentalStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new LastFunctionalAndMentalStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastFunctionalStatus"] = this.lastFunctionalStatus ? this.lastFunctionalStatus.toJSON() : <any>undefined;
        data["lastMentalStatus"] = this.lastMentalStatus ? this.lastMentalStatus.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILastFunctionalAndMentalStatusModel {
    lastFunctionalStatus?: FunctionalOrMentalStatusModel | undefined;
    lastMentalStatus?: FunctionalOrMentalStatusModel | undefined;
}

export class FunctionalOrMentalStatusModel extends ObservationBaseModel implements IFunctionalOrMentalStatusModel {
    comment?: string | undefined;
    statusType?: FunctionalOrMentalStatusType;
    period?: PeriodModel | undefined;
    type?: string | undefined;
    value?: string | undefined;
    subject?: ReferenceModel | undefined;
    context?: ReferenceModel | undefined;
    performers?: ReferenceModel[] | undefined;
    medicalDevice?: ReferenceModel | undefined;

    constructor(data?: IFunctionalOrMentalStatusModel) {
        super(data);
        this._discriminator = "FunctionalOrMentalStatusModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.comment = _data["comment"];
            this.statusType = _data["statusType"];
            this.period = _data["period"] ? PeriodModel.fromJS(_data["period"]) : <any>undefined;
            this.type = _data["type"];
            this.value = _data["value"];
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            this.context = _data["context"] ? ReferenceModel.fromJS(_data["context"]) : <any>undefined;
            if (Array.isArray(_data["performers"])) {
                this.performers = [] as any;
                for (let item of _data["performers"])
                    this.performers!.push(ReferenceModel.fromJS(item));
            }
            this.medicalDevice = _data["medicalDevice"] ? ReferenceModel.fromJS(_data["medicalDevice"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): FunctionalOrMentalStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new FunctionalOrMentalStatusModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment;
        data["statusType"] = this.statusType;
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["value"] = this.value;
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        data["context"] = this.context ? this.context.toJSON() : <any>undefined;
        if (Array.isArray(this.performers)) {
            data["performers"] = [];
            for (let item of this.performers)
                data["performers"].push(item.toJSON());
        }
        data["medicalDevice"] = this.medicalDevice ? this.medicalDevice.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFunctionalOrMentalStatusModel extends IObservationBaseModel {
    comment?: string | undefined;
    statusType?: FunctionalOrMentalStatusType;
    period?: PeriodModel | undefined;
    type?: string | undefined;
    value?: string | undefined;
    subject?: ReferenceModel | undefined;
    context?: ReferenceModel | undefined;
    performers?: ReferenceModel[] | undefined;
    medicalDevice?: ReferenceModel | undefined;
}

export enum FunctionalOrMentalStatusType {
    Functional = 1,
    Mental = 2,
}

export class LivingSituationModel extends ObservationBaseModel implements ILivingSituationModel {
    type?: LivingSituationType;
    comment?: string | undefined;
    subject?: ReferenceModel | undefined;
    context?: ReferenceModel | undefined;
    performers?: ReferenceModel[] | undefined;

    constructor(data?: ILivingSituationModel) {
        super(data);
        this._discriminator = "LivingSituationModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            this.comment = _data["comment"];
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            this.context = _data["context"] ? ReferenceModel.fromJS(_data["context"]) : <any>undefined;
            if (Array.isArray(_data["performers"])) {
                this.performers = [] as any;
                for (let item of _data["performers"])
                    this.performers!.push(ReferenceModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): LivingSituationModel {
        data = typeof data === 'object' ? data : {};
        let result = new LivingSituationModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["comment"] = this.comment;
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        data["context"] = this.context ? this.context.toJSON() : <any>undefined;
        if (Array.isArray(this.performers)) {
            data["performers"] = [];
            for (let item of this.performers)
                data["performers"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ILivingSituationModel extends IObservationBaseModel {
    type?: LivingSituationType;
    comment?: string | undefined;
    subject?: ReferenceModel | undefined;
    context?: ReferenceModel | undefined;
    performers?: ReferenceModel[] | undefined;
}

export enum LivingSituationType {
    Other = 0,
    Upstairs = 1,
    GroundFloor = 2,
    SingleFamilyHome = 3,
    Apartment = 4,
    ShelteredHome = 5,
    Houseboat = 6,
    Caravan = 7,
    Awbz = 8,
    Homeless = 9,
}

export class MedicalDeviceRequestModel extends ResourceModel implements IMedicalDeviceRequestModel {
    code?: MedicalDeviceRequestCodeModel | undefined;
    comments?: CommentModel[] | undefined;
    context?: ReferenceModel | undefined;
    identifiers?: IdentifierModel[] | undefined;
    occurence?: EffectiveModel | undefined;
    performerType?: ParticipantType | undefined;
    requester?: RequesterModel | undefined;
    status?: OrderStatus | undefined;
    subject?: ReferenceModel | undefined;

    constructor(data?: IMedicalDeviceRequestModel) {
        super(data);
        this._discriminator = "MedicalDeviceRequestModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"] ? MedicalDeviceRequestCodeModel.fromJS(_data["code"]) : <any>undefined;
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(CommentModel.fromJS(item));
            }
            this.context = _data["context"] ? ReferenceModel.fromJS(_data["context"]) : <any>undefined;
            if (Array.isArray(_data["identifiers"])) {
                this.identifiers = [] as any;
                for (let item of _data["identifiers"])
                    this.identifiers!.push(IdentifierModel.fromJS(item));
            }
            this.occurence = _data["occurence"] ? EffectiveModel.fromJS(_data["occurence"]) : <any>undefined;
            this.performerType = _data["performerType"];
            this.requester = _data["requester"] ? RequesterModel.fromJS(_data["requester"]) : <any>undefined;
            this.status = _data["status"];
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): MedicalDeviceRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalDeviceRequestModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code ? this.code.toJSON() : <any>undefined;
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        data["context"] = this.context ? this.context.toJSON() : <any>undefined;
        if (Array.isArray(this.identifiers)) {
            data["identifiers"] = [];
            for (let item of this.identifiers)
                data["identifiers"].push(item.toJSON());
        }
        data["occurence"] = this.occurence ? this.occurence.toJSON() : <any>undefined;
        data["performerType"] = this.performerType;
        data["requester"] = this.requester ? this.requester.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IMedicalDeviceRequestModel extends IResourceModel {
    code?: MedicalDeviceRequestCodeModel | undefined;
    comments?: CommentModel[] | undefined;
    context?: ReferenceModel | undefined;
    identifiers?: IdentifierModel[] | undefined;
    occurence?: EffectiveModel | undefined;
    performerType?: ParticipantType | undefined;
    requester?: RequesterModel | undefined;
    status?: OrderStatus | undefined;
    subject?: ReferenceModel | undefined;
}

export class MedicalDeviceRequestCodeModel implements IMedicalDeviceRequestCodeModel {
    code?: string | undefined;
    codeReference?: ReferenceModel | undefined;

    constructor(data?: IMedicalDeviceRequestCodeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.codeReference = _data["codeReference"] ? ReferenceModel.fromJS(_data["codeReference"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MedicalDeviceRequestCodeModel {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalDeviceRequestCodeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["codeReference"] = this.codeReference ? this.codeReference.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMedicalDeviceRequestCodeModel {
    code?: string | undefined;
    codeReference?: ReferenceModel | undefined;
}

export class RequesterModel implements IRequesterModel {
    agent?: ReferenceModel | undefined;
    onBehalfOf?: ReferenceModel | undefined;

    constructor(data?: IRequesterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agent = _data["agent"] ? ReferenceModel.fromJS(_data["agent"]) : <any>undefined;
            this.onBehalfOf = _data["onBehalfOf"] ? ReferenceModel.fromJS(_data["onBehalfOf"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RequesterModel {
        data = typeof data === 'object' ? data : {};
        let result = new RequesterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agent"] = this.agent ? this.agent.toJSON() : <any>undefined;
        data["onBehalfOf"] = this.onBehalfOf ? this.onBehalfOf.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRequesterModel {
    agent?: ReferenceModel | undefined;
    onBehalfOf?: ReferenceModel | undefined;
}

export class MedicationAgreementModel extends ResourceModel implements IMedicationAgreementModel {
    additionalInformation?: MedicationAgreementAdditionalInformation | undefined;
    authoredOn?: string | undefined;
    basedOnAgreementOrUseReference?: ReferenceModel | undefined;
    category?: CategoryModel | undefined;
    comments?: CommentModel[] | undefined;
    context?: ReferenceModel | undefined;
    copyIndicator?: boolean | undefined;
    identifiers?: IdentifierModel[] | undefined;
    instructions?: InstructionsModel | undefined;
    medication?: ReferenceModel | undefined;
    periodOfUse?: PeriodModel | undefined;
    prescriptionReason?: ReferenceModel[] | undefined;
    reasons?: string[] | undefined;
    recorder?: ReferenceModel | undefined;
    repeatPeriodCyclicalSchedule?: DurationModel | undefined;
    requester?: RequesterModel | undefined;
    status?: MedicationRequestStatus;
    subject?: ReferenceModel | undefined;
    supportingInformation?: SupportingInformationModel | undefined;
    treatment?: IdentifierModel | undefined;
    treatmentStopType?: TreatmentStopType | undefined;
    usageDuration?: DurationModel | undefined;

    constructor(data?: IMedicationAgreementModel) {
        super(data);
        this._discriminator = "MedicationAgreementModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.additionalInformation = _data["additionalInformation"];
            this.authoredOn = _data["authoredOn"];
            this.basedOnAgreementOrUseReference = _data["basedOnAgreementOrUseReference"] ? ReferenceModel.fromJS(_data["basedOnAgreementOrUseReference"]) : <any>undefined;
            this.category = _data["category"] ? CategoryModel.fromJS(_data["category"]) : <any>undefined;
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(CommentModel.fromJS(item));
            }
            this.context = _data["context"] ? ReferenceModel.fromJS(_data["context"]) : <any>undefined;
            this.copyIndicator = _data["copyIndicator"];
            if (Array.isArray(_data["identifiers"])) {
                this.identifiers = [] as any;
                for (let item of _data["identifiers"])
                    this.identifiers!.push(IdentifierModel.fromJS(item));
            }
            this.instructions = _data["instructions"] ? InstructionsModel.fromJS(_data["instructions"]) : <any>undefined;
            this.medication = _data["medication"] ? ReferenceModel.fromJS(_data["medication"]) : <any>undefined;
            this.periodOfUse = _data["periodOfUse"] ? PeriodModel.fromJS(_data["periodOfUse"]) : <any>undefined;
            if (Array.isArray(_data["prescriptionReason"])) {
                this.prescriptionReason = [] as any;
                for (let item of _data["prescriptionReason"])
                    this.prescriptionReason!.push(ReferenceModel.fromJS(item));
            }
            if (Array.isArray(_data["reasons"])) {
                this.reasons = [] as any;
                for (let item of _data["reasons"])
                    this.reasons!.push(item);
            }
            this.recorder = _data["recorder"] ? ReferenceModel.fromJS(_data["recorder"]) : <any>undefined;
            this.repeatPeriodCyclicalSchedule = _data["repeatPeriodCyclicalSchedule"] ? DurationModel.fromJS(_data["repeatPeriodCyclicalSchedule"]) : <any>undefined;
            this.requester = _data["requester"] ? RequesterModel.fromJS(_data["requester"]) : <any>undefined;
            this.status = _data["status"];
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            this.supportingInformation = _data["supportingInformation"] ? SupportingInformationModel.fromJS(_data["supportingInformation"]) : <any>undefined;
            this.treatment = _data["treatment"] ? IdentifierModel.fromJS(_data["treatment"]) : <any>undefined;
            this.treatmentStopType = _data["treatmentStopType"];
            this.usageDuration = _data["usageDuration"] ? DurationModel.fromJS(_data["usageDuration"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): MedicationAgreementModel {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationAgreementModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additionalInformation"] = this.additionalInformation;
        data["authoredOn"] = this.authoredOn;
        data["basedOnAgreementOrUseReference"] = this.basedOnAgreementOrUseReference ? this.basedOnAgreementOrUseReference.toJSON() : <any>undefined;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        data["context"] = this.context ? this.context.toJSON() : <any>undefined;
        data["copyIndicator"] = this.copyIndicator;
        if (Array.isArray(this.identifiers)) {
            data["identifiers"] = [];
            for (let item of this.identifiers)
                data["identifiers"].push(item.toJSON());
        }
        data["instructions"] = this.instructions ? this.instructions.toJSON() : <any>undefined;
        data["medication"] = this.medication ? this.medication.toJSON() : <any>undefined;
        data["periodOfUse"] = this.periodOfUse ? this.periodOfUse.toJSON() : <any>undefined;
        if (Array.isArray(this.prescriptionReason)) {
            data["prescriptionReason"] = [];
            for (let item of this.prescriptionReason)
                data["prescriptionReason"].push(item.toJSON());
        }
        if (Array.isArray(this.reasons)) {
            data["reasons"] = [];
            for (let item of this.reasons)
                data["reasons"].push(item);
        }
        data["recorder"] = this.recorder ? this.recorder.toJSON() : <any>undefined;
        data["repeatPeriodCyclicalSchedule"] = this.repeatPeriodCyclicalSchedule ? this.repeatPeriodCyclicalSchedule.toJSON() : <any>undefined;
        data["requester"] = this.requester ? this.requester.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        data["supportingInformation"] = this.supportingInformation ? this.supportingInformation.toJSON() : <any>undefined;
        data["treatment"] = this.treatment ? this.treatment.toJSON() : <any>undefined;
        data["treatmentStopType"] = this.treatmentStopType;
        data["usageDuration"] = this.usageDuration ? this.usageDuration.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IMedicationAgreementModel extends IResourceModel {
    additionalInformation?: MedicationAgreementAdditionalInformation | undefined;
    authoredOn?: string | undefined;
    basedOnAgreementOrUseReference?: ReferenceModel | undefined;
    category?: CategoryModel | undefined;
    comments?: CommentModel[] | undefined;
    context?: ReferenceModel | undefined;
    copyIndicator?: boolean | undefined;
    identifiers?: IdentifierModel[] | undefined;
    instructions?: InstructionsModel | undefined;
    medication?: ReferenceModel | undefined;
    periodOfUse?: PeriodModel | undefined;
    prescriptionReason?: ReferenceModel[] | undefined;
    reasons?: string[] | undefined;
    recorder?: ReferenceModel | undefined;
    repeatPeriodCyclicalSchedule?: DurationModel | undefined;
    requester?: RequesterModel | undefined;
    status?: MedicationRequestStatus;
    subject?: ReferenceModel | undefined;
    supportingInformation?: SupportingInformationModel | undefined;
    treatment?: IdentifierModel | undefined;
    treatmentStopType?: TreatmentStopType | undefined;
    usageDuration?: DurationModel | undefined;
}

export enum MedicationAgreementAdditionalInformation {
    Unknown = 0,
    DeliberatelyHighDosage = 1,
    DeliberatelyLowDosage = 2,
    DivergentAdministrationRoute = 3,
    MedicalNecessity = 4,
    Prophylaxis = 5,
    ChangeGdsPerDirect = 6,
    ChangeGdsPerRollSwitch = 7,
}

export enum MedicationRequestStatus {
    Unknown = 0,
    Active = 1,
    OnHold = 2,
    Cancelled = 3,
    Completed = 4,
    EnteredInError = 5,
    Stopped = 6,
    Draft = 7,
}

export class SupportingInformationModel implements ISupportingInformationModel {
    bodyHeight?: ReferenceModel | undefined;
    bodyWeight?: ReferenceModel | undefined;

    constructor(data?: ISupportingInformationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bodyHeight = _data["bodyHeight"] ? ReferenceModel.fromJS(_data["bodyHeight"]) : <any>undefined;
            this.bodyWeight = _data["bodyWeight"] ? ReferenceModel.fromJS(_data["bodyWeight"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SupportingInformationModel {
        data = typeof data === 'object' ? data : {};
        let result = new SupportingInformationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bodyHeight"] = this.bodyHeight ? this.bodyHeight.toJSON() : <any>undefined;
        data["bodyWeight"] = this.bodyWeight ? this.bodyWeight.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISupportingInformationModel {
    bodyHeight?: ReferenceModel | undefined;
    bodyWeight?: ReferenceModel | undefined;
}

export class MedicationUseModel extends ResourceModel implements IMedicationUseModel {
    identifiers?: IdentifierModel[] | undefined;
    asAgreed?: boolean | undefined;
    assertedDateTime?: string | undefined;
    author?: ReferenceModel | undefined;
    comments?: CommentModel[] | undefined;
    copyIndicator?: boolean | undefined;
    effectiveDuration?: DurationModel | undefined;
    effectivePeriod?: PeriodModel | undefined;
    instructions?: InstructionsModel | undefined;
    medication?: MedicationModel | undefined;
    notTakenReasons?: (ChangeOfUseReason | undefined)[] | undefined;
    practitionerRole?: ReferenceModel | undefined;
    prescriber?: ReferenceModel | undefined;
    reasonForChange?: ChangeOfUseReason | undefined;
    reasons?: string[] | undefined;
    status?: MedicationUseStatus;
    taken?: MedicationUseTaken | undefined;
    treatment?: IdentifierModel | undefined;
    subject?: ReferenceModel | undefined;
    informationSource?: ReferenceModel | undefined;

    constructor(data?: IMedicationUseModel) {
        super(data);
        this._discriminator = "MedicationUseModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["identifiers"])) {
                this.identifiers = [] as any;
                for (let item of _data["identifiers"])
                    this.identifiers!.push(IdentifierModel.fromJS(item));
            }
            this.asAgreed = _data["asAgreed"];
            this.assertedDateTime = _data["assertedDateTime"];
            this.author = _data["author"] ? ReferenceModel.fromJS(_data["author"]) : <any>undefined;
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(CommentModel.fromJS(item));
            }
            this.copyIndicator = _data["copyIndicator"];
            this.effectiveDuration = _data["effectiveDuration"] ? DurationModel.fromJS(_data["effectiveDuration"]) : <any>undefined;
            this.effectivePeriod = _data["effectivePeriod"] ? PeriodModel.fromJS(_data["effectivePeriod"]) : <any>undefined;
            this.instructions = _data["instructions"] ? InstructionsModel.fromJS(_data["instructions"]) : <any>undefined;
            this.medication = _data["medication"] ? MedicationModel.fromJS(_data["medication"]) : <any>undefined;
            if (Array.isArray(_data["notTakenReasons"])) {
                this.notTakenReasons = [] as any;
                for (let item of _data["notTakenReasons"])
                    this.notTakenReasons!.push(item);
            }
            this.practitionerRole = _data["practitionerRole"] ? ReferenceModel.fromJS(_data["practitionerRole"]) : <any>undefined;
            this.prescriber = _data["prescriber"] ? ReferenceModel.fromJS(_data["prescriber"]) : <any>undefined;
            this.reasonForChange = _data["reasonForChange"];
            if (Array.isArray(_data["reasons"])) {
                this.reasons = [] as any;
                for (let item of _data["reasons"])
                    this.reasons!.push(item);
            }
            this.status = _data["status"];
            this.taken = _data["taken"];
            this.treatment = _data["treatment"] ? IdentifierModel.fromJS(_data["treatment"]) : <any>undefined;
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            this.informationSource = _data["informationSource"] ? ReferenceModel.fromJS(_data["informationSource"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): MedicationUseModel {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationUseModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.identifiers)) {
            data["identifiers"] = [];
            for (let item of this.identifiers)
                data["identifiers"].push(item.toJSON());
        }
        data["asAgreed"] = this.asAgreed;
        data["assertedDateTime"] = this.assertedDateTime;
        data["author"] = this.author ? this.author.toJSON() : <any>undefined;
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        data["copyIndicator"] = this.copyIndicator;
        data["effectiveDuration"] = this.effectiveDuration ? this.effectiveDuration.toJSON() : <any>undefined;
        data["effectivePeriod"] = this.effectivePeriod ? this.effectivePeriod.toJSON() : <any>undefined;
        data["instructions"] = this.instructions ? this.instructions.toJSON() : <any>undefined;
        data["medication"] = this.medication ? this.medication.toJSON() : <any>undefined;
        if (Array.isArray(this.notTakenReasons)) {
            data["notTakenReasons"] = [];
            for (let item of this.notTakenReasons)
                data["notTakenReasons"].push(item);
        }
        data["practitionerRole"] = this.practitionerRole ? this.practitionerRole.toJSON() : <any>undefined;
        data["prescriber"] = this.prescriber ? this.prescriber.toJSON() : <any>undefined;
        data["reasonForChange"] = this.reasonForChange;
        if (Array.isArray(this.reasons)) {
            data["reasons"] = [];
            for (let item of this.reasons)
                data["reasons"].push(item);
        }
        data["status"] = this.status;
        data["taken"] = this.taken;
        data["treatment"] = this.treatment ? this.treatment.toJSON() : <any>undefined;
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        data["informationSource"] = this.informationSource ? this.informationSource.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IMedicationUseModel extends IResourceModel {
    identifiers?: IdentifierModel[] | undefined;
    asAgreed?: boolean | undefined;
    assertedDateTime?: string | undefined;
    author?: ReferenceModel | undefined;
    comments?: CommentModel[] | undefined;
    copyIndicator?: boolean | undefined;
    effectiveDuration?: DurationModel | undefined;
    effectivePeriod?: PeriodModel | undefined;
    instructions?: InstructionsModel | undefined;
    medication?: MedicationModel | undefined;
    notTakenReasons?: (ChangeOfUseReason | undefined)[] | undefined;
    practitionerRole?: ReferenceModel | undefined;
    prescriber?: ReferenceModel | undefined;
    reasonForChange?: ChangeOfUseReason | undefined;
    reasons?: string[] | undefined;
    status?: MedicationUseStatus;
    taken?: MedicationUseTaken | undefined;
    treatment?: IdentifierModel | undefined;
    subject?: ReferenceModel | undefined;
    informationSource?: ReferenceModel | undefined;
}

export class MedicationModel implements IMedicationModel {
    reference?: ReferenceModel | undefined;
    codeableConceptString?: string | undefined;

    constructor(data?: IMedicationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reference = _data["reference"] ? ReferenceModel.fromJS(_data["reference"]) : <any>undefined;
            this.codeableConceptString = _data["codeableConceptString"];
        }
    }

    static fromJS(data: any): MedicationModel {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reference"] = this.reference ? this.reference.toJSON() : <any>undefined;
        data["codeableConceptString"] = this.codeableConceptString;
        return data;
    }
}

export interface IMedicationModel {
    reference?: ReferenceModel | undefined;
    codeableConceptString?: string | undefined;
}

export enum ChangeOfUseReason {
    Other = 0,
    Commenced = 1,
    Contraindication = 2,
    DrugInteraction = 3,
    Hypersensitivity = 4,
    AdmissionToEstablishment = 5,
    InsufficientEffect = 6,
    TooStrong = 7,
    PossibleSideEffects = 8,
    WayOfAdministrationDoesNotSuffice = 9,
    IndicationExpired = 10,
    PolicyChange = 11,
    PatientChoice = 12,
    ByAgreement = 13,
    ResumePolicyPreviousPrescriber = 14,
    PlannedProcedure = 15,
    AllergyOrHypersensitivity = 16,
    Correction = 17,
}

export enum MedicationUseStatus {
    Unknown = 0,
    Active = 1,
    Completed = 2,
    EnteredInError = 3,
    Intended = 4,
    Stopped = 5,
    OnHold = 6,
}

export enum MedicationUseTaken {
    Unknown = 0,
    Yes = 1,
    No = 2,
    Na = 3,
}

export class PayerModel extends ResourceModel implements IPayerModel {
    beneficiary?: ReferenceModel | undefined;
    banks?: BankModel[] | undefined;
    payors?: ReferenceModel[] | undefined;
    insurers?: ReferenceModel[] | undefined;
    insuranceType?: InsuranceType | undefined;
    period?: PeriodModel | undefined;
    policyHolder?: ReferenceModel | undefined;
    subscriber?: ReferenceModel | undefined;
    subscriberId?: string | undefined;

    constructor(data?: IPayerModel) {
        super(data);
        this._discriminator = "PayerModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.beneficiary = _data["beneficiary"] ? ReferenceModel.fromJS(_data["beneficiary"]) : <any>undefined;
            if (Array.isArray(_data["banks"])) {
                this.banks = [] as any;
                for (let item of _data["banks"])
                    this.banks!.push(BankModel.fromJS(item));
            }
            if (Array.isArray(_data["payors"])) {
                this.payors = [] as any;
                for (let item of _data["payors"])
                    this.payors!.push(ReferenceModel.fromJS(item));
            }
            if (Array.isArray(_data["insurers"])) {
                this.insurers = [] as any;
                for (let item of _data["insurers"])
                    this.insurers!.push(ReferenceModel.fromJS(item));
            }
            this.insuranceType = _data["insuranceType"];
            this.period = _data["period"] ? PeriodModel.fromJS(_data["period"]) : <any>undefined;
            this.policyHolder = _data["policyHolder"] ? ReferenceModel.fromJS(_data["policyHolder"]) : <any>undefined;
            this.subscriber = _data["subscriber"] ? ReferenceModel.fromJS(_data["subscriber"]) : <any>undefined;
            this.subscriberId = _data["subscriberId"];
        }
    }

    static override fromJS(data: any): PayerModel {
        data = typeof data === 'object' ? data : {};
        let result = new PayerModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beneficiary"] = this.beneficiary ? this.beneficiary.toJSON() : <any>undefined;
        if (Array.isArray(this.banks)) {
            data["banks"] = [];
            for (let item of this.banks)
                data["banks"].push(item.toJSON());
        }
        if (Array.isArray(this.payors)) {
            data["payors"] = [];
            for (let item of this.payors)
                data["payors"].push(item.toJSON());
        }
        if (Array.isArray(this.insurers)) {
            data["insurers"] = [];
            for (let item of this.insurers)
                data["insurers"].push(item.toJSON());
        }
        data["insuranceType"] = this.insuranceType;
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        data["policyHolder"] = this.policyHolder ? this.policyHolder.toJSON() : <any>undefined;
        data["subscriber"] = this.subscriber ? this.subscriber.toJSON() : <any>undefined;
        data["subscriberId"] = this.subscriberId;
        super.toJSON(data);
        return data;
    }
}

export interface IPayerModel extends IResourceModel {
    beneficiary?: ReferenceModel | undefined;
    banks?: BankModel[] | undefined;
    payors?: ReferenceModel[] | undefined;
    insurers?: ReferenceModel[] | undefined;
    insuranceType?: InsuranceType | undefined;
    period?: PeriodModel | undefined;
    policyHolder?: ReferenceModel | undefined;
    subscriber?: ReferenceModel | undefined;
    subscriberId?: string | undefined;
}

export class BankModel implements IBankModel {
    name?: string | undefined;
    code?: string | undefined;
    accountNumber?: string | undefined;

    constructor(data?: IBankModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.accountNumber = _data["accountNumber"];
        }
    }

    static fromJS(data: any): BankModel {
        data = typeof data === 'object' ? data : {};
        let result = new BankModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["accountNumber"] = this.accountNumber;
        return data;
    }
}

export interface IBankModel {
    name?: string | undefined;
    code?: string | undefined;
    accountNumber?: string | undefined;
}

export enum InsuranceType {
    Unknown = 0,
    Basic = 1,
    Supplementary = 2,
    BasicAwbz = 3,
    Main = 4,
    Dental = 5,
    SupplementaryAndDental = 6,
}

export class ProcedureRequestModel extends ResourceModel implements IProcedureRequestModel {
    bodySite?: BodySite | undefined;
    type?: string | undefined;
    context?: ReferenceModel | undefined;
    identifiers?: IdentifierModel[] | undefined;
    occurence?: EffectiveModel | undefined;
    performer?: ReferenceModel | undefined;
    performerType?: ParticipantType | undefined;
    reasons?: ReferenceModel[] | undefined;
    requester?: RequesterModel | undefined;
    status?: OrderStatus | undefined;
    subject?: ReferenceModel | undefined;

    constructor(data?: IProcedureRequestModel) {
        super(data);
        this._discriminator = "ProcedureRequestModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.bodySite = _data["bodySite"];
            this.type = _data["type"];
            this.context = _data["context"] ? ReferenceModel.fromJS(_data["context"]) : <any>undefined;
            if (Array.isArray(_data["identifiers"])) {
                this.identifiers = [] as any;
                for (let item of _data["identifiers"])
                    this.identifiers!.push(IdentifierModel.fromJS(item));
            }
            this.occurence = _data["occurence"] ? EffectiveModel.fromJS(_data["occurence"]) : <any>undefined;
            this.performer = _data["performer"] ? ReferenceModel.fromJS(_data["performer"]) : <any>undefined;
            this.performerType = _data["performerType"];
            if (Array.isArray(_data["reasons"])) {
                this.reasons = [] as any;
                for (let item of _data["reasons"])
                    this.reasons!.push(ReferenceModel.fromJS(item));
            }
            this.requester = _data["requester"] ? RequesterModel.fromJS(_data["requester"]) : <any>undefined;
            this.status = _data["status"];
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ProcedureRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedureRequestModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bodySite"] = this.bodySite;
        data["type"] = this.type;
        data["context"] = this.context ? this.context.toJSON() : <any>undefined;
        if (Array.isArray(this.identifiers)) {
            data["identifiers"] = [];
            for (let item of this.identifiers)
                data["identifiers"].push(item.toJSON());
        }
        data["occurence"] = this.occurence ? this.occurence.toJSON() : <any>undefined;
        data["performer"] = this.performer ? this.performer.toJSON() : <any>undefined;
        data["performerType"] = this.performerType;
        if (Array.isArray(this.reasons)) {
            data["reasons"] = [];
            for (let item of this.reasons)
                data["reasons"].push(item.toJSON());
        }
        data["requester"] = this.requester ? this.requester.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IProcedureRequestModel extends IResourceModel {
    bodySite?: BodySite | undefined;
    type?: string | undefined;
    context?: ReferenceModel | undefined;
    identifiers?: IdentifierModel[] | undefined;
    occurence?: EffectiveModel | undefined;
    performer?: ReferenceModel | undefined;
    performerType?: ParticipantType | undefined;
    reasons?: ReferenceModel[] | undefined;
    requester?: RequesterModel | undefined;
    status?: OrderStatus | undefined;
    subject?: ReferenceModel | undefined;
}

export class ProcedureBaseModel extends ResourceModel implements IProcedureBaseModel {

    constructor(data?: IProcedureBaseModel) {
        super(data);
        this._discriminator = "ProcedureBaseModel";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ProcedureBaseModel {
        data = typeof data === 'object' ? data : {};
        if (data["resourceTypeDiscriminator"] === "FreedomRestrictingMeasureModel") {
            let result = new FreedomRestrictingMeasureModel();
            result.init(data);
            return result;
        }
        if (data["resourceTypeDiscriminator"] === "ProcedureModel") {
            let result = new ProcedureModel();
            result.init(data);
            return result;
        }
        let result = new ProcedureBaseModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IProcedureBaseModel extends IResourceModel {
}

export class ProcedureModel extends ProcedureBaseModel implements IProcedureModel {
    basedOns?: ReferenceModel[] | undefined;
    bodySite?: BodySite | undefined;
    anatomicLocation?: string | undefined;
    code?: string | undefined;
    focalDevices?: FocalDeviceModel[] | undefined;
    identifiers?: IdentifierModel[] | undefined;
    performed?: OccurenceModel | undefined;
    performers?: PerformerModel[] | undefined;
    procedureMethod?: string | undefined;
    reasons?: ReferenceModel[] | undefined;
    reports?: ReferenceModel[] | undefined;
    subject?: ReferenceModel | undefined;

    constructor(data?: IProcedureModel) {
        super(data);
        this._discriminator = "ProcedureModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["basedOns"])) {
                this.basedOns = [] as any;
                for (let item of _data["basedOns"])
                    this.basedOns!.push(ReferenceModel.fromJS(item));
            }
            this.bodySite = _data["bodySite"];
            this.anatomicLocation = _data["anatomicLocation"];
            this.code = _data["code"];
            if (Array.isArray(_data["focalDevices"])) {
                this.focalDevices = [] as any;
                for (let item of _data["focalDevices"])
                    this.focalDevices!.push(FocalDeviceModel.fromJS(item));
            }
            if (Array.isArray(_data["identifiers"])) {
                this.identifiers = [] as any;
                for (let item of _data["identifiers"])
                    this.identifiers!.push(IdentifierModel.fromJS(item));
            }
            this.performed = _data["performed"] ? OccurenceModel.fromJS(_data["performed"]) : <any>undefined;
            if (Array.isArray(_data["performers"])) {
                this.performers = [] as any;
                for (let item of _data["performers"])
                    this.performers!.push(PerformerModel.fromJS(item));
            }
            this.procedureMethod = _data["procedureMethod"];
            if (Array.isArray(_data["reasons"])) {
                this.reasons = [] as any;
                for (let item of _data["reasons"])
                    this.reasons!.push(ReferenceModel.fromJS(item));
            }
            if (Array.isArray(_data["reports"])) {
                this.reports = [] as any;
                for (let item of _data["reports"])
                    this.reports!.push(ReferenceModel.fromJS(item));
            }
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ProcedureModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedureModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.basedOns)) {
            data["basedOns"] = [];
            for (let item of this.basedOns)
                data["basedOns"].push(item.toJSON());
        }
        data["bodySite"] = this.bodySite;
        data["anatomicLocation"] = this.anatomicLocation;
        data["code"] = this.code;
        if (Array.isArray(this.focalDevices)) {
            data["focalDevices"] = [];
            for (let item of this.focalDevices)
                data["focalDevices"].push(item.toJSON());
        }
        if (Array.isArray(this.identifiers)) {
            data["identifiers"] = [];
            for (let item of this.identifiers)
                data["identifiers"].push(item.toJSON());
        }
        data["performed"] = this.performed ? this.performed.toJSON() : <any>undefined;
        if (Array.isArray(this.performers)) {
            data["performers"] = [];
            for (let item of this.performers)
                data["performers"].push(item.toJSON());
        }
        data["procedureMethod"] = this.procedureMethod;
        if (Array.isArray(this.reasons)) {
            data["reasons"] = [];
            for (let item of this.reasons)
                data["reasons"].push(item.toJSON());
        }
        if (Array.isArray(this.reports)) {
            data["reports"] = [];
            for (let item of this.reports)
                data["reports"].push(item.toJSON());
        }
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IProcedureModel extends IProcedureBaseModel {
    basedOns?: ReferenceModel[] | undefined;
    bodySite?: BodySite | undefined;
    anatomicLocation?: string | undefined;
    code?: string | undefined;
    focalDevices?: FocalDeviceModel[] | undefined;
    identifiers?: IdentifierModel[] | undefined;
    performed?: OccurenceModel | undefined;
    performers?: PerformerModel[] | undefined;
    procedureMethod?: string | undefined;
    reasons?: ReferenceModel[] | undefined;
    reports?: ReferenceModel[] | undefined;
    subject?: ReferenceModel | undefined;
}

export class FocalDeviceModel implements IFocalDeviceModel {
    manipulated?: ReferenceModel | undefined;

    constructor(data?: IFocalDeviceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.manipulated = _data["manipulated"] ? ReferenceModel.fromJS(_data["manipulated"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FocalDeviceModel {
        data = typeof data === 'object' ? data : {};
        let result = new FocalDeviceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manipulated"] = this.manipulated ? this.manipulated.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFocalDeviceModel {
    manipulated?: ReferenceModel | undefined;
}

export class OccurenceModel implements IOccurenceModel {
    dateTime?: string | undefined;
    period?: PeriodModel | undefined;

    constructor(data?: IOccurenceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateTime = _data["dateTime"];
            this.period = _data["period"] ? PeriodModel.fromJS(_data["period"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OccurenceModel {
        data = typeof data === 'object' ? data : {};
        let result = new OccurenceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateTime"] = this.dateTime;
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOccurenceModel {
    dateTime?: string | undefined;
    period?: PeriodModel | undefined;
}

export class FreedomRestrictingMeasureModel extends ProcedureBaseModel implements IFreedomRestrictingMeasureModel {
    legalStatus?: LegalStatus | undefined;
    legallyCapable?: FreedomRestrictingMeasureLegallyCapableModel | undefined;
    consent?: LegalConsent | undefined;
    interventionType?: InterventionType | undefined;
    interventionTypeString?: string | undefined;
    subject?: ReferenceModel | undefined;
    performed?: PeriodModel | undefined;

    constructor(data?: IFreedomRestrictingMeasureModel) {
        super(data);
        this._discriminator = "FreedomRestrictingMeasureModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.legalStatus = _data["legalStatus"];
            this.legallyCapable = _data["legallyCapable"] ? FreedomRestrictingMeasureLegallyCapableModel.fromJS(_data["legallyCapable"]) : <any>undefined;
            this.consent = _data["consent"];
            this.interventionType = _data["interventionType"];
            this.interventionTypeString = _data["interventionTypeString"];
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            this.performed = _data["performed"] ? PeriodModel.fromJS(_data["performed"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): FreedomRestrictingMeasureModel {
        data = typeof data === 'object' ? data : {};
        let result = new FreedomRestrictingMeasureModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalStatus"] = this.legalStatus;
        data["legallyCapable"] = this.legallyCapable ? this.legallyCapable.toJSON() : <any>undefined;
        data["consent"] = this.consent;
        data["interventionType"] = this.interventionType;
        data["interventionTypeString"] = this.interventionTypeString;
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        data["performed"] = this.performed ? this.performed.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFreedomRestrictingMeasureModel extends IProcedureBaseModel {
    legalStatus?: LegalStatus | undefined;
    legallyCapable?: FreedomRestrictingMeasureLegallyCapableModel | undefined;
    consent?: LegalConsent | undefined;
    interventionType?: InterventionType | undefined;
    interventionTypeString?: string | undefined;
    subject?: ReferenceModel | undefined;
    performed?: PeriodModel | undefined;
}

export class FreedomRestrictingMeasureLegallyCapableModel implements IFreedomRestrictingMeasureLegallyCapableModel {
    capable?: boolean | undefined;
    comment?: string | undefined;

    constructor(data?: IFreedomRestrictingMeasureLegallyCapableModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.capable = _data["capable"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): FreedomRestrictingMeasureLegallyCapableModel {
        data = typeof data === 'object' ? data : {};
        let result = new FreedomRestrictingMeasureLegallyCapableModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["capable"] = this.capable;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IFreedomRestrictingMeasureLegallyCapableModel {
    capable?: boolean | undefined;
    comment?: string | undefined;
}

export enum LegalConsent {
    Unknown = 0,
    OwnRequest = 1,
    NoResistance = 2,
    Resistance = 3,
    NoAgreementPatient = 4,
    AgreementPatient = 5,
    NoAgreementLegalRepresentative = 6,
    AgreementLegalRepresentative = 7,
}

export enum InterventionType {
    Other = 0,
    Seclusion = 1,
    Segregation = 2,
    PhysicalRestraint = 3,
    ForcedMedication = 4,
    ForcedFeeding = 5,
}

export class TobaccoUseModel extends ObservationBaseModel implements ITobaccoUseModel {
    period?: PeriodModel | undefined;
    type?: TobaccoUseType | undefined;
    comment?: string | undefined;
    subject?: ReferenceModel | undefined;
    performers?: ReferenceModel[] | undefined;
    tobaccoType?: TobaccoType | undefined;
    tobaccoAmount?: QuantityModel | undefined;
    tobaccoPackYears?: QuantityModel | undefined;

    constructor(data?: ITobaccoUseModel) {
        super(data);
        this._discriminator = "TobaccoUseModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.period = _data["period"] ? PeriodModel.fromJS(_data["period"]) : <any>undefined;
            this.type = _data["type"];
            this.comment = _data["comment"];
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            if (Array.isArray(_data["performers"])) {
                this.performers = [] as any;
                for (let item of _data["performers"])
                    this.performers!.push(ReferenceModel.fromJS(item));
            }
            this.tobaccoType = _data["tobaccoType"];
            this.tobaccoAmount = _data["tobaccoAmount"] ? QuantityModel.fromJS(_data["tobaccoAmount"]) : <any>undefined;
            this.tobaccoPackYears = _data["tobaccoPackYears"] ? QuantityModel.fromJS(_data["tobaccoPackYears"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): TobaccoUseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TobaccoUseModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["comment"] = this.comment;
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        if (Array.isArray(this.performers)) {
            data["performers"] = [];
            for (let item of this.performers)
                data["performers"].push(item.toJSON());
        }
        data["tobaccoType"] = this.tobaccoType;
        data["tobaccoAmount"] = this.tobaccoAmount ? this.tobaccoAmount.toJSON() : <any>undefined;
        data["tobaccoPackYears"] = this.tobaccoPackYears ? this.tobaccoPackYears.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ITobaccoUseModel extends IObservationBaseModel {
    period?: PeriodModel | undefined;
    type?: TobaccoUseType | undefined;
    comment?: string | undefined;
    subject?: ReferenceModel | undefined;
    performers?: ReferenceModel[] | undefined;
    tobaccoType?: TobaccoType | undefined;
    tobaccoAmount?: QuantityModel | undefined;
    tobaccoPackYears?: QuantityModel | undefined;
}

export enum TobaccoUseType {
    Other = 0,
    Daily = 1,
    Occasional = 2,
    Passive = 3,
    Ex = 4,
    HistoryUnknown = 5,
    Never = 6,
}

export enum TobaccoType {
    Other = 0,
    CigaretteSmoker = 1,
    CigarSmoker = 2,
    PipeSmoker = 3,
    RollsOwnCigarettes = 4,
}

export class TreatmentDirectiveModel extends ResourceModel implements ITreatmentDirectiveModel {
    actors?: ActorModel[] | undefined;
    comment?: string | undefined;
    consentingParties?: ReferenceModel[] | undefined;
    dateTime?: string | undefined;
    organizations?: ReferenceModel[] | undefined;
    patient?: ReferenceModel | undefined;
    period?: PeriodModel | undefined;
    permission?: TreatmentPermissionCode | undefined;
    permissionExceptions?: PermissionExceptionModel[] | undefined;
    policies?: string[] | undefined;
    source?: SourceModel | undefined;
    status?: ConsentStatus;
    type?: TreatmentType | undefined;
    verification?: VerificationModel | undefined;

    constructor(data?: ITreatmentDirectiveModel) {
        super(data);
        this._discriminator = "TreatmentDirectiveModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["actors"])) {
                this.actors = [] as any;
                for (let item of _data["actors"])
                    this.actors!.push(ActorModel.fromJS(item));
            }
            this.comment = _data["comment"];
            if (Array.isArray(_data["consentingParties"])) {
                this.consentingParties = [] as any;
                for (let item of _data["consentingParties"])
                    this.consentingParties!.push(ReferenceModel.fromJS(item));
            }
            this.dateTime = _data["dateTime"];
            if (Array.isArray(_data["organizations"])) {
                this.organizations = [] as any;
                for (let item of _data["organizations"])
                    this.organizations!.push(ReferenceModel.fromJS(item));
            }
            this.patient = _data["patient"] ? ReferenceModel.fromJS(_data["patient"]) : <any>undefined;
            this.period = _data["period"] ? PeriodModel.fromJS(_data["period"]) : <any>undefined;
            this.permission = _data["permission"];
            if (Array.isArray(_data["permissionExceptions"])) {
                this.permissionExceptions = [] as any;
                for (let item of _data["permissionExceptions"])
                    this.permissionExceptions!.push(PermissionExceptionModel.fromJS(item));
            }
            if (Array.isArray(_data["policies"])) {
                this.policies = [] as any;
                for (let item of _data["policies"])
                    this.policies!.push(item);
            }
            this.source = _data["source"] ? SourceModel.fromJS(_data["source"]) : <any>undefined;
            this.status = _data["status"];
            this.type = _data["type"];
            this.verification = _data["verification"] ? VerificationModel.fromJS(_data["verification"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): TreatmentDirectiveModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentDirectiveModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.actors)) {
            data["actors"] = [];
            for (let item of this.actors)
                data["actors"].push(item.toJSON());
        }
        data["comment"] = this.comment;
        if (Array.isArray(this.consentingParties)) {
            data["consentingParties"] = [];
            for (let item of this.consentingParties)
                data["consentingParties"].push(item.toJSON());
        }
        data["dateTime"] = this.dateTime;
        if (Array.isArray(this.organizations)) {
            data["organizations"] = [];
            for (let item of this.organizations)
                data["organizations"].push(item.toJSON());
        }
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        data["permission"] = this.permission;
        if (Array.isArray(this.permissionExceptions)) {
            data["permissionExceptions"] = [];
            for (let item of this.permissionExceptions)
                data["permissionExceptions"].push(item.toJSON());
        }
        if (Array.isArray(this.policies)) {
            data["policies"] = [];
            for (let item of this.policies)
                data["policies"].push(item);
        }
        data["source"] = this.source ? this.source.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["type"] = this.type;
        data["verification"] = this.verification ? this.verification.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ITreatmentDirectiveModel extends IResourceModel {
    actors?: ActorModel[] | undefined;
    comment?: string | undefined;
    consentingParties?: ReferenceModel[] | undefined;
    dateTime?: string | undefined;
    organizations?: ReferenceModel[] | undefined;
    patient?: ReferenceModel | undefined;
    period?: PeriodModel | undefined;
    permission?: TreatmentPermissionCode | undefined;
    permissionExceptions?: PermissionExceptionModel[] | undefined;
    policies?: string[] | undefined;
    source?: SourceModel | undefined;
    status?: ConsentStatus;
    type?: TreatmentType | undefined;
    verification?: VerificationModel | undefined;
}

export enum TreatmentPermissionCode {
    Unknown = 0,
    Yes = 1,
    Limited = 2,
    No = 3,
}

export class PermissionExceptionModel implements IPermissionExceptionModel {
    restriction?: string | undefined;
    actors?: ActorModel[] | undefined;

    constructor(data?: IPermissionExceptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.restriction = _data["restriction"];
            if (Array.isArray(_data["actors"])) {
                this.actors = [] as any;
                for (let item of _data["actors"])
                    this.actors!.push(ActorModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionExceptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionExceptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["restriction"] = this.restriction;
        if (Array.isArray(this.actors)) {
            data["actors"] = [];
            for (let item of this.actors)
                data["actors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPermissionExceptionModel {
    restriction?: string | undefined;
    actors?: ActorModel[] | undefined;
}

export class SourceModel implements ISourceModel {
    attachment?: AttachmentModel | undefined;
    identifier?: IdentifierModel | undefined;
    reference?: ReferenceModel | undefined;

    constructor(data?: ISourceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attachment = _data["attachment"] ? AttachmentModel.fromJS(_data["attachment"]) : <any>undefined;
            this.identifier = _data["identifier"] ? IdentifierModel.fromJS(_data["identifier"]) : <any>undefined;
            this.reference = _data["reference"] ? ReferenceModel.fromJS(_data["reference"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SourceModel {
        data = typeof data === 'object' ? data : {};
        let result = new SourceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachment"] = this.attachment ? this.attachment.toJSON() : <any>undefined;
        data["identifier"] = this.identifier ? this.identifier.toJSON() : <any>undefined;
        data["reference"] = this.reference ? this.reference.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISourceModel {
    attachment?: AttachmentModel | undefined;
    identifier?: IdentifierModel | undefined;
    reference?: ReferenceModel | undefined;
}

export enum ConsentStatus {
    Unknown = 0,
    Draft = 1,
    Proposed = 2,
    Active = 3,
    Rejected = 4,
    Inactive = 5,
    EnteredInError = 6,
}

export enum TreatmentType {
    Other = 0,
    AdmissionToIntensiveCare = 1,
    CardiopulmonaryResuscitation = 2,
    ArtificialRespiration = 3,
    AdministrationBloodProduct = 4,
}

export class VerificationModel implements IVerificationModel {
    verified?: boolean | undefined;
    verifiedWith?: VerifiedWith;
    dateTime?: string | undefined;

    constructor(data?: IVerificationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.verified = _data["verified"];
            this.verifiedWith = _data["verifiedWith"];
            this.dateTime = _data["dateTime"];
        }
    }

    static fromJS(data: any): VerificationModel {
        data = typeof data === 'object' ? data : {};
        let result = new VerificationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["verified"] = this.verified;
        data["verifiedWith"] = this.verifiedWith;
        data["dateTime"] = this.dateTime;
        return data;
    }
}

export interface IVerificationModel {
    verified?: boolean | undefined;
    verifiedWith?: VerifiedWith;
    dateTime?: string | undefined;
}

export enum VerifiedWith {
    Other = 0,
    Patient = 1,
    Parent = 2,
    Guardian = 3,
    AuthorizedRepresentative = 4,
}

export class VaccinationRecommendationModel extends ResourceModel implements IVaccinationRecommendationModel {
    vacineCode?: string | undefined;
    identifiers?: IdentifierModel[] | undefined;
    orderStatus?: OrderStatus | undefined;
    patient?: ReferenceModel | undefined;
    recommendations?: RecommendationModel[] | undefined;

    constructor(data?: IVaccinationRecommendationModel) {
        super(data);
        this._discriminator = "VaccinationRecommendationModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.vacineCode = _data["vacineCode"];
            if (Array.isArray(_data["identifiers"])) {
                this.identifiers = [] as any;
                for (let item of _data["identifiers"])
                    this.identifiers!.push(IdentifierModel.fromJS(item));
            }
            this.orderStatus = _data["orderStatus"];
            this.patient = _data["patient"] ? ReferenceModel.fromJS(_data["patient"]) : <any>undefined;
            if (Array.isArray(_data["recommendations"])) {
                this.recommendations = [] as any;
                for (let item of _data["recommendations"])
                    this.recommendations!.push(RecommendationModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): VaccinationRecommendationModel {
        data = typeof data === 'object' ? data : {};
        let result = new VaccinationRecommendationModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vacineCode"] = this.vacineCode;
        if (Array.isArray(this.identifiers)) {
            data["identifiers"] = [];
            for (let item of this.identifiers)
                data["identifiers"].push(item.toJSON());
        }
        data["orderStatus"] = this.orderStatus;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        if (Array.isArray(this.recommendations)) {
            data["recommendations"] = [];
            for (let item of this.recommendations)
                data["recommendations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IVaccinationRecommendationModel extends IResourceModel {
    vacineCode?: string | undefined;
    identifiers?: IdentifierModel[] | undefined;
    orderStatus?: OrderStatus | undefined;
    patient?: ReferenceModel | undefined;
    recommendations?: RecommendationModel[] | undefined;
}

export class RecommendationModel implements IRecommendationModel {
    vaccineCode?: string | undefined;
    date?: string | undefined;
    protocol?: ProtocolModel | undefined;
    supportingImmunizations?: ReferenceModel[] | undefined;
    supportingPatientInformations?: ReferenceModel[] | undefined;

    constructor(data?: IRecommendationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vaccineCode = _data["vaccineCode"];
            this.date = _data["date"];
            this.protocol = _data["protocol"] ? ProtocolModel.fromJS(_data["protocol"]) : <any>undefined;
            if (Array.isArray(_data["supportingImmunizations"])) {
                this.supportingImmunizations = [] as any;
                for (let item of _data["supportingImmunizations"])
                    this.supportingImmunizations!.push(ReferenceModel.fromJS(item));
            }
            if (Array.isArray(_data["supportingPatientInformations"])) {
                this.supportingPatientInformations = [] as any;
                for (let item of _data["supportingPatientInformations"])
                    this.supportingPatientInformations!.push(ReferenceModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RecommendationModel {
        data = typeof data === 'object' ? data : {};
        let result = new RecommendationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vaccineCode"] = this.vaccineCode;
        data["date"] = this.date;
        data["protocol"] = this.protocol ? this.protocol.toJSON() : <any>undefined;
        if (Array.isArray(this.supportingImmunizations)) {
            data["supportingImmunizations"] = [];
            for (let item of this.supportingImmunizations)
                data["supportingImmunizations"].push(item.toJSON());
        }
        if (Array.isArray(this.supportingPatientInformations)) {
            data["supportingPatientInformations"] = [];
            for (let item of this.supportingPatientInformations)
                data["supportingPatientInformations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRecommendationModel {
    vaccineCode?: string | undefined;
    date?: string | undefined;
    protocol?: ProtocolModel | undefined;
    supportingImmunizations?: ReferenceModel[] | undefined;
    supportingPatientInformations?: ReferenceModel[] | undefined;
}

export class ProtocolModel implements IProtocolModel {
    authority?: ReferenceModel | undefined;

    constructor(data?: IProtocolModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authority = _data["authority"] ? ReferenceModel.fromJS(_data["authority"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProtocolModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProtocolModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authority"] = this.authority ? this.authority.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProtocolModel {
    authority?: ReferenceModel | undefined;
}

export class MaternalRecordDetailsViewModel implements IMaternalRecordDetailsViewModel {
    pregnancy?: ZibPregnancy | undefined;
    bloodType?: ZibLaboratoryTestResult | undefined;
    rhesusDFactor?: ZibLaboratoryTestResult | undefined;
    rhesusCFactor?: ZibLaboratoryTestResult | undefined;
    hemoglobinLevel?: ZibLaboratoryTestResult | undefined;
    termDate?: ZibPregnancyTermDate | undefined;
    gravidity?: ZibPregnancyGravidity | undefined;
    parity?: ZibPregnancyParity | undefined;
    terminationType?: BcPregnancyObservationTerminationType | undefined;
    terminationDate?: BcPregnancyObservationTerminationDate | undefined;
    deliveryProcedure?: BcDeliveryProcedure | undefined;
    obstetricProcedure?: BcObstetricProcedure | undefined;
    onsetLaborFirstStage?: BcDeliveryObservationOnsetLaborFirstStage | undefined;
    bloodLoss?: BcDeliveryObservationBloodloss | undefined;
    perineumCondition?: BcDeliveryObservationPerineumCondition | undefined;
    birth?: BcBirth | undefined;
    onsetActivePushing?: BcBirthObservationOnsetOfPushing | undefined;
    partus?: BcBirthObservationPartus | undefined;
    apgarScore?: ZibApgarScore | undefined;
    birthWeight?: BcBirthWeight | undefined;

    constructor(data?: IMaternalRecordDetailsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pregnancy = _data["pregnancy"] ? ZibPregnancy.fromJS(_data["pregnancy"]) : <any>undefined;
            this.bloodType = _data["bloodType"] ? ZibLaboratoryTestResult.fromJS(_data["bloodType"]) : <any>undefined;
            this.rhesusDFactor = _data["rhesusDFactor"] ? ZibLaboratoryTestResult.fromJS(_data["rhesusDFactor"]) : <any>undefined;
            this.rhesusCFactor = _data["rhesusCFactor"] ? ZibLaboratoryTestResult.fromJS(_data["rhesusCFactor"]) : <any>undefined;
            this.hemoglobinLevel = _data["hemoglobinLevel"] ? ZibLaboratoryTestResult.fromJS(_data["hemoglobinLevel"]) : <any>undefined;
            this.termDate = _data["termDate"] ? ZibPregnancyTermDate.fromJS(_data["termDate"]) : <any>undefined;
            this.gravidity = _data["gravidity"] ? ZibPregnancyGravidity.fromJS(_data["gravidity"]) : <any>undefined;
            this.parity = _data["parity"] ? ZibPregnancyParity.fromJS(_data["parity"]) : <any>undefined;
            this.terminationType = _data["terminationType"] ? BcPregnancyObservationTerminationType.fromJS(_data["terminationType"]) : <any>undefined;
            this.terminationDate = _data["terminationDate"] ? BcPregnancyObservationTerminationDate.fromJS(_data["terminationDate"]) : <any>undefined;
            this.deliveryProcedure = _data["deliveryProcedure"] ? BcDeliveryProcedure.fromJS(_data["deliveryProcedure"]) : <any>undefined;
            this.obstetricProcedure = _data["obstetricProcedure"] ? BcObstetricProcedure.fromJS(_data["obstetricProcedure"]) : <any>undefined;
            this.onsetLaborFirstStage = _data["onsetLaborFirstStage"] ? BcDeliveryObservationOnsetLaborFirstStage.fromJS(_data["onsetLaborFirstStage"]) : <any>undefined;
            this.bloodLoss = _data["bloodLoss"] ? BcDeliveryObservationBloodloss.fromJS(_data["bloodLoss"]) : <any>undefined;
            this.perineumCondition = _data["perineumCondition"] ? BcDeliveryObservationPerineumCondition.fromJS(_data["perineumCondition"]) : <any>undefined;
            this.birth = _data["birth"] ? BcBirth.fromJS(_data["birth"]) : <any>undefined;
            this.onsetActivePushing = _data["onsetActivePushing"] ? BcBirthObservationOnsetOfPushing.fromJS(_data["onsetActivePushing"]) : <any>undefined;
            this.partus = _data["partus"] ? BcBirthObservationPartus.fromJS(_data["partus"]) : <any>undefined;
            this.apgarScore = _data["apgarScore"] ? ZibApgarScore.fromJS(_data["apgarScore"]) : <any>undefined;
            this.birthWeight = _data["birthWeight"] ? BcBirthWeight.fromJS(_data["birthWeight"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MaternalRecordDetailsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MaternalRecordDetailsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pregnancy"] = this.pregnancy ? this.pregnancy.toJSON() : <any>undefined;
        data["bloodType"] = this.bloodType ? this.bloodType.toJSON() : <any>undefined;
        data["rhesusDFactor"] = this.rhesusDFactor ? this.rhesusDFactor.toJSON() : <any>undefined;
        data["rhesusCFactor"] = this.rhesusCFactor ? this.rhesusCFactor.toJSON() : <any>undefined;
        data["hemoglobinLevel"] = this.hemoglobinLevel ? this.hemoglobinLevel.toJSON() : <any>undefined;
        data["termDate"] = this.termDate ? this.termDate.toJSON() : <any>undefined;
        data["gravidity"] = this.gravidity ? this.gravidity.toJSON() : <any>undefined;
        data["parity"] = this.parity ? this.parity.toJSON() : <any>undefined;
        data["terminationType"] = this.terminationType ? this.terminationType.toJSON() : <any>undefined;
        data["terminationDate"] = this.terminationDate ? this.terminationDate.toJSON() : <any>undefined;
        data["deliveryProcedure"] = this.deliveryProcedure ? this.deliveryProcedure.toJSON() : <any>undefined;
        data["obstetricProcedure"] = this.obstetricProcedure ? this.obstetricProcedure.toJSON() : <any>undefined;
        data["onsetLaborFirstStage"] = this.onsetLaborFirstStage ? this.onsetLaborFirstStage.toJSON() : <any>undefined;
        data["bloodLoss"] = this.bloodLoss ? this.bloodLoss.toJSON() : <any>undefined;
        data["perineumCondition"] = this.perineumCondition ? this.perineumCondition.toJSON() : <any>undefined;
        data["birth"] = this.birth ? this.birth.toJSON() : <any>undefined;
        data["onsetActivePushing"] = this.onsetActivePushing ? this.onsetActivePushing.toJSON() : <any>undefined;
        data["partus"] = this.partus ? this.partus.toJSON() : <any>undefined;
        data["apgarScore"] = this.apgarScore ? this.apgarScore.toJSON() : <any>undefined;
        data["birthWeight"] = this.birthWeight ? this.birthWeight.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMaternalRecordDetailsViewModel {
    pregnancy?: ZibPregnancy | undefined;
    bloodType?: ZibLaboratoryTestResult | undefined;
    rhesusDFactor?: ZibLaboratoryTestResult | undefined;
    rhesusCFactor?: ZibLaboratoryTestResult | undefined;
    hemoglobinLevel?: ZibLaboratoryTestResult | undefined;
    termDate?: ZibPregnancyTermDate | undefined;
    gravidity?: ZibPregnancyGravidity | undefined;
    parity?: ZibPregnancyParity | undefined;
    terminationType?: BcPregnancyObservationTerminationType | undefined;
    terminationDate?: BcPregnancyObservationTerminationDate | undefined;
    deliveryProcedure?: BcDeliveryProcedure | undefined;
    obstetricProcedure?: BcObstetricProcedure | undefined;
    onsetLaborFirstStage?: BcDeliveryObservationOnsetLaborFirstStage | undefined;
    bloodLoss?: BcDeliveryObservationBloodloss | undefined;
    perineumCondition?: BcDeliveryObservationPerineumCondition | undefined;
    birth?: BcBirth | undefined;
    onsetActivePushing?: BcBirthObservationOnsetOfPushing | undefined;
    partus?: BcBirthObservationPartus | undefined;
    apgarScore?: ZibApgarScore | undefined;
    birthWeight?: BcBirthWeight | undefined;
}

export class FunctionalAndMentalStatusesModel implements IFunctionalAndMentalStatusesModel {
    functionalStatuses?: FunctionalOrMentalStatusModel[] | undefined;
    mentalStatuses?: FunctionalOrMentalStatusModel[] | undefined;

    constructor(data?: IFunctionalAndMentalStatusesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["functionalStatuses"])) {
                this.functionalStatuses = [] as any;
                for (let item of _data["functionalStatuses"])
                    this.functionalStatuses!.push(FunctionalOrMentalStatusModel.fromJS(item));
            }
            if (Array.isArray(_data["mentalStatuses"])) {
                this.mentalStatuses = [] as any;
                for (let item of _data["mentalStatuses"])
                    this.mentalStatuses!.push(FunctionalOrMentalStatusModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FunctionalAndMentalStatusesModel {
        data = typeof data === 'object' ? data : {};
        let result = new FunctionalAndMentalStatusesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.functionalStatuses)) {
            data["functionalStatuses"] = [];
            for (let item of this.functionalStatuses)
                data["functionalStatuses"].push(item.toJSON());
        }
        if (Array.isArray(this.mentalStatuses)) {
            data["mentalStatuses"] = [];
            for (let item of this.mentalStatuses)
                data["mentalStatuses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFunctionalAndMentalStatusesModel {
    functionalStatuses?: FunctionalOrMentalStatusModel[] | undefined;
    mentalStatuses?: FunctionalOrMentalStatusModel[] | undefined;
}

export class ParticipationInSocietyModel extends ObservationBaseModel implements IParticipationInSocietyModel {
    subject?: ReferenceModel | undefined;
    context?: ReferenceModel | undefined;
    performers?: ReferenceModel[] | undefined;
    comment?: string | undefined;
    socialNetwork?: string | undefined;
    hobby?: string | undefined;
    workSituation?: string | undefined;

    constructor(data?: IParticipationInSocietyModel) {
        super(data);
        this._discriminator = "ParticipationInSocietyModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            this.context = _data["context"] ? ReferenceModel.fromJS(_data["context"]) : <any>undefined;
            if (Array.isArray(_data["performers"])) {
                this.performers = [] as any;
                for (let item of _data["performers"])
                    this.performers!.push(ReferenceModel.fromJS(item));
            }
            this.comment = _data["comment"];
            this.socialNetwork = _data["socialNetwork"];
            this.hobby = _data["hobby"];
            this.workSituation = _data["workSituation"];
        }
    }

    static override fromJS(data: any): ParticipationInSocietyModel {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipationInSocietyModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        data["context"] = this.context ? this.context.toJSON() : <any>undefined;
        if (Array.isArray(this.performers)) {
            data["performers"] = [];
            for (let item of this.performers)
                data["performers"].push(item.toJSON());
        }
        data["comment"] = this.comment;
        data["socialNetwork"] = this.socialNetwork;
        data["hobby"] = this.hobby;
        data["workSituation"] = this.workSituation;
        super.toJSON(data);
        return data;
    }
}

export interface IParticipationInSocietyModel extends IObservationBaseModel {
    subject?: ReferenceModel | undefined;
    context?: ReferenceModel | undefined;
    performers?: ReferenceModel[] | undefined;
    comment?: string | undefined;
    socialNetwork?: string | undefined;
    hobby?: string | undefined;
    workSituation?: string | undefined;
}

export class GroupedProceduresModel implements IGroupedProceduresModel {
    freedomRestrictingMeasures?: FreedomRestrictingMeasureModel[] | undefined;
    otherProcedures?: ProcedureModel[] | undefined;

    constructor(data?: IGroupedProceduresModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["freedomRestrictingMeasures"])) {
                this.freedomRestrictingMeasures = [] as any;
                for (let item of _data["freedomRestrictingMeasures"])
                    this.freedomRestrictingMeasures!.push(FreedomRestrictingMeasureModel.fromJS(item));
            }
            if (Array.isArray(_data["otherProcedures"])) {
                this.otherProcedures = [] as any;
                for (let item of _data["otherProcedures"])
                    this.otherProcedures!.push(ProcedureModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GroupedProceduresModel {
        data = typeof data === 'object' ? data : {};
        let result = new GroupedProceduresModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.freedomRestrictingMeasures)) {
            data["freedomRestrictingMeasures"] = [];
            for (let item of this.freedomRestrictingMeasures)
                data["freedomRestrictingMeasures"].push(item.toJSON());
        }
        if (Array.isArray(this.otherProcedures)) {
            data["otherProcedures"] = [];
            for (let item of this.otherProcedures)
                data["otherProcedures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGroupedProceduresModel {
    freedomRestrictingMeasures?: FreedomRestrictingMeasureModel[] | undefined;
    otherProcedures?: ProcedureModel[] | undefined;
}

export class EncounterReportModel extends ResourceModel implements IEncounterReportModel {
    attesterParties?: ReferenceModel[] | undefined;
    authors?: ReferenceModel[] | undefined;
    custodian?: ReferenceModel | undefined;
    encounter?: ReferenceModel | undefined;
    sections?: EncounterReportSectionModel[] | undefined;
    title?: string | undefined;
    dateTime?: string | undefined;
    comparisonDate?: Date | undefined;
    subject?: ReferenceModel | undefined;
    relatedObservations?: ObservationBaseModel[] | undefined;

    constructor(data?: IEncounterReportModel) {
        super(data);
        this._discriminator = "EncounterReportModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["attesterParties"])) {
                this.attesterParties = [] as any;
                for (let item of _data["attesterParties"])
                    this.attesterParties!.push(ReferenceModel.fromJS(item));
            }
            if (Array.isArray(_data["authors"])) {
                this.authors = [] as any;
                for (let item of _data["authors"])
                    this.authors!.push(ReferenceModel.fromJS(item));
            }
            this.custodian = _data["custodian"] ? ReferenceModel.fromJS(_data["custodian"]) : <any>undefined;
            this.encounter = _data["encounter"] ? ReferenceModel.fromJS(_data["encounter"]) : <any>undefined;
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(EncounterReportSectionModel.fromJS(item));
            }
            this.title = _data["title"];
            this.dateTime = _data["dateTime"];
            this.comparisonDate = _data["comparisonDate"] ? new Date(_data["comparisonDate"].toString()) : <any>undefined;
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            if (Array.isArray(_data["relatedObservations"])) {
                this.relatedObservations = [] as any;
                for (let item of _data["relatedObservations"])
                    this.relatedObservations!.push(ObservationBaseModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): EncounterReportModel {
        data = typeof data === 'object' ? data : {};
        let result = new EncounterReportModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.attesterParties)) {
            data["attesterParties"] = [];
            for (let item of this.attesterParties)
                data["attesterParties"].push(item.toJSON());
        }
        if (Array.isArray(this.authors)) {
            data["authors"] = [];
            for (let item of this.authors)
                data["authors"].push(item.toJSON());
        }
        data["custodian"] = this.custodian ? this.custodian.toJSON() : <any>undefined;
        data["encounter"] = this.encounter ? this.encounter.toJSON() : <any>undefined;
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item.toJSON());
        }
        data["title"] = this.title;
        data["dateTime"] = this.dateTime;
        data["comparisonDate"] = this.comparisonDate ? this.comparisonDate.toISOString() : <any>undefined;
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        if (Array.isArray(this.relatedObservations)) {
            data["relatedObservations"] = [];
            for (let item of this.relatedObservations)
                data["relatedObservations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IEncounterReportModel extends IResourceModel {
    attesterParties?: ReferenceModel[] | undefined;
    authors?: ReferenceModel[] | undefined;
    custodian?: ReferenceModel | undefined;
    encounter?: ReferenceModel | undefined;
    sections?: EncounterReportSectionModel[] | undefined;
    title?: string | undefined;
    dateTime?: string | undefined;
    comparisonDate?: Date | undefined;
    subject?: ReferenceModel | undefined;
    relatedObservations?: ObservationBaseModel[] | undefined;
}

export class EncounterReportSectionModel implements IEncounterReportSectionModel {
    entries?: ReferenceModel[] | undefined;
    icpc1?: string | undefined;
    text?: NarrativeModel | undefined;
    type?: EncounterReportSectionType | undefined;

    constructor(data?: IEncounterReportSectionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(ReferenceModel.fromJS(item));
            }
            this.icpc1 = _data["icpc1"];
            this.text = _data["text"] ? NarrativeModel.fromJS(_data["text"]) : <any>undefined;
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): EncounterReportSectionModel {
        data = typeof data === 'object' ? data : {};
        let result = new EncounterReportSectionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item.toJSON());
        }
        data["icpc1"] = this.icpc1;
        data["text"] = this.text ? this.text.toJSON() : <any>undefined;
        data["type"] = this.type;
        return data;
    }
}

export interface IEncounterReportSectionModel {
    entries?: ReferenceModel[] | undefined;
    icpc1?: string | undefined;
    text?: NarrativeModel | undefined;
    type?: EncounterReportSectionType | undefined;
}

export class NarrativeModel implements INarrativeModel {
    status?: NarrativeStatus | undefined;
    div?: string | undefined;

    constructor(data?: INarrativeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.div = _data["div"];
        }
    }

    static fromJS(data: any): NarrativeModel {
        data = typeof data === 'object' ? data : {};
        let result = new NarrativeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["div"] = this.div;
        return data;
    }
}

export interface INarrativeModel {
    status?: NarrativeStatus | undefined;
    div?: string | undefined;
}

export enum NarrativeStatus {
    Unknown = 0,
    Generated = 1,
    Extensions = 2,
    Additional = 3,
    Empty = 4,
}

export enum EncounterReportSectionType {
    Unknown = 0,
    Subjective = 1,
    Objective = 2,
    Assessment = 3,
    Plan = 4,
}

export class LaboratoryTestResultDiagnosticReportModel extends ResourceModel implements ILaboratoryTestResultDiagnosticReportModel {
    basedOn?: ReferenceModel[] | undefined;
    conclusion?: string | undefined;
    context?: ReferenceModel | undefined;
    effective?: EffectiveModel | undefined;
    performers?: PerformerModel[] | undefined;
    results?: ReferenceModel[] | undefined;
    specimens?: ReferenceModel[] | undefined;
    status?: DiagnosticReportStatus | undefined;
    subject?: ReferenceModel | undefined;
    type?: DiagnosticReportType | undefined;
    typeString?: string | undefined;

    constructor(data?: ILaboratoryTestResultDiagnosticReportModel) {
        super(data);
        this._discriminator = "LaboratoryTestResultDiagnosticReportModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["basedOn"])) {
                this.basedOn = [] as any;
                for (let item of _data["basedOn"])
                    this.basedOn!.push(ReferenceModel.fromJS(item));
            }
            this.conclusion = _data["conclusion"];
            this.context = _data["context"] ? ReferenceModel.fromJS(_data["context"]) : <any>undefined;
            this.effective = _data["effective"] ? EffectiveModel.fromJS(_data["effective"]) : <any>undefined;
            if (Array.isArray(_data["performers"])) {
                this.performers = [] as any;
                for (let item of _data["performers"])
                    this.performers!.push(PerformerModel.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ReferenceModel.fromJS(item));
            }
            if (Array.isArray(_data["specimens"])) {
                this.specimens = [] as any;
                for (let item of _data["specimens"])
                    this.specimens!.push(ReferenceModel.fromJS(item));
            }
            this.status = _data["status"];
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            this.type = _data["type"];
            this.typeString = _data["typeString"];
        }
    }

    static override fromJS(data: any): LaboratoryTestResultDiagnosticReportModel {
        data = typeof data === 'object' ? data : {};
        let result = new LaboratoryTestResultDiagnosticReportModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.basedOn)) {
            data["basedOn"] = [];
            for (let item of this.basedOn)
                data["basedOn"].push(item.toJSON());
        }
        data["conclusion"] = this.conclusion;
        data["context"] = this.context ? this.context.toJSON() : <any>undefined;
        data["effective"] = this.effective ? this.effective.toJSON() : <any>undefined;
        if (Array.isArray(this.performers)) {
            data["performers"] = [];
            for (let item of this.performers)
                data["performers"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.specimens)) {
            data["specimens"] = [];
            for (let item of this.specimens)
                data["specimens"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["typeString"] = this.typeString;
        super.toJSON(data);
        return data;
    }
}

export interface ILaboratoryTestResultDiagnosticReportModel extends IResourceModel {
    basedOn?: ReferenceModel[] | undefined;
    conclusion?: string | undefined;
    context?: ReferenceModel | undefined;
    effective?: EffectiveModel | undefined;
    performers?: PerformerModel[] | undefined;
    results?: ReferenceModel[] | undefined;
    specimens?: ReferenceModel[] | undefined;
    status?: DiagnosticReportStatus | undefined;
    subject?: ReferenceModel | undefined;
    type?: DiagnosticReportType | undefined;
    typeString?: string | undefined;
}

export class DocumentManifestSearchResultModel implements IDocumentManifestSearchResultModel {
    documentManifests?: DocumentManifestModel[] | undefined;

    constructor(data?: IDocumentManifestSearchResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["documentManifests"])) {
                this.documentManifests = [] as any;
                for (let item of _data["documentManifests"])
                    this.documentManifests!.push(DocumentManifestModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentManifestSearchResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentManifestSearchResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.documentManifests)) {
            data["documentManifests"] = [];
            for (let item of this.documentManifests)
                data["documentManifests"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDocumentManifestSearchResultModel {
    documentManifests?: DocumentManifestModel[] | undefined;
}

export class DocumentManifestModel extends ResourceModel implements IDocumentManifestModel {
    documentManifestId?: string | undefined;
    creationDate?: string | undefined;
    status?: DocumentReferenceStatus | undefined;
    type?: string | undefined;
    subject?: ReferenceModel | undefined;
    authors?: ReferenceModel[] | undefined;
    source?: string | undefined;
    documentReferences?: ReferenceModel[] | undefined;

    constructor(data?: IDocumentManifestModel) {
        super(data);
        this._discriminator = "DocumentManifestModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentManifestId = _data["documentManifestId"];
            this.creationDate = _data["creationDate"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            if (Array.isArray(_data["authors"])) {
                this.authors = [] as any;
                for (let item of _data["authors"])
                    this.authors!.push(ReferenceModel.fromJS(item));
            }
            this.source = _data["source"];
            if (Array.isArray(_data["documentReferences"])) {
                this.documentReferences = [] as any;
                for (let item of _data["documentReferences"])
                    this.documentReferences!.push(ReferenceModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): DocumentManifestModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentManifestModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentManifestId"] = this.documentManifestId;
        data["creationDate"] = this.creationDate;
        data["status"] = this.status;
        data["type"] = this.type;
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        if (Array.isArray(this.authors)) {
            data["authors"] = [];
            for (let item of this.authors)
                data["authors"].push(item.toJSON());
        }
        data["source"] = this.source;
        if (Array.isArray(this.documentReferences)) {
            data["documentReferences"] = [];
            for (let item of this.documentReferences)
                data["documentReferences"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDocumentManifestModel extends IResourceModel {
    documentManifestId?: string | undefined;
    creationDate?: string | undefined;
    status?: DocumentReferenceStatus | undefined;
    type?: string | undefined;
    subject?: ReferenceModel | undefined;
    authors?: ReferenceModel[] | undefined;
    source?: string | undefined;
    documentReferences?: ReferenceModel[] | undefined;
}

export enum DocumentReferenceStatus {
    Current = 0,
    Superseded = 1,
    EnteredInError = 2,
}

export class DocumentReferenceSearchResultModel implements IDocumentReferenceSearchResultModel {
    documentReferences?: DocumentReferenceModel[] | undefined;

    constructor(data?: IDocumentReferenceSearchResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["documentReferences"])) {
                this.documentReferences = [] as any;
                for (let item of _data["documentReferences"])
                    this.documentReferences!.push(DocumentReferenceModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentReferenceSearchResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentReferenceSearchResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.documentReferences)) {
            data["documentReferences"] = [];
            for (let item of this.documentReferences)
                data["documentReferences"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDocumentReferenceSearchResultModel {
    documentReferences?: DocumentReferenceModel[] | undefined;
}

export class DocumentReferenceModel extends ResourceModel implements IDocumentReferenceModel {
    documentReferenceId?: string | undefined;
    creationDate?: string | undefined;
    status?: DocumentReferenceStatus | undefined;
    type?: string | undefined;
    documentClass?: string | undefined;
    subject?: ReferenceModel | undefined;
    authors?: ReferenceModel[] | undefined;
    relatedDocumentReferences?: ReferenceModel[] | undefined;
    description?: string | undefined;
    confidentiality?: Confidentiality | undefined;
    attachments?: AttachmentModel[] | undefined;
    context?: DocumentReferenceContext | undefined;

    constructor(data?: IDocumentReferenceModel) {
        super(data);
        this._discriminator = "DocumentReferenceModel";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentReferenceId = _data["documentReferenceId"];
            this.creationDate = _data["creationDate"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.documentClass = _data["documentClass"];
            this.subject = _data["subject"] ? ReferenceModel.fromJS(_data["subject"]) : <any>undefined;
            if (Array.isArray(_data["authors"])) {
                this.authors = [] as any;
                for (let item of _data["authors"])
                    this.authors!.push(ReferenceModel.fromJS(item));
            }
            if (Array.isArray(_data["relatedDocumentReferences"])) {
                this.relatedDocumentReferences = [] as any;
                for (let item of _data["relatedDocumentReferences"])
                    this.relatedDocumentReferences!.push(ReferenceModel.fromJS(item));
            }
            this.description = _data["description"];
            this.confidentiality = _data["confidentiality"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentModel.fromJS(item));
            }
            this.context = _data["context"] ? DocumentReferenceContext.fromJS(_data["context"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): DocumentReferenceModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentReferenceModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentReferenceId"] = this.documentReferenceId;
        data["creationDate"] = this.creationDate;
        data["status"] = this.status;
        data["type"] = this.type;
        data["documentClass"] = this.documentClass;
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        if (Array.isArray(this.authors)) {
            data["authors"] = [];
            for (let item of this.authors)
                data["authors"].push(item.toJSON());
        }
        if (Array.isArray(this.relatedDocumentReferences)) {
            data["relatedDocumentReferences"] = [];
            for (let item of this.relatedDocumentReferences)
                data["relatedDocumentReferences"].push(item.toJSON());
        }
        data["description"] = this.description;
        data["confidentiality"] = this.confidentiality;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["context"] = this.context ? this.context.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IDocumentReferenceModel extends IResourceModel {
    documentReferenceId?: string | undefined;
    creationDate?: string | undefined;
    status?: DocumentReferenceStatus | undefined;
    type?: string | undefined;
    documentClass?: string | undefined;
    subject?: ReferenceModel | undefined;
    authors?: ReferenceModel[] | undefined;
    relatedDocumentReferences?: ReferenceModel[] | undefined;
    description?: string | undefined;
    confidentiality?: Confidentiality | undefined;
    attachments?: AttachmentModel[] | undefined;
    context?: DocumentReferenceContext | undefined;
}

export enum Confidentiality {
    Low = 0,
    Moderate = 1,
    Normal = 2,
    Restricted = 3,
    Unrestricted = 4,
    VeryRestricted = 5,
}

export class DocumentReferenceContext implements IDocumentReferenceContext {
    encounter?: ReferenceModel | undefined;
    event?: string | undefined;
    period?: PeriodModel | undefined;
    facilityType?: string | undefined;
    practiceSetting?: string | undefined;
    patient?: ReferenceModel | undefined;
    related?: DocumentReferenceContextRelated[] | undefined;

    constructor(data?: IDocumentReferenceContext) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.encounter = _data["encounter"] ? ReferenceModel.fromJS(_data["encounter"]) : <any>undefined;
            this.event = _data["event"];
            this.period = _data["period"] ? PeriodModel.fromJS(_data["period"]) : <any>undefined;
            this.facilityType = _data["facilityType"];
            this.practiceSetting = _data["practiceSetting"];
            this.patient = _data["patient"] ? ReferenceModel.fromJS(_data["patient"]) : <any>undefined;
            if (Array.isArray(_data["related"])) {
                this.related = [] as any;
                for (let item of _data["related"])
                    this.related!.push(DocumentReferenceContextRelated.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentReferenceContext {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentReferenceContext();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["encounter"] = this.encounter ? this.encounter.toJSON() : <any>undefined;
        data["event"] = this.event;
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        data["facilityType"] = this.facilityType;
        data["practiceSetting"] = this.practiceSetting;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        if (Array.isArray(this.related)) {
            data["related"] = [];
            for (let item of this.related)
                data["related"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDocumentReferenceContext {
    encounter?: ReferenceModel | undefined;
    event?: string | undefined;
    period?: PeriodModel | undefined;
    facilityType?: string | undefined;
    practiceSetting?: string | undefined;
    patient?: ReferenceModel | undefined;
    related?: DocumentReferenceContextRelated[] | undefined;
}

export class DocumentReferenceContextRelated implements IDocumentReferenceContextRelated {
    id?: string | undefined;
    reference?: ReferenceModel | undefined;

    constructor(data?: IDocumentReferenceContextRelated) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reference = _data["reference"] ? ReferenceModel.fromJS(_data["reference"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DocumentReferenceContextRelated {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentReferenceContextRelated();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reference"] = this.reference ? this.reference.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDocumentReferenceContextRelated {
    id?: string | undefined;
    reference?: ReferenceModel | undefined;
}

export class SendPdfaDocumentSetModel implements ISendPdfaDocumentSetModel {
    patient?: SendPdfaDocumentPatientModel | undefined;
    subject?: string | undefined;
    status?: DocumentReferenceStatus2;
    source?: string | undefined;
    receiverFirstName?: string | undefined;
    receiverInitials?: string | undefined;
    receiverLastName?: string | undefined;
    documentSetDate?: Date;
    documentReferences?: SendPdfaDocumentReferenceModel[] | undefined;

    constructor(data?: ISendPdfaDocumentSetModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patient = _data["patient"] ? SendPdfaDocumentPatientModel.fromJS(_data["patient"]) : <any>undefined;
            this.subject = _data["subject"];
            this.status = _data["status"];
            this.source = _data["source"];
            this.receiverFirstName = _data["receiverFirstName"];
            this.receiverInitials = _data["receiverInitials"];
            this.receiverLastName = _data["receiverLastName"];
            this.documentSetDate = _data["documentSetDate"] ? new Date(_data["documentSetDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["documentReferences"])) {
                this.documentReferences = [] as any;
                for (let item of _data["documentReferences"])
                    this.documentReferences!.push(SendPdfaDocumentReferenceModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SendPdfaDocumentSetModel {
        data = typeof data === 'object' ? data : {};
        let result = new SendPdfaDocumentSetModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["subject"] = this.subject;
        data["status"] = this.status;
        data["source"] = this.source;
        data["receiverFirstName"] = this.receiverFirstName;
        data["receiverInitials"] = this.receiverInitials;
        data["receiverLastName"] = this.receiverLastName;
        data["documentSetDate"] = this.documentSetDate ? this.documentSetDate.toISOString() : <any>undefined;
        if (Array.isArray(this.documentReferences)) {
            data["documentReferences"] = [];
            for (let item of this.documentReferences)
                data["documentReferences"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISendPdfaDocumentSetModel {
    patient?: SendPdfaDocumentPatientModel | undefined;
    subject?: string | undefined;
    status?: DocumentReferenceStatus2;
    source?: string | undefined;
    receiverFirstName?: string | undefined;
    receiverInitials?: string | undefined;
    receiverLastName?: string | undefined;
    documentSetDate?: Date;
    documentReferences?: SendPdfaDocumentReferenceModel[] | undefined;
}

export class SendPdfaDocumentPatientModel implements ISendPdfaDocumentPatientModel {
    firstName?: string | undefined;
    initials?: string | undefined;
    lastName?: string | undefined;
    gender?: Gender;
    dateOfBirth?: Date;
    street?: string | undefined;
    houseNumber?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;

    constructor(data?: ISendPdfaDocumentPatientModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.initials = _data["initials"];
            this.lastName = _data["lastName"];
            this.gender = _data["gender"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.street = _data["street"];
            this.houseNumber = _data["houseNumber"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
        }
    }

    static fromJS(data: any): SendPdfaDocumentPatientModel {
        data = typeof data === 'object' ? data : {};
        let result = new SendPdfaDocumentPatientModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["initials"] = this.initials;
        data["lastName"] = this.lastName;
        data["gender"] = this.gender;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["street"] = this.street;
        data["houseNumber"] = this.houseNumber;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        return data;
    }
}

export interface ISendPdfaDocumentPatientModel {
    firstName?: string | undefined;
    initials?: string | undefined;
    lastName?: string | undefined;
    gender?: Gender;
    dateOfBirth?: Date;
    street?: string | undefined;
    houseNumber?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
}

export enum DocumentReferenceStatus2 {
    Current = 0,
    Superseded = 1,
    EnteredInError = 2,
}

export class SendPdfaDocumentReferenceModel implements ISendPdfaDocumentReferenceModel {
    status?: DocumentReferenceStatus2;
    subject?: string | undefined;
    authorFirstName?: string | undefined;
    authorInitials?: string | undefined;
    authorLastName?: string | undefined;
    documentName?: string | undefined;
    documentDate?: Date;
    documentBase64?: string | undefined;

    constructor(data?: ISendPdfaDocumentReferenceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.subject = _data["subject"];
            this.authorFirstName = _data["authorFirstName"];
            this.authorInitials = _data["authorInitials"];
            this.authorLastName = _data["authorLastName"];
            this.documentName = _data["documentName"];
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : <any>undefined;
            this.documentBase64 = _data["documentBase64"];
        }
    }

    static fromJS(data: any): SendPdfaDocumentReferenceModel {
        data = typeof data === 'object' ? data : {};
        let result = new SendPdfaDocumentReferenceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["subject"] = this.subject;
        data["authorFirstName"] = this.authorFirstName;
        data["authorInitials"] = this.authorInitials;
        data["authorLastName"] = this.authorLastName;
        data["documentName"] = this.documentName;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : <any>undefined;
        data["documentBase64"] = this.documentBase64;
        return data;
    }
}

export interface ISendPdfaDocumentReferenceModel {
    status?: DocumentReferenceStatus2;
    subject?: string | undefined;
    authorFirstName?: string | undefined;
    authorInitials?: string | undefined;
    authorLastName?: string | undefined;
    documentName?: string | undefined;
    documentDate?: Date;
    documentBase64?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
